export const en = {
  "loading": "Loading...",
  "save": "Save",
  "cancel": "Cancel", 
  "editDates": "Edit Dates",
  "projectStartDate": "Project Start Date",
  "projectEndDate": "Project End Date",
  "editDatesNotAvailable": "Date editing not available",
  "startDateNotEditable": "Start date editing not available",
  "endDateNotEditable": "End date editing not available", 
  "startDateReadOnly": "Start date is read-only",
  "endDateReadOnly": "End date is read-only",
  "siteProjectStartDate": "Project Start Date",
  "siteProjectEndDate": "Project End Date",
  "jobDetailsFromQuote": "Job Details From Quote",
  "noJobDetailsAvailable": "No job details available",
  "jobNotFromQuote": "This job may not have been created from a quote, or no job details were specified in the original quote.",
  "errorLoadingJobDetails": "Error Loading Job Details",
  "serviceAgreementTitle": "Service Agreement",
  "serviceAgreementDescription": "Configure this job as a recurring service agreement with assigned team member",
  "serviceAgreementMakeRecurring": "Make this a recurring service agreement",
  "serviceAgreementServiceFrequency": "Service Frequency",
  "serviceAgreementServiceSchedule": "Service Schedule",
  "serviceAgreementDaysOfWeek": "Days of the Week",
  "frequenciesDaily": "Daily",
  "frequenciesWeekly": "Weekly",
  "frequenciesBiweekly": "Biweekly",
  "frequenciesMonthly": "Monthly",
  "frequenciesQuarterly": "Quarterly",
  "frequenciesAnnually": "Annually",
  "daysOfWeekMon": "Mon",
  "daysOfWeekTue": "Tue", 
  "daysOfWeekWed": "Wed",
  "daysOfWeekThu": "Thu",
  "daysOfWeekFri": "Fri",
  "daysOfWeekSat": "Sat",
  "daysOfWeekSun": "Sun",
  "daysOfWeekMonday": "Monday",
  "daysOfWeekTuesday": "Tuesday",
  "daysOfWeekWednesday": "Wednesday", 
  "daysOfWeekThursday": "Thursday",
  "daysOfWeekFriday": "Friday",
  "daysOfWeekSaturday": "Saturday",
  "daysOfWeekSunday": "Sunday",
  "nav": {
    "overview": "Overview",
    "reports": "Reports",
    "dashboard": "Dashboard",
    "jobs": "Jobs",
    "quotes": "Quotes",
    "activity": "Activity",
    "customers": "Customers",
    "map": "Map",
    "calendar": "Calendar",
    "inventory": "Product inventory",
    "suppliers": "Suppliers",
    "billing": "Billing",
    "settings": "Settings",
    "timeRequests": "Time Request",
    "timeRegistration": "Time Registration",
    "admin": "Admin",
    "adminPage": "Admin Page",
    "serviceAgreements": "Service Agreements"
  },
  "invoices": {
    "title": "Invoices",
    "createNew": "Create New Invoice",
    "invoice": "Invoice",
    "issueDate": "Issue Date",
    "dueDate": "Due Date",
    "status": "Status",
    "amount": "Amount",
    "view": "View",
    "noInvoices": "No Invoices Yet",
    "createFirstInvoice": "Create your first invoice to start billing for this job",
    "confirmCreate": "Create New Invoice",
    "confirmCreateDescription": "This will create a new invoice for this job. You can edit the details before sending it to the customer.",
    "importantNote": "Important Note",
    "includesUnbilled": "This invoice will include all unbilled items associated with this job.",
    "cancel": "Cancel",
    "creating": "Creating...",
    "createInvoice": "Create Invoice",
    "deleteInvoice": "Delete Invoice",
    "deleteWarning": "Are you sure you want to delete this draft invoice? This action cannot be undone.",
    "invoiceNumber": "Invoice Number",
    "date": "Date",
    "totalAmount": "Total Amount",
    "delete": "Delete",
    "deleting": "Deleting...",
    "onlyDraftDelete": "Only draft invoices can be deleted",
    "searchInvoices": "Search invoices...",
    "viewAndManageAll": "View and manage all your invoices",
    "allInvoices": "All Invoices",
    "draftInvoices": "Draft Invoices",
    "sentInvoices": "Sent Invoices",
    "paidInvoices": "Paid Invoices",
    "overdueInvoices": "Overdue Invoices",
    "allInvoicesWithStatus": "All invoices with \"{{status}}\" status",
    "overdueDescription": "Invoices that are past their due date",
    "customer": "Customer",
    "job": "Job",
    "organization": "Organization",
    "remaining": "Remaining",
    "viewDetails": "View details",
    "noInvoicesFound": "No invoices found",
    "noInvoicesMatchSearch": "No invoices match your search for \"{{searchTerm}}\"",
    "noInvoicesYet": "There are no {{status}} invoices yet",
    "unnamedCustomer": "Unnamed Customer",
    "draft": "Draft",
    "sent": "Sent",
    "paid": "Paid",
    "overdue": "Overdue",
    "all": "All",
    "drafts": "Drafts",
    "create": {
      "jobSelection": "Job Selection",
      "jobSelectionDesc": "Select the job for this invoice",
      "selectJob": "Select a job",
      "jobDetails": "Job Details",
      "customerInformation": "Customer Information",
      "customerInformationDesc": "Customer details for the invoice",
      "selectCustomer": "Select Customer (Optional)",
      "selectCustomerPlaceholder": "Select a customer or enter manually",
      "selectOrEnterCustomer": "Select or enter customer details",
      "clearSelection": "Clear selection",
      "customerName": "Customer Name",
      "customerNamePlaceholder": "Enter customer name",
      "customerEmail": "Customer Email",
      "customerEmailPlaceholder": "customer@example.com",
      "customerAddress": "Customer Address",
      "customerAddressPlaceholder": "Enter customer address",
      "invoiceDetails": "Invoice Details",
      "invoiceDetailsDesc": "Set invoice dates and additional information",
      "notes": "Notes",
      "notesPlaceholder": "Additional notes for the invoice",
      "invoiceItems": "Invoice Items",
      "invoiceItemsDesc": "Items to be included in the invoice",
      "addItem": "Add Item",
      "noItemsYet": "No items added yet. Select a job to auto-populate items or add them manually.",
      "description": "Description",
      "descriptionPlaceholder": "Item description",
      "quantity": "Quantity",
      "rate": "Rate",
      "total": "Total",
      "required": "*"
    },
    "detail": {
      "backToInvoices": "Back to Invoices",
      "sendEmail": "Send Email",
      "downloadPdf": "Download PDF",
      "viewAndManageDetails": "View and manage invoice details",
      "viewAndManageDetailsWithBranding": "View and manage invoice details with company branding",
      "sendInvoice": "Send Invoice",
      "setFixedCost": "Set Fixed Cost",
      "markAsPaid": "Mark as Paid",
      "recordPayment": "Record Payment",
      "delete": "Delete",
      "status": "Status",
      "invoiceDetails": "Invoice Details",
      "pdfPreview": "PDF Preview",
      "payments": "Payments",
      "settings": "Settings",
      "customerInformation": "Customer Information",
      "invoiceItems": "Invoice Items",
      "item": "Item",
      "qty": "Qty",
      "rate": "Rate",
      "hours": "Hours",
      "workPerformed": "Work Performed",
      "customerText": "Customer Text",
      "customerTextTitle": "Customer Text",
      "customerTextPlaceholder": "Enter special instructions or notes for the customer...",
      "customerTextDescription": "This text will be displayed on the invoice and visible to the customer.",
      "noCustomerText": "No customer text added",
      "noCustomerTextDescription": "Click Edit to add special instructions or notes for the customer.",
      "customerTextCannotBeModified": "Customer text cannot be modified for paid invoices.",
      "customerTextTemplates": {
        "title": "Customer Text Templates",
        "description": "Manage reusable text templates for your invoices.",
        "refresh": "Refresh templates",
        "createTemplate": "Create Template",
        "loading": "Loading templates...",
        "noTemplates": "No templates found",
        "createFirstTemplate": "Create your first template to get started.",
        "isDefault": "Default",
        "useTemplate": "Use Template",
        "editTemplate": "Edit Template",
        "templateName": "Template Name",
        "templateNamePlaceholder": "e.g., Standard Terms",
        "templateContent": "Template Content",
        "templateContentPlaceholder": "Enter the text content...",
        "charactersCount": "characters",
        "setAsDefault": "Set as default template",
        "creating": "Creating...",
        "failedToLoad": "Failed to load templates",
        "nameRequired": "Template name and content are required",
        "maxTemplatesReached": "Maximum number of templates reached (3)",
        "templateCreated": "Template created successfully",
        "failedToCreate": "Failed to create template",
        "templateUpdated": "Template updated successfully",
        "failedToUpdate": "Failed to update template",
        "templateDeleted": "Template deleted successfully",
        "failedToDelete": "Failed to delete template",
        "deleteConfirmation": {
          "title": "Delete Template",
          "message": "Are you sure you want to delete the template \"{{templateName}}\"?",
          "warning": "This action cannot be undone.",
          "cancelButton": "Cancel",
          "confirmButton": "Delete"
        }
      },
      "templates": "Templates",
      "notes": "Notes",
      "invoiceSummary": "Invoice Summary",
      "issueDate": "Issue Date",
      "dueDate": "Due Date",
      "subtotal": "Subtotal",
      "tax": "Tax",
      "total": "Total",
      "paid": "Paid",
      "balanceDue": "Balance Due",
      "paymentHistory": "Payment History",
      "setFixedCostOverride": "Set Fixed Cost Override",
      "replaceAllItems": "Replace all current invoice items with a single fixed cost. This will create a simplified invoice with one line item at your specified amount.",
      "fixedCostLabel": "Fixed Cost Amount (DKK)",
      "fixedCostDescription": "Description (Optional)",
      "describeFixedCost": "Describe what this fixed cost covers",
      "applyFixedCost": "Apply Fixed Cost",
      "applying": "Applying...",
      "cancel": "Cancel",
      "unknownCustomer": "Unknown Customer",
      "paymentProgress": "Payment Progress",
      "goToPayments": "Go to Payments",
      "noPaymentsRecorded": "No payments recorded yet",
      "goToPaymentsTab": "Go to the \"Payments\" tab to record a payment",
      "invoiceFullyPaid": "Invoice Fully Paid",
      "invoiceFullyPaidDesc": "This invoice has been fully paid by the customer.",
      "fullBalance": "Full Balance",
      "maximum": "Maximum:",
      "remainingAfterPayment": "Remaining after payment:",
      "selectPaymentMethodTab": "Select payment method",
      "optionalField": "Optional",
      "accountEndingPlaceholder": "Account ending in... or bank name",
      "referenceNumberGeneral": "Reference Number",
      "checkNumber": "Check number",
      "wireReference": "Wire reference",
      "transactionId": "Transaction ID",
      "referenceNumberPlaceholder": "Reference number",
      "additionalNotesPlaceholder": "Additional notes about this payment",
      "currentBalance": "Current Balance",
      "newBalance": "New Balance",
      "invoiceWillBeMarkedPaid": "Invoice will be marked as PAID",
      "addingPayment": "Adding Payment...",
      "addPayment": "Add Payment",
      "clearForm": "Clear Form",
      "payment": "payment",
      "method": "Method:",
      "reference": "Reference:",
      "account": "Account:",
      "note": "Note:",
      "noPaymentsRecordedTitle": "No Payments Recorded",
      "noPaymentsRecordedDesc": "No payments have been recorded for this invoice yet.",
      "useFormToRecord": "Use the form on the left to record your first payment.",
      "paymentStatistics": "Payment Statistics",
      "totalPaid": "Total Paid",
      "paymentMethodsUsed": "Payment Methods Used:",
      "invoiceSettings": "Invoice Settings",
      "paymentDetails": "Payment Details",
      "recordPaymentDesc": "Record a payment received for this invoice",
      "paymentAmount": "Payment Amount",
      "paymentMethod": "Payment Method",
      "paymentDate": "Payment Date",
      "paymentReference": "Payment Reference (Optional)",
      "paymentNotes": "Payment Notes (Optional)",
      "bankTransfer": "Bank Transfer",
      "cash": "Cash",
      "check": "Check",
      "creditCard": "Credit Card",
      "other": "Other",
      "recordPaymentButton": "Record Payment",
      "recording": "Recording...",
      "invoicePreview": "Invoice Preview",
      "downloadPdf": "Download PDF",
      "previewInvoice": "Preview Invoice",
      "loading": "Loading...",
      "close": "Close",
      "taxSettings": "Tax Settings",
      "enableTax": "Enable Tax",
      "taxRate": "Tax Rate (%)",
      "save": "Save",
      "saving": "Saving...",
      "draftInvoice": "Draft Invoice",
      "edit": "Edit",
      "saveChanges": "Save Changes",
      "workPerformed": "Work Performed",
      "fixedCostDialog": {
        "title": "Set Fixed Cost Override",
        "description": "Replace all current invoice items with a single fixed cost. This will create a simplified invoice with one line item at your specified amount.",
        "amount": "Fixed Cost Amount (DKK)",
        "amountPlaceholder": "0.00",
        "costDescription": "Description (Optional)",
        "descriptionPlaceholder": "Describe what this fixed cost covers",
        "cancel": "Cancel",
        "applyFixedCost": "Apply Fixed Cost",
        "applying": "Applying...",
        "costBreakdownPreview": "Cost Breakdown Preview",
        "fixedCost": "Fixed Cost:",
        "tax": "Tax",
        "total": "Total:",
        "currentTotal": "Current total:"
      },
      "previewModal": {
        "title": "Invoice Preview",
        "description": "Preview how your invoice will look when printed or downloaded as PDF",
        "closePreview": "Close Preview",
        "print": "Print",
        "downloadPdf": "Download PDF",
        "livePreview": "Live preview of invoice",
        "exit": "Exit",
        "fullscreen": "Fullscreen",
        "previewError": "Preview Error",
        "exitFullscreen": "Exit Fullscreen",
        "generatePdfError": "Failed to generate PDF",
        "generatingPdf": "Generating PDF... This may take a moment.",
        "downloadSuccess": "Invoice PDF downloaded successfully!",
        "downloadError": "Failed to download PDF:",
        "printError": "Please allow pop-ups to print the invoice",
        "previewLoadError": "Failed to load PDF preview. Please try refreshing or downloading the PDF directly.",
        "unknownError": "Unknown error",
        "invoice": "Invoice"
      },
      "paymentDialog": {
        "title": "Add Payment Record",
        "description": "Record a payment received from the client. This will update the invoice balance and payment history.",
        "paymentAmount": "Payment Amount",
        "remainingBalance": "Remaining Balance",
        "paymentMethod": "Payment Method",
        "selectPaymentMethod": "Select payment method",
        "paymentDate": "Payment Date",
        "referenceNumber": "Reference Number",
        "referenceNumberPlaceholder": "Transaction ID, Check number, etc.",
        "bankAccount": "Bank Account",
        "bankAccountPlaceholder": "Account ending in...",
        "notes": "Notes",
        "notesPlaceholder": "Additional notes about this payment",
        "optional": "Optional",
        "paymentSummary": "Payment Summary",
        "newBalance": "New Balance",
        "invoiceWillBePaid": "Invoice will be marked as PAID",
        "cancel": "Cancel",
        "addPayment": "Add Payment",
        "addingPayment": "Adding Payment..."
      },
      "tabs": {
        "payments": {
          "recordNewPayment": "Record New Payment",
          "balance": "Balance",
          "paymentPrefilledNotice": "The payment amount has been pre-filled with the full remaining balance. You can adjust it as needed.",
          "paymentMethods": {
            "bankTransfer": "Bank Transfer",
            "cash": "Cash",
            "creditCard": "Credit Card",
            "debitCard": "Debit Card",
            "check": "Check",
            "paypal": "PayPal",
            "mobilepay": "MobilePay",
            "wireTransfer": "Wire Transfer",
            "cryptocurrency": "Cryptocurrency",
            "other": "Other"
          }
        }
      },
      "settingsTab": {
        "invoiceSettings": "Invoice Settings",
        "invoiceStatus": "Invoice Status",
        "currentStatus": "Current Status",
        "selectStatus": "Select status",
        "statusChangeDesc": "Change the status of this invoice. This will be visible to your team.",
        "statusDescriptions": {
          "cancelled": "Cancelled",
          "notSentToCustomer": "Not sent to customer",
          "invoiceSentToCustomer": "Invoice sent to customer",
          "fullyPaidByCustomer": "Fully paid by customer",
          "paymentDeadlinePassed": "Payment deadline has passed",
          "invoiceCancelledShort": "Invoice cancelled",
          "draftDesc": "Draft invoices are only visible to your team and not sent to customers.",
          "sentDesc": "Sent status indicates the invoice has been delivered to the customer and payment is expected.",
          "paidDesc": "Paid status indicates this invoice has been fully settled by the customer.",
          "overdueDesc": "Overdue status indicates payment deadline has passed and you may need to follow up with the customer.",
          "cancelledDesc": "Cancelled status indicates this invoice is no longer valid and will not be counted in reports."
        },
        "taxSettings": "Tax Settings",
        "enableTax": "Enable Tax",
        "applyTaxToInvoice": "Apply tax to this invoice",
        "taxRate": "Tax Rate (%)",
        "enterTaxRate": "Enter tax rate",
        "commonTaxRates": "Common rates: 25% (Denmark), 20% (UK), 19% (Germany)",
        "currencySettings": "Currency Settings",
        "currency": "Currency",
        "selectCurrency": "Select currency",
        "currencyUpdateDesc": "This will update all amounts displayed in the invoice",
        "previewChanges": "Preview Changes",
        "newTotal": "New Total",
        "invoiceSettingsUpdate": "Invoice Settings Update",
        "changesWillRecalculate": "Changes will recalculate all invoice totals and amounts",
        "updating": "Updating...",
        "updateSettings": "Update Settings",
        "settingsCannotBeModified": "Settings cannot be modified for paid invoices"
      },
      "activityLog": {
        "title": "Activity Log",
        "loading": "Loading activities...",
        "noActivity": "No activity recorded",
        "noActivityDesc": "Activity will appear here when actions are performed on this invoice",
        "by": "By {{userName}}",
        "actions": {
          "invoiceSent": "Invoice Sent",
          "invoiceCreated": "Invoice Created",
          "statusChanged": "Status Changed",
          "paymentRecorded": "Payment Recorded"
        }
      }
    }
  },
  "customers": {
    "title": "Customers",
    "addNewCustomer": "Add New Customer",
    "refreshCustomerList": "Refresh customer list",
    "searchCustomers": "Search customers...",
    "allCustomers": "All Customers",
    "manageCustomerDatabase": "Manage your customer database",
    "companyName": "Company Name",
    "address": "Address",
    "phone": "Phone",
    "email": "Email",
    "created": "Created",
    "sites": "Sites",
    "actions": "Actions",
    "addSite": "Add Site",
    "addNewSiteForCustomer": "Add new site for this customer",
    "deleteCustomer": "Delete customer",
    "noCustomersFound": "No customers found. Try adjusting your search or add a new customer.",
    "areYouSure": "Are you sure?",
    "deleteConfirmation": "This action will permanently delete {{customerName}}.",
    "deleteWarning": "Warning: This customer has {{count}} {{sitePlural}} associated with it.",
    "siteSingular": "site",
    "sitePlural": "sites",
    "cancel": "Cancel",
    "delete": "Delete",
    "deleting": "Deleting...",
    "customerDeleted": "Customer deleted",
    "customerDeletedSuccess": "{{customerName}} has been successfully removed.",
    "error": "Error",
    "deleteCustomerError": "Failed to delete the customer. Please try again.",
    "offerAlreadyAcceptedError": "This offer has already been accepted by the customer. Cannot send a new offer link.",
    "createNew": "Create New Customer",
    "backToCustomers": "Back to Customers",
    "companyNameRequired": "Company Name *",
    "addressRequired": "Address *",
    "phoneNumber": "Phone Number",
    "cvrNumber": "CVR Number",
    "creating": "Creating...",
    "createCustomer": "Create Customer",
    "customerCreatedSuccess": "Customer created successfully",
    "createCustomerError": "Failed to create customer",
    "editCustomer": "Edit Customer",
    "customerDetails": "Customer Details",
    "quotes": "Quotes",
    "jobs": "Jobs",
    "invoices": "Invoices",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "customerUpdatedSuccess": "Customer updated successfully",
    "updateCustomerError": "Failed to update customer",
    "updated": "Updated",
    "viewQuote": "View Quote",
    "viewJob": "View Job",
    "viewInvoice": "View Invoice",
    "noQuotesFound": "No quotes found for this customer",
    "noJobsFound": "No jobs found for this customer",
    "noInvoicesFound": "No invoices found for this customer",
    "noSitesFound": "No sites added for this customer",
    "addNewSite": "Add New Site",
    "addNewSiteDescription": "Add a new site location for this customer",
    "siteName": "Site Name",
    "siteNameRequired": "Site Name *",
    "contactName": "Contact Name",
    "contact": "Contact",
    "addingSite": "Adding Site...",
    "siteAddedSuccess": "Site added successfully",
    "addSiteError": "Failed to add site",
    "customerSites": "Customer Sites",
    "name": "Name",
    "edit": "Edit",
    "deleteSiteConfirm": "Are you sure you want to delete this site?",
    "siteDeletedSuccess": "Site deleted successfully",
    "deleteSiteError": "Failed to delete site",
    "updatingSite": "Saving...",
    "save": "Save",
    "siteUpdatedSuccess": "Site updated successfully",
    "updateSiteError": "Failed to update site",
    "enterSiteName": "Enter site name",
    "contactPersonName": "Contact person name",
    "contactPhoneNumber": "Contact phone number",
    "contactEmailAddress": "Contact email address",
    "invoiceNumber": "Invoice #",
    "amount": "Amount",
    "dueDate": "Due Date",
    // Settings dropdown keys
    "settings": "Settings",
    "customerManagementOptions": "Customer management options",
    "exportToCSV": "Export to CSV",
    "exporting": "Exporting...",
    "selectMultiple": "Select Multiple",
    // Export and selection keys
    "noData": "No Data",
    "noCustomersToExport": "No customers available to export.",
    "exportSuccessful": "Export Successful",
    "exportedCustomers": "Exported {{count}} customer{{count, plural, one {} other {s}}} to {{filename}}",
    "exportFailed": "Export Failed",
    "exportFailedDescription": "Failed to export customers. Please try again.",
    "noSelection": "No Selection",
    "pleaseSelectCustomersToExport": "Please select customers to export.",
    "selectedCustomersNotFound": "Selected customers not found.",
    "exportedSelectedCustomers": "Exported {{count}} selected customer{{count, plural, one {} other {s}}} to {{filename}}",
    "exportSelectedFailedDescription": "Failed to export selected customers. Please try again.",
    "deselectAll": "Deselect All",
    "selectAll": "Select All",
    "exportSelected": "Export Selected ({{count}})",
    "deleteSelected": "Delete Selected ({{count}})",
    "noCustomersMatchSearch": "No customers match your search.",
    "customersTotal": "{{count}} {{customerWord}} total",
    "customerSingular": "customer",
    "customerPlural": "customers",
    "status": "Status",
    // Bulk Upload translations
    "bulkUpload": {
      "title": "Bulk Upload Customers",
      "menuItem": "Import from CSV",
      "description": "Upload a CSV file to add up to {{max}} customers at once.",
      "emptyStateDescription": "Get started by importing customers from a CSV file or adding them one by one.",
      "importFromCSV": "Import from CSV",
      "dragAndDrop": "Drag and drop your CSV file here",
      "orClickToSelect": "or click to select a file",
      "selectFile": "Select CSV File",
      "csvFormat": "CSV File Format",
      "csvFormatDescription": "Your CSV file should include a header row with the following columns:",
      "requiredColumns": "Required columns",
      "optionalColumns": "Optional columns",
      "downloadTemplate": "Download Template",
      "noDataRows": "CSV file contains no data rows.",
      "missingCompanyNameColumn": "CSV file is missing 'Company Name' column.",
      "missingAddressColumn": "CSV file is missing 'Address' column.",
      "noValidRows": "No valid customer data found in CSV file.",
      "companyNameRequired": "Company name is required",
      "addressRequired": "Address is required",
      "invalidEmail": "Invalid email format",
      "invalidFileType": "Invalid File Type",
      "pleaseUploadCSV": "Please upload a CSV file.",
      "fileTooLarge": "File Too Large",
      "maxFileSize": "Maximum file size is 5MB.",
      "tooManyRows": "Too Many Rows",
      "maxCustomersAllowed": "Maximum {{max}} customers allowed per upload.",
      "parseError": "Parse Error",
      "invalidCSVFormat": "Invalid CSV format. Please check your file.",
      "valid": "valid",
      "invalid": "invalid",
      "invalidRowsWarning": "{{count}} row(s) contain errors and will be skipped during upload.",
      "noValidCustomers": "No Valid Customers",
      "fixErrorsFirst": "Please fix the errors or remove invalid rows.",
      "uploadSuccessful": "Upload Successful",
      "customersCreated": "Successfully created {{count}} customer(s).",
      "uploadFailed": "Upload Failed",
      "unknownError": "An unknown error occurred.",
      "selectDifferentFile": "Select Different File",
      "uploading": "Uploading...",
      "uploadCustomers": "Upload {{count}} Customer(s)",
      "uploadComplete": "Upload Complete",
      "successSummary": "Created {{created}} customer(s). {{failed}} failed.",
      "noCustomersCreated": "No customers could be created.",
      "errors": "Errors",
      "done": "Done"
    }
  },
  "addressAutocomplete": {
    "startTypingAddress": "Start typing an address...",
    "enterAddressManually": "Enter address manually...",
    "autocompleteUnavailable": "Address autocomplete is unavailable - please enter address manually"
  },
  "activeJob": {
    "addNewCustomer": "Add New Customer",
    "customerInformation": "Customer Information",
    "editCustomer": "Edit Customer",
    "linkCustomer": "Link Customer",
    "saveChanges": "Save Changes",
    "cancel": "Cancel",
    "companyNameRequired": "Company Name *",
    "email": "Email",
    "phone": "Phone",
    "cvrNumber": "CVR Number",
    "addressRequired": "Address *",
    "companyName": "Company Name",
    "address": "Address",
    "noCustomerInformation": "No customer information available",
    "customerNotAvailable": "Customer information is not available for this job",
    "changeCustomer": "Change Customer",
    "selectCustomer": "Select a customer...",
    "selectCustomerLabel": "Select Customer",
    "updatingCustomer": "Updating customer...",
    "noCustomersAvailable": "No customers available. Create a customer first.",
    "unknownCustomer": "Unknown Customer",
    "companyNamePlaceholder": "Enter company name",
    "emailPlaceholder": "company@example.com",
    "phonePlaceholder": "+45 12 34 56 78",
    "cvrPlaceholder": "12345678",
    "projectTimeline": "Project Timeline",
    "siteInformation": "Site Information",
    "costs": "Costs",
    "assignedTeamMembers": "Assigned Team Members",
    "member": "member",
    "members": "members",
    "assigned": "assigned",
    "unknownMember": "Unknown Member",
    "assignedOn": "Assigned on",
    "removeTeamMember": "Remove team member",
    "noTeamMembersAssigned": "No team members assigned yet",
    "addTeamMember": "Add Team Member",
    "selectToAdd": "Select a member to add...",
    "noTeamMembersAvailable": "No team members available",
    "allMembersAssigned": "All available team members are already assigned",
    "noPermissionToManage": "No permission to manage team members",
    "onlyAdminsAndCreatorsCanManage": "Only administrators and the job creator can add or remove team members.",
    "jobCreatedBy": "Job created by",
    "addSite": "Add Site",
    "editDates": "Edit Dates",
    "editDatesNotAvailable": "Date editing not available",
    "serviceAgreementTitle": "Service Agreement",
    "serviceAgreementDescription": "Configure this job as a recurring service agreement with assigned team member",
    "serviceAgreementMakeRecurring": "Make this a recurring service agreement",
    "serviceAgreementServiceFrequency": "Service Frequency",
    "serviceAgreementServiceSchedule": "Service Schedule",
    "serviceAgreementDaysOfWeek": "Days of the Week",
    "serviceAgreementDayOfMonth": "Day of the Month",
    "serviceAgreementMonthOfQuarter": "Month of Quarter",
    "serviceAgreementMonthOfYear": "Month of Year",
    "serviceAgreementStartTime": "Start Time",
    "serviceAgreementEndTime": "End Time",
    "serviceAgreementEndDateLabel": "Service Agreement End Date (Optional)",
    "serviceAgreementEndDateDescription": "Leave empty for an ongoing service agreement. Set a date to automatically end the recurring services.",
    "serviceAgreementTimeWindowDescription": "Set the preferred time window for service appointments",
    "serviceAgreementAssignedTeamMember": "Assigned Team Member",
    "serviceAgreementSelectTeamMember": "Select a team member...",
    "serviceAgreementLoadingTeamMembers": "Loading team members...",
    "serviceAgreementPleaseSelectAtLeastOneDay": "Please select at least one day of the week",
    "serviceAgreementSaving": "Saving...",
    "serviceAgreementSaveSchedule": "Save Recurring Schedule",
    "serviceAgreementActiveTitle": "Service Agreement Active",

    // Days of the week - short forms
    "daysOfWeekMon": "Mon",
    "daysOfWeekTue": "Tue",
    "daysOfWeekWed": "Wed",
    "daysOfWeekThu": "Thu",
    "daysOfWeekFri": "Fri",
    "daysOfWeekSat": "Sat",
    "daysOfWeekSun": "Sun",

    // Days of the week - full forms
    "daysOfWeekMonday": "Monday",
    "daysOfWeekTuesday": "Tuesday",
    "daysOfWeekWednesday": "Wednesday",
    "daysOfWeekThursday": "Thursday",
    "daysOfWeekFriday": "Friday",
    "daysOfWeekSaturday": "Saturday",
    "daysOfWeekSunday": "Sunday",

    // Frequencies
    "frequenciesDaily": "Daily",
    "frequenciesWeekly": "Weekly",
    "frequenciesBiweekly": "Biweekly",
    "frequenciesMonthly": "Monthly",
    "frequenciesQuarterly": "Quarterly",
    "frequenciesAnnually": "Annually",

    // Ordinals
    "ordinalsFirst": "1st",
    "ordinalsSecond": "2nd",
    "ordinalsThird": "3rd",
    "ordinalsNth": "{{number}}th",
    "ordinalsLastDay": "Last day",
    "ordinals1st": "1st",
    "ordinals2nd": "2nd",
    "ordinals3rd": "3rd",

    // Months
    "monthsJanuary": "January",
    "monthsFebruary": "February",
    "monthsMarch": "March",
    "monthsApril": "April",
    "monthsMay": "May",
    "monthsJune": "June",
    "monthsJuly": "July",
    "monthsAugust": "August",
    "monthsSeptember": "September",
    "monthsOctober": "October",
    "monthsNovember": "November",
    "monthsDecember": "December",

    // Service Agreement Summary
    "serviceAgreementActiveDescription": "This job is configured as a recurring service agreement. The system will automatically create new appointments based on the schedule below.",
    "serviceAgreementFrequency": "Frequency",
    "serviceAgreementServiceTime": "Service Time",
    "serviceAgreementDays": "Days",
    "serviceAgreementMonth": "Month",
    "serviceAgreementAssignedTo": "Assigned To",
    "overviewUnknown": "Unknown",
    "overviewUnknownMember": "Unknown Member",
    "siteName": "Site Name",
    "siteAddress": "Site Address",
    "selectSite": "Select Site",
    "noSitesAvailable": "No sites available for this customer.",
    "jobDetailsFromQuote": "Job Details from Quote",
    "errorLoadingJobDetails": "Error loading job details",
    "projectStartDate": "Project Start Date",
    "projectEndDate": "Project End Date",
    "loading": "Loading...",
    "status": "Status",
    "laborCost": "Labor Cost",
    "totalHours": "Total Hours",
    "materials": "Materials",
    "customer": "Customer",
    "selectACustomer": "Select a customer...",
    "addNewSite": "Add New Site",
    "selectedSite": "Selected Site",
    "editSiteInformation": "Edit Site Information",
    "daily": "Daily",
    "weekly": "Weekly",
    "biweekly": "Bi-weekly",
    "monthly": "Monthly",
    "quarterly": "Quarterly",
    "annually": "Annually",
    "serviceSchedule": "Service Schedule",
    "lastDayOfMonth": "Last day of the month",
    "serviceAgreementActive": "Service Agreement Active",
    "jobDescription": "Job Description",
    "hours": "Hours",
    "ratePerHour": "Rate/Hour",
    "totalPrice": "Total Price",
    "salesPrice": "Sales Price",
    "quoteDetailsTransferred": "Quote Details Transferred",
    "quoteDetailsTransferredDesc": "These job details were automatically transferred from the original quote when it was converted to an active job. You can view the full breakdown of services and pricing from the original quote.",
    "totalJobs": "Total Jobs:",
    "totalEstimatedHours": "Total Estimated Hours:",
    "totalSalesValue": "Total Sales Value:",
    "noJobDetailsAvailable": "No job details available",
    "jobNotFromQuote": "This job may not have been created from a quote, or no job details were specified in the original quote.",
    "priorityLevel": "Priority Level",
    "jobType": "Job Type",
    "viewOffer": "View Offer",
    "delete": "Delete",
    "deleteJob": "Delete Job",
    "deleteJobConfirm": "This action cannot be undone",
    "deleting": "Deleting...",
    "deleteJobButton": "Delete Job",
    "tabs": {
      "overview": "Overview",
      "workEntries": "Work Entries",
      "tasks": "Tasks",
      "materials": "Materials",
      "qualityControl": "Quality Control",
      "billing": "Billing",
      "invoices": "Invoices"
    },
    "statusOptions": {
      "unassigned": "Unassigned",
      "inProgress": "In Progress",
      "onHold": "On Hold",
      "toInvoice": "Job To Invoice",
      "complete": "Complete",
      "cancelled": "Cancelled"
    },
    "addWorkEntry": "Add Work Entry",
    "addTask": "Add Task",
    "addMaterial": "Add Material",
    "loadingWorkEntries": "Loading work entries...",
    "loadingTasks": "Loading tasks...",
    "loadingMaterials": "Loading materials...",
    "completeJobManagement": "Complete Job Management System with Offer-to-Job Material Transfer!",
    "completedFeatures": "Completed Features:",
    "materialsManagement": "Materials Management - Full CRUD operations with quantity and pricing",
    "offerToJobConversion": "Offer-to-Job Conversion - Materials from offers automatically transfer to job materials tab",
    "qualityControlFiles": "Quality Control Files - File upload with S3 storage and quota tracking",
    "overviewIntegration": "Overview Integration - Materials costs automatically calculated and displayed",
    "invoiceSystem": "Invoice System - Complete invoice management with PDF generation, email sending, and payment tracking",
    "workEntrySystem": "Work Entry System - Time tracking with team member assignment",
    "taskManagement": "Task Management - Full task system with priority and status tracking",
    "timeRangeFeature": "Time Range Feature - Recurring schedule management with calendar integration",
    "typescriptCompliance": "TypeScript Compliance - Clean build with proper type safety",
    "readyForProduction": "Ready for production: Complete job management system with seamless offer-to-job workflow!",
    "getStartedByCreating": "Get started by creating a site for this customer.",
    "addFirstSite": "Add First Site",
    "siteNameRequired": "Site Name *",
    "siteContactName": "Contact Name",
    "sitePhoneNumber": "Phone Number",
    "siteEmailLabel": "Email",
    "siteAddressRequired": "Address *",
    "siteCancel": "Cancel",
    "siteCreating": "Creating...",
    "createSite": "Create Site",
    "editSite": "Edit Site",
    "siteProjectStartDate": "Project Start Date",
    "siteProjectEndDate": "Project End Date",
    "notSet": "Not set",
    "overview": {
      "priorityLevel": "Priority Level",
      "jobType": "Job Type",
      "projectTimeline": "Project Timeline",
      "currentCustomer": "Current Customer",
      "changeTo": "Change to",
      "priority": {
        "high": "High Priority",
        "medium": "Medium Priority",
        "low": "Low Priority"
      },
      "jobTypes": {
        "service": "Service",
        "installation": "Installation",
        "callOut": "Call Out"
      },
      "days": {
        "monday": "Monday",
        "tuesday": "Tuesday", 
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday"
      }
    },
    "customerSignature": {
      "title": "Customer Work Approval",
      "description": "Please review the completed work and provide your digital signature to confirm acceptance.",
      "workDescriptionLabel": "Work Description *",
      "workDescriptionPlaceholder": "Please describe the work that was completed...",
      "digitalSignatureLabel": "Digital Signature *",
      "signInstructions": "Sign above using your mouse or finger",
      "clear": "Clear",
      "legalNoticeTitle": "Legal Notice",
      "legalNoticeIntro": "By providing your digital signature above, you acknowledge that:",
      "legalPoint1": "You have reviewed and accept the completed work as described",
      "legalPoint2": "This digital signature has the same legal effect as a handwritten signature",
      "legalPoint3": "The work was completed to your satisfaction",
      "legalPoint4": "This signature is dated {{date}}",
      "submitting": "Submitting...",
      "submitWorkApproval": "Submit Work Approval",
      "customerApprovals": "Customer Approvals",
      "customerApproval": "Customer Approval",
      "signedOn": "Signed on",
      "deleting": "Deleting",
      "delete": "Delete",
      "workDescriptionColon": "Work Description:",
      "pleaseDescribeWork": "Please describe the work performed",
      "pleaseProvideSignature": "Please provide your signature",
      "failedToCaptureSignature": "Failed to capture signature",
      "signatureSubmittedSuccessfully": "Work completion signature submitted successfully!",
      "failedToSubmitSignature": "Failed to submit signature"
    },
    "siteSaving": "Saving...",
    "siteContactPerson": "Site contact person",
    "sitePhoneNumberPlaceholder": "Site phone number",
    "siteEmailPlaceholder": "site@example.com",
    "fullSiteAddress": "Full site address",
    "mainOfficeWarehouse": "e.g., Main Office, Warehouse A",
    "noTasksCreated": "No tasks created yet",
    "clickAddTaskToCreate": "Click \"Add Task\" to create your first task",
    "deleteTask": "Delete Task",
    "deleteTaskConfirmation": "Are you sure you want to delete this task? This action cannot be undone.",
    "deletingTask": "Deleting...",
    "assignedTo": "Assigned to:",
    "teamMember": "Team Member",
    "unassignedTask": "Unassigned Task",
    "due": "Due",
    "time": "Time:",
    "created": "Created",
    "createdBy": "Created by",
    "user": "User",
    "toDo": "To Do",
    "inProgress": "In Progress",
    "done": "Done",
    "editTask": "Edit task",
    "deleteTaskAction": "Delete task",
    "noWorkEntriesYet": "No Work Entries Yet",
    "startTrackingTime": "Start tracking time by creating your first work entry.",
    "hoursUnit": "hours",
    "hourlyRate": "hr",
    "deleteEntry": "Delete Entry",
    "entryType": "Type:",
    "work": "Work",
    "overtime": "Overtime",
    "transportation": "Transportation",
    "areYouSureDeleteEntry": "Are you sure you want to delete this work entry?",
    "entryTypeUpdatedSuccess": "Entry type updated successfully",
    "failedUpdateEntryType": "Failed to update entry type",
    "workEntryDeletedSuccess": "Work entry deleted successfully",
    "failedDeleteWorkEntry": "Failed to delete work entry",
    "editEntry": "Edit Entry",
    "workEntryModal": {
      "title": "Add Work Entry",
      "assignToTeamMember": "Assign to Team Member",
      "selectTeamMember": "Select team member",
      "entryType": "Entry Type",
      "date": "Date",
      "startTime": "Start Time",
      "endTime": "End Time",
      "hours": "Hours",
      "hourlyRate": "Hourly Rate (optional)",
      "hourlyRatePlaceholder": "0.00",
      "description": "Description",
      "descriptionPlaceholder": "Describe the work performed...",
      "cancel": "Cancel",
      "creating": "Creating...",
      "createWorkEntry": "Create Work Entry",
      "pleaseSelectTeamMember": "Please select a team member",
      "hoursMustBeGreaterThanZero": "Hours must be greater than 0",
      "workEntryCreatedSuccessfully": "Work entry created successfully",
      "failedToCreateWorkEntry": "Failed to create work entry",
      "purchasePrice": "Purchase Price",
      "salesPrice": "Sales Price",
      "profitMargin": "Profit Margin",
      "type": "Type",
      "workEntry": "Work Entry",
      "eventHolidayTeamActivity": "Event (Holiday/Team Activity)",
      "trackBillableHours": "Track billable work hours for a specific job",
      "addHolidaysMeetings": "Add holidays, meetings, or team events (no billing required)",
      "teamMembers": "Team Members",
      "selectTeamMembers": "Select team members...",
      "membersSelected": "members selected",
      "ofSelected": "of",
      "selected": "selected",
      "selectAll": "Select all",
      "clear": "Clear",
      "done": "Done",
      "more": "more",
      "user": "User",
      "selectATeamMember": "Select a team member...",
      "job": "Job",
      "selectAJob": "Select a job",
      "eventTitle": "Event Title",
      "eventTitlePlaceholder": "e.g., Christmas Holiday, Team Meeting",
      "eventType": "Event Type",
      "holiday": "Holiday",
      "teamEvent": "Team Event",
      "meeting": "Meeting",
      "other": "Other",
      "allDayEvent": "All Day Event",
      "startDate": "Start Date",
      "endDate": "End Date",
      "findNextAvailableTime": "Find Next Available Time",
      "searching": "Searching...",
      "selectTeamMembersFirst": "Select team members first",
      "hoursCalculatedAutomatically": "Hours will be calculated automatically if start and end times are provided",
      "billingRate": "Billing Rate",
      "loadingRates": "Loading rates...",
      "work": "Work",
      "overtime": "Overtime",
      "transportation": "Transportation",
      "descriptionOptional": "Description (optional)",
      "addEventDetails": "Add any additional details about this event...",
      "markAsCompleted": "Mark as completed",
      "deleteEvent": "Delete Event",
      "delete": "Delete",
      "deleteThisOccurrenceOnly": "Delete this occurrence only",
      "deleteEntireRecurringSeries": "Delete entire recurring series",
      "save": "Save",
      "pleaseSelectAtLeastOneTeamMember": "Please select at least one team member",
      "pleaseEnterEventTitle": "Please enter an event title",
      "pleaseSelectAJob": "Please select a job",
      "pleaseEnterValidHours": "Please enter valid hours (greater than 0)",
      "foundAvailableSlot": "Found available slot on",
      "at": "at",
      "for": "for",
      "noAvailableSlotsFound": "No available time slots found in the next",
      "daysForSelectedTeamMembers": "days for selected team members",
      "failedToFindSlot": "Failed to find available time slot",
      "editEntry": "Edit Entry",
      "newEntry": "New Entry"
    },
    "editJobTitle": "Edit job title",
    "saveJobTitle": "Save",
    "cancelJobTitle": "Cancel",
    "jobTitleUpdated": "Job title updated successfully",
    "failedToUpdateJobTitle": "Failed to update job title",
    "jobTitleRequired": "Job title is required",
    "profitAnalysis": "Profit Analysis",
    "labor": "Labor",
    "costPrice": "Cost Price",
    "profit": "Profit",
    "margin": "Margin",
    "combinedTotal": "Combined Total",
    "totalCostPrice": "Total cost price",
    "grossProfit": "Gross profit",
    "profitMargin": "Profit Margin",
    "marginOnCost": "Margin on cost",
    "backToJobs": "Back to Jobs",
    "jobDeletedSuccess": "Job deleted successfully",
    "workEntryUpdatedSuccessfully": "Work entry updated successfully",
    "deleteJobConfirmMessage": "Are you sure you want to delete",
    "deleteJobAllDataRemoved": "All data associated with this job will be removed.",
    "redirectingToJobs": "Redirecting to jobs...",
    "redirectingToOffer": "Redirecting to offer...",
    "pleaseWait": "Please wait",
    "materialsSection": {
      "nameRequired": "Material name is required",
      "validQuantityRequired": "Please enter a valid quantity",
      "validPriceRequired": "Please enter a valid price",
      "updatedSuccessfully": "Material updated successfully",
      "updateFailed": "Failed to update material",
      "materialNotFound": "Material not found",
      "removedFromJob": "Material removed from job",
      "deleteFailed": "Failed to delete material",
      "loading": "Loading materials...",
      "loadingDescription": "Please wait while materials are loaded",
      "noMaterialsYet": "No materials added yet",
      "addMaterialsDescription": "Add materials from inventory to track costs",
      "totalMaterialsCost": "Total Materials Cost"
    },
    "materialForm": {
      "updatingMaterials": "Updating materials...",
      "materialName": "Material Name",
      "fromInventoryNote": "Material name comes from inventory",
      "quantity": "Quantity",
      "setInInventory": "Set in inventory",
      "cancel": "Cancel",
      "saving": "Saving...",
      "save": "Save",
      "fromInventory": "From Inventory",
      "qty": "Qty",
      "editMaterial": "Edit material",
      "removeMaterial": "Remove material",
      "materialCost": "Material Cost",
      "currency": "DKK"
    }
  },
  "profitStatus": {
    "excellent": "Excellent",
    "good": "Good",
    "fair": "Fair",
    "low": "Low",
    "loss": "Loss"
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "Profit & Loss Analysis from Jobs and Invoices",
    "loadingError": "Failed to load dashboard data",
    "timeRanges": {
      "30d": "30 Days",
      "90d": "90 Days",
      "1y": "1 Year"
    },
    "metrics": {
      "collectedRevenue": "Collected Revenue",
      "collectedRevenueDesc": "Actual payments received",
      "totalBilled": "Total Billed",
      "totalBilledDesc": "Total invoiced amount",
      "totalCosts": "Total Costs",
      "totalCostsDesc": "Labor and materials",
      "netProfit": "Net Profit",
      "profitMargin": "profit margin"
    },
    "tabs": {
      "overview": "Overview",
      "trends": "Trends",
      "breakdown": "Job Type Breakdown",
      "invoices": "Invoice Breakdown",
      "pending": "Pending Invoices"
    },
    "charts": {
      "monthlyProfitLoss": "Monthly Profit & Loss",
      "monthlyProfitLossDesc": "Revenue, costs, and profit over the last 6 months",
      "financialTrends": "Financial Trends",
      "financialTrendsDesc": "Track revenue and profit trends over time",
      "profitByJobType": "Profit by Job Type",
      "profitByJobTypeDesc": "Distribution of profit across different job types",
      "jobCountByType": "Job Count by Type",
      "jobCountByTypeDesc": "Number of jobs completed by type",
      "detailedJobTypeAnalysis": "Detailed Job Type Analysis",
      "detailedJobTypeAnalysisDesc": "Revenue, costs, and profit breakdown by job type with detailed job listings"
    },
    "legends": {
      "revenue": "Revenue",
      "costs": "Costs",
      "netProfit": "Net Profit",
      "profit": "Profit",
      "jobsCompleted": "Jobs Completed",
      "unknown": "Unknown"
    },
    "jobDetails": {
      "jobsCompleted": "jobs completed",
      "netProfit": "Net profit",
      "profitPerJob": "Profit per job:",
      "profitMargin": "Profit margin:",
      "individualJobs": "Individual Jobs",
      "noJobDetails": "No job details available for this job type",
      "duration": "Duration",
      "margin": "margin"
    },
    "invoiceBreakdown": {
      "paidInvoices": "Paid Invoices",
      "paidInvoicesDesc": "Fully paid invoices",
      "partiallyPaidInvoices": "Partially Paid Invoices",
      "partiallyPaidInvoicesDesc": "Invoices with partial payments",
      "unpaidInvoices": "Unpaid Invoices",
      "unpaidInvoicesDesc": "Invoices with no payments yet",
      "invoiceCount": "Invoice Count:",
      "averageValue": "Average Value:",
      "paidAmount": "Paid Amount:",
      "remaining": "Remaining:",
      "collected": "collected",
      "invoiceStatusDistribution": "Invoice Status Distribution",
      "invoiceStatusDistributionDesc": "Breakdown of total invoiced amount by status",
      "paid": "Paid",
      "partiallyPaid": "Partially Paid",
      "unpaid": "Unpaid",
      "invoiceSummary": "Invoice Summary",
      "invoiceSummaryDesc": "Total invoiced amount breakdown",
      "totalInvoicedAmount": "Total Invoiced Amount:",
      "totalCollected": "Total Collected:",
      "totalOutstanding": "Total Outstanding:",
      "collectionRate": "Collection Rate:"
    },
    "pendingInvoices": {
      "title": "Pending Invoices",
      "description": "Invoices awaiting payment sorted by days overdue",
      "outstandingAmount": "Outstanding amount",
      "issueDate": "Issue Date",
      "dueDate": "Due Date",
      "daysOverdue": "Days Overdue",
      "paidAmount": "Paid Amount",
      "notOverdue": "Not overdue",
      "days": "days",
      "noPendingInvoices": "No pending invoices found"
    }
  },
  "reports": {
    "overview": {
      "title": "Reports",
      "subtitle": "Access detailed analytics and insights about your business performance",
      "profitabilityTitle": "Profitability Report",
      "profitabilityDesc": "Comprehensive profit & loss analysis with revenue, costs, and margins by job type",
      "employeeTitle": "Employee Report",
      "employeeDesc": "View active jobs and assignments for each team member in your organization",
      "viewReport": "View Report"
    },
    "employee": {
      "title": "Employee Report",
      "subtitle": "View active job assignments and work hours for each team member",
      "totalEmployees": "Total Employees",
      "employeesDesc": "Team members in organization",
      "activeJobs": "Active Jobs",
      "activeJobsDesc": "Jobs currently in progress",
      "totalHours": "Total Hours (30d)",
      "totalHoursDesc": "Hours logged in last 30 days",
      "teamMembersTitle": "Team Members & Active Jobs",
      "teamMembersDesc": "Click on an employee to see their active job assignments",
      "noEmployees": "No employees found",
      "hours30d": "Hours (30d)",
      "noActiveJobs": "No active jobs assigned",
      "activeJobsCount": "Active Jobs",
      "hoursLogged": "hours logged",
      "lastEntry": "Last",
      "jobType": "Job Type",
      "loadingError": "Failed to load employee report",
      "revenue": "Revenue",
      "cost": "Cost",
      "profit": "Profit"
    }
  },
  "licensing": {
    "pageTitle": "License Management",
    "pageSubtitle": "Manage your team's licenses and subscription",
    "loading": "Loading...",
    "organizationRequired": "Organization Required",
    "organizationRequiredDesc": "You need to create or join an organization to manage licenses.",
    "createOrganization": "Create Organization",
    "noLicensesPurchased": "No Licenses Purchased",
    "noLicensesPurchasedDesc": "Your organization does not have any active licenses. You must purchase at least one license to use the platform.",
    "subscriptionRequired": "Subscription Required",
    "subscriptionRequiredDesc": "A subscription is required to use this application. Please purchase a license to continue.",
    "licenseManagement": "License Management",
    "licenseRequired": "License Required",
    "licenseRequiredDesc": "You need to purchase licenses before you can invite team members. Each team member requires one license.",
    "error": "Error",
    "overview": "Overview",
    "users": "Users",
    "noLicenseAssigned": "No License Assigned",
    "noLicenseAssignedDesc": "You do not have a license. Please purchase a license or ask an admin to assign you one.",
    "userLicenseManagement": "User License Management",
    "licenseCountDesc": "You have {{licenses}} total licenses with {{assigned}} currently assigned.",
    "name": "Name",
    "email": "Email",
    "licensed": "Licensed"
  },
  "signUp": {
    "title": "Start Your Free Trial",
    "subtitle": "Join thousands of trade professionals using Svendetid to grow their business",
    "backToHome": "← Back to Home",
    "alreadyHaveAccount": "Already have an account?",
    "signInHere": "Sign in here →",
    "signIn": "Sign in",
    "freeTrial": "14-day free trial",
    "noCreditCard": "No credit card required",
    "termsAgreement": "By signing up, you agree to our Terms of Service and Privacy Policy",
    "terms": "By signing up, you agree to our Terms of Service and Privacy Policy",
    "footer": "© {{year}} Svendetid. All rights reserved. Made with ❤️ for trade professionals.",
    "welcome": {
      "title": "Welcome to Svendetid",
      "subtitle": "Your complete trade business management solution"
    },
    "features": {
      "scheduling": {
        "title": "Smart Scheduling & Dispatch",
        "description": "Efficiently manage jobs, teams, and appointments with intelligent automation"
      },
      "invoicing": {
        "title": "Instant Invoicing & Payments",
        "description": "Create professional invoices and get paid faster with integrated payment processing"
      },
      "analytics": {
        "title": "Business Analytics & Insights",
        "description": "Track performance and grow your business with powerful reporting tools"
      }
    },
    "form": {
      "title": "Start Your Free Trial",
      "subtitle": "Join thousands of trade professionals using Svendetid to grow their business"
    },
    "trust": {
      "freeTrial": "14-day free trial",
      "noCreditCard": "No credit card required"
    }
  },
  "create": "Create",
  "organization": "Organization",
  "signOut": "Sign Out",
  "yourJobs": "Your quotes",
  "filterOffers": "Filter offers...",
  "createNewqoute": "Create new quote",
  "forms": {
    "quoteTitle": "Write a title for the quote"
  },
  "navHelp": {
    "guideTitle": "Navigation Guide",
    "closeButton": "Close",
    "helpMenu": "Help menu",
    "menuItemLabel": "Navigation Menu Help",
    "gettingStarted": "Getting Started",
    "previous": "Previous",
    "next": "Next",
    "close": "Close",
    "stepCounter": "Step {{current}} of {{total}}",
    "overview": {
      "subtitle": "See and manage your tasks for today",
      "description": "View your company dashboard with key metrics and performance indicators."
    },
    "quotes": {
      "description": "Create and manage customer quotes and estimates for potential jobs."
    },
    "jobs": {
      "description": "Track all active and completed jobs with detailed status information."
    },
    "billing": {
      "description": "Manage invoices, payments, and billing-related activities."
    },
    "activity": {
      "description": "See recent actions and changes in your organization's workspace."
    },
    "customers": {
      "description": "Maintain your customer database with contact details and history."
    },
    "map": {
      "description": "View customer locations and jobs on a geographic map.",
      "title": "Job Locations",
      "subtitle": "View all job locations on the map",
      "noOrganization": "No organization found. Please contact support."
    },
    "calendar": {
      "description": "Schedule appointments and view upcoming deadlines and events."
    },
    "inventory": {
      "description": "Manage your product inventory, stock levels, and suppliers."
    },
    "settings": {
      "description": "Configure your organization preferences, user access, and system settings."
    },
    "adminPage": {
      "description": "Access administrator tools and settings (admin users only)."
    },
    "reports": {
      "description": "Generate and view detailed reports on business performance and activities."
    }
  },
  "offerCreated": "Offer created!",
  "adminApprovalRequired": "Admin Approval Required",
  "adminApprovalRequiredDesc": "This organization requires admin approval before offers can be accepted by customers. As an admin, you need to review and approve this offer first.",
  "adminApproved": "Admin Approved",
  "adminApprovedDesc": "Approved by admin, awaiting customer acceptance",
  "approveOffer": "Approve Offer (Admin)",
  "approveOfferDesc": "Approve this offer for customer acceptance",
  "approveOfferConfirm": "Approve This Offer?",
  "approveOfferConfirmDesc": "This will approve the offer and allow customers to accept it. Once approved, customers will be able to proceed with this quote.",
  "approvedReadyForCustomer": "Approved - Ready for Customer",
  "approvedReadyForCustomerDesc": "This offer has been approved by an admin and is now ready for customer acceptance. The customer can now proceed with this quote.",
  "requireAdminApprovalForOffers": "Require Admin Approval for Offers",
  "requireAdminApprovalForOffersDesc": "Require admin approval before offers can be accepted by customers",
  "title": "Title",
  "status": "Status",
  "customer": "Customer",
  "new": "New",
  "tasks": {
    "title": "Tasks",
    "taskToday": "task today",
    "tasksToday": "tasks today",
    "taskTomorrow": "task tomorrow",
    "tasksTomorrow": "tasks tomorrow",
    "highPriority": "high priority",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "myTasksToday": "My Tasks Today",
    "myTasks": "My Tasks",
    "noTasksToday": "You have no tasks scheduled for today!",
    "noTasksTomorrow": "You have no tasks scheduled for tomorrow!",
    "allCaughtUpToday": "All caught up for today!",
    "allCaughtUpTomorrow": "Nothing scheduled for tomorrow yet",
    "noTasksTodayDesc": "Great work! You have completed all your tasks.",
    "noTasksTomorrowDesc": "Your schedule is clear for tomorrow.",
    "viewAllJobs": "View All Jobs",
    "markComplete": "Mark as Complete",
    "edit": "Edit Task",
    "refreshTasks": "Refresh Tasks",
    "createTestTask": "Create Test Task",
    "viewDiagnostics": "View Diagnostics",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "urgent": "Urgent",
    "toDo": "To Do",
    "inProgress": "In Progress",
    "done": "Done",
    "unassigned": "Unassigned",
    "markAsInProgress": "Mark as In Progress",
    "markAsDone": "Mark as Done",
    "delete": "Delete",
    "addTask": "Add Task",
    "noDueDate": "No due date",
    "due": "Due",
    "unknownUser": "Unknown User",
    "refresh": "Refresh",
    "from": "From",
    "until": "Until",
    "createNewTask": "Create New Task",
    "taskTitle": "Title",
    "enterTaskTitle": "Enter task title",
    "description": "Description",
    "describeTask": "Enter task description",
    "status": "Status",
    "priority": "Priority",
    "dueDate": "Due Date",
    "startTime": "Start Time",
    "endTime": "End Time",
    "assignTo": "Assign To",
    "assigningTo": "Assigning to:",
    "noOne": "No one",
    "cancel": "Cancel",
    "creating": "Creating...",
    "createTask": "Create Task",
    "taskCreationWithTiming": "Task creation with timing and assignment!",
    "startEndTimeMandatory": "Start time and End time are mandatory for all tasks."
  },
  "nav": {
    "overview": "Overview",
    "reports": "Reports",
    "dashboard": "Dashboard",
    "jobs": "Jobs",
    "quotes": "Quotes",
    "activity": "Activity",
    "customers": "Customers",
    "map": "Map",
    "calendar": "Calendar",
    "inventory": "Inventory",
    "suppliers": "Suppliers",
    "billing": "Billing",
    "settings": "Settings",
    "admin": "Admin",
    "adminPage": "Admin Page",
    "serviceAgreements": "Service Agreements",
    "timeRequests": "Time Request",
    "timeRegistration": "Time Registration"
  },
  "admin": {
    "title": "Admin Panel",
    "subtitle": "Manage organization settings, requests, and export time entries",
    "accessLabel": "Admin Access",
    "tabs": {
      "offerApprovals": "Offer Approvals",
      "timeRequests": "Time Requests",
      "employeePayroll": "Employee Payroll",
      "timeExport": "Export Time Entries",
      "adminSettings": "Admin Settings"
    },
    "settings": {
      "title": "Organization Settings",
      "subtitle": "Configure organization-wide settings and preferences",
      "loading": "Loading settings...",
      "loadError": "Failed to load settings",
      "saveSuccess": "Settings saved successfully",
      "saveError": "Failed to save settings",
      "saveInfo": "Changes will be applied immediately after saving",
      "saving": "Saving...",
      "save": "Save Settings",
      "general": {
        "title": "General Settings",
        "description": "Basic organization configuration",
        "orgName": "Organization Name",
        "orgNamePlaceholder": "Enter organization name",
        "timezone": "Timezone",
        "timezoneHelp": "Used for time calculations and reports"
      },
      "timeEntry": {
        "title": "Time Entry Settings",
        "description": "Configure how employees can log time",
        "allowFuture": "Allow Future Time Entries",
        "allowFutureDesc": "Allow employees to log time for future dates",
        "requireApprovalTimeOff": "Require Approval for Time Off",
        "requireApprovalTimeOffDesc": "Require admin approval for holiday and sick leave",
        "requireApprovalOffers": "Require Admin Approval for Offers",
        "requireApprovalOffersDesc": "Require admin approval before offers can be accepted by customers",
        "maxDailyHours": "Max Daily Hours",
        "maxWeeklyHours": "Max Weekly Hours"
      },
      "calendar": {
        "title": "Calendar Settings",
        "description": "Configure calendar display options and working hours",
        "workingHours": "Daily Working Hours",
        "workingHoursDesc": "Set the standard working hours for your organization. These hours will be highlighted in the calendar.",
        "startTime": "Start Time",
        "endTime": "End Time",
        "showWeekends": "Show Weekends",
        "showWeekendsDesc": "Display Saturday and Sunday in the calendar view"
      }
    }
  },
  "employeePayroll": {
    "title": "Employee Payroll Management",
    "subtitle": "Manage CVR numbers, employee numbers, and salary information for CSV exports",
    "exportInformation": "Export Information",
    "exportInformationDescription": "CVR numbers and employee numbers managed here will be automatically included in time entry exports",
    "automaticExportIntegration": "Automatic Export Integration",
    "exportIntegrationDescription": "When you export time entries from the admin panel, the following information will be automatically included:",
    "cvrNumbers": "CVR numbers for each employee",
    "employeeNumbers": "Employee numbers for payroll identification",
    "salaryTypeAndRates": "Salary type and rates for cost calculations",
    "employeePayrollInformation": "Employee Payroll Information",
    "managePayrollInfo": "Manage CVR numbers, employee numbers, and salary information for payroll exports",
    "addEditEmployeeData": "Add/Edit Employee Data",
    "employee": "Employee",
    "role": "Role",
    "cvrNumber": "CVR Number",
    "employeeNumber": "Employee Number",
    "salaryType": "Salary Type",
    "rateSalary": "Rate/Salary",
    "actions": "Actions",
    "noEmployeesFound": "No employees found in organization",
    "noUserID": "No user ID",
    "hourly": "HOURLY",
    "fixedSalary": "SALARY",
    "freelance": "FREELANCE",
    "edit": "Edit",
    "editEmployeeData": "Edit Employee Data",
    "addEmployeeData": "Add Employee Data",
    "enterCvrNumber": "Enter CVR number",
    "enterEmployeeNumber": "Enter employee number",
    "selectSalaryType": "Select salary type",
    "hourlyRate": "Hourly Rate (DKK)",
    "monthlySalary": "Monthly Salary (DKK)",
    "enterHourlyRate": "Enter hourly rate",
    "enterMonthlySalary": "Enter monthly salary",
    "cancel": "Cancel",
    "saving": "Saving...",
    "saveEmployeeData": "Save Employee Data",
    "errorLoadingData": "Error: Unable to load organization members or payroll data. Please try again later.",
    "dkkPerHour": "DKK/hr",
    "dkkPerMonth": "DKK/month"
  },
  "timeEntriesExport": {
    "title": "Time Entries Export",
    "subtitle": "Export all time entries to CSV for HR and payroll systems",
    "loadingOrganization": "Loading organization data...",
    "exportConfiguration": "Export Configuration",
    "configurationDescription": "Configure the export parameters and download time entries as a CSV file",
    "fromDate": "From Date",
    "toDate": "To Date",
    "employeeFilter": "Employee Filter",
    "workTypeFilter": "Work Type Filter",
    "selectEmployee": "Select employee",
    "selectWorkType": "Select work type",
    "allEmployees": "All Employees",
    "allWorkTypes": "All Work Types",
    "work": "Work",
    "holiday": "Holiday",
    "sickLeave": "Sick Leave",
    "personalLeave": "Personal Leave",
    "noMembersFound": "No organization members found",
    "exportToCSV": "Export to CSV",
    "exporting": "Exporting...",
    "csvFormatTitle": "Simplified CSV Export Format",
    "cvrNumberDesc": "Danish company registration number",
    "employeeNumberDesc": "Internal employee ID",
    "workTypeDesc": "Type of work (WORK, HOLIDAY, SICK_LEAVE, etc.)",
    "salaryTypeDesc": "Payment structure (HOURLY, SALARY, FREELANCE)",
    "hoursDesc": "Hours worked for each time entry",
    "salaryPerHourDesc": "Hourly rate from employee payroll data",
    "salaryDesc": "Calculated amount (Hours × Salary Per Hour)",
    "setupRequiredDesc": "Configure employee data in \"Employee Payroll\" tab first",
    "organizationNotFound": "Organization not found",
    "unknownUser": "Unknown User",
    "errorArray": "Error: organizationMembers is not an array"
  },
  "adminSettings": {
    "title": "Organization Settings",
    "subtitle": "Configure organization-wide settings",
    "loadingSettings": "Loading settings...",
    "offerApprovalSettings": "Offer Approval Settings",
    "offerApprovalDescription": "Control how offers are processed in your organization",
    "requireAdminApproval": "Require Admin Approval for Offers",
    "requireAdminApprovalDesc": "When enabled, all offers must be approved by an admin before customers can accept them",
    "saveSettings": "Save Settings",
    "saving": "Saving...",
    "settingsSaved": "Settings saved successfully",
    "failedToSave": "Failed to save settings",
    "adminApprovalEnabled": "Admin approval enabled",
    "adminApprovalDisabled": "Admin approval disabled",
    "failedToUpdate": "Failed to update setting"
  },
  "vacationAllowance": {
    "title": "Vacation Allowance Management",
    "subtitle": "Set vacation limits per employee and vacation type",
    "loading": "Loading...",
    "year": "Year",
    "setVacationAllowance": "Set Vacation Allowance",
    "employee": "Employee",
    "selectEmployee": "Select employee",
    "vacationType": "Vacation Type",
    "selectType": "Select type",
    "allowedHours": "Allowed Hours",
    "setAllowance": "Set Allowance",
    "setting": "Setting...",
    "currentVacationAllowances": "Current Vacation Allowances",
    "noAllowancesSet": "No vacation allowances set for",
    "useFormAbove": "Use the form above to set allowances for employees",
    "hoursUsed": "h used",
    "remaining": "Remaining",
    "used": "used",
    "pleaseSelectAll": "Please fill in all fields",
    "allowanceUpdated": "Vacation allowance updated successfully",
    "failedToLoad": "Failed to load vacation allowance data",
    "failedToSet": "Failed to set vacation allowance"
  },
  "holidayTypes": {
    "title": "Holiday Types Management",
    "subtitle": "Manage holiday types that users can select when logging time off",
    "addHolidayType": "Add Holiday Type",
    "addNewHolidayType": "Add New Holiday Type",
    "createNewDescription": "Create a new holiday type that users can select when logging holiday time.",
    "editHolidayType": "Edit Holiday Type",
    "updateDescription": "Update the holiday type information.",
    "name": "Name",
    "namePlaceholder": "e.g., Annual Leave, Sick Leave, Personal Day",
    "nameRequired": "Name *",
    "description": "Description",
    "descriptionPlaceholder": "Optional description for this holiday type",
    "cancel": "Cancel",
    "createHolidayType": "Create Holiday Type",
    "creating": "Creating...",
    "updateHolidayType": "Update Holiday Type",
    "updating": "Updating...",
    "deleteConfirm": "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
    "noHolidayTypes": "No holiday types configured yet",
    "createHolidayTypesDescription": "Create holiday types that your team can use when logging time off.",
    "created": "Created",
    "holidayTypeNameRequired": "Holiday type name is required",
    "holidayTypeCreated": "Holiday type created successfully",
    "failedToCreate": "Failed to create holiday type",
    "holidayTypeUpdated": "Holiday type updated successfully", 
    "failedToUpdate": "Failed to update holiday type",
    "holidayTypeDeleted": "Holiday type deleted successfully",
    "failedToDelete": "Failed to delete holiday type",
    "loading": "Loading..."
  },
  "attendanceCalendar": {
    "thisWeek": "This Week",
    "thisMonth": "This Month",
    "work": "Work",
    "holiday": "Holiday",
    "sick": "Sick",
    "pending": "Pending",
    "calendarView": "Calendar View",
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "loadingCalendar": "Loading calendar...",
    "clickToAddEntries": "Click on any day to add time entries",
    "dragToCreateEntries": "Drag to create time entries instantly",
    "creatingTimeEntry": "Creating time entry...",
    "clickForManualEntry": "Click for manual entry • Switch to Week/Day view for drag functionality",
    "clickOrDragEntry": "Click for manual entry • Drag for quick logging",
    "duration": "Duration",
    "hours": "hours"
  },
  "materialModal": {
    "title": "Add Material from Inventory",
    "selectExistingItem": "Select Existing Item",
    "createNewItem": "Create New Item",
    "selectMaterialFromInventory": "Select Material from Inventory *",
    "loadingInventoryItems": "Loading inventory items...",
    "attemptOf": "Attempt {{current}} of {{total}}",
    "slowConnectionDetected": "Slow connection detected. Loading may take longer...",
    "youAppearOffline": "You appear to be offline. Please check your connection.",
    "searchMaterials": "Search materials...",
    "available": "available",
    "noItemsMatchSearch": "No items match your search",
    "selected": "Selected",
    "errorLoadingInventory": "Error loading inventory",
    "noInventoryItems": "No inventory items available",
    "createFirstInventoryItem": "Create your first inventory item to get started",
    "tryAgain": "Try Again",
    "productName": "Product Name *",
    "enterProductName": "Enter product name",
    "price": "Price *",
    "enterPrice": "Enter price (DKK)",
    "unit": "Unit *",
    "enterUnit": "Enter unit (e.g., pcs, m, kg)",
    "quantity": "Quantity *",
    "enterQuantity": "Enter quantity",
    "description": "Description",
    "enterDescription": "Enter description (optional)",
    "totalCost": "Total Cost",
    "cancel": "Cancel",
    "creating": "Creating...",
    "adding": "Adding...",
    "addMaterial": "Add Material",
    "createMaterial": "Create Material",
    "pleaseSelectInventoryItem": "Please select an inventory item",
    "validQuantityRequired": "Valid quantity is required",
    "productNameRequired": "Product name is required",
    "validPriceRequired": "Valid price is required",
    "unitRequired": "Unit is required",
    "selectedInventoryItemNotFound": "Selected inventory item not found",
    "notEnoughQuantityAvailable": "Not enough quantity available. Only {{available}} {{unit}} in stock.",
    "failedToAddMaterialFromInventory": "Failed to add material from inventory",
    "materialAddedSuccessfully": "Material added successfully",
    "failedToAddMaterial": "Failed to add material",
    "creatingInventoryItem": "Creating inventory item...",
    "failedToCreateInventoryItem": "Failed to create inventory item",
    "failedToAddMaterialToJob": "Failed to add material to job",
    "materialAndInventoryItemCreated": "Material and inventory item created successfully",
    "failedToCreateMaterial": "Failed to create material"
  },
  "overview": {
    "subtitle": "See and manage your tasks for today",
    "welcome": "Welcome back",
    "user": "User",
    "tasksToday": "tasks today",
    "tasksTomorrow": "tasks tomorrow",
    "highPriority": "high priority",
    "updated": "Updated",
    "refresh": "Refresh",
    "noJobDetailsAvailable": "No Job Details Available",
    "jobNotFromQuote": "This job was not created from a quote or the quote details are not available.",
    "quickActions": {
      "title": "Quick Actions",
      "subtitle": "Create new items quickly to get started",
      "createOffer": "Create Offer",
      "createJob": "Create Job",
      "createCustomer": "Create Customer",
      "createSupplier": "Create Supplier",
      "createInvoice": "Create Invoice"
    },
    "days": {
      "monday": "Monday",
      "tuesday": "Tuesday", 
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "summary": {
      "totalHours": "Total Hours",
      "workEntriesCost": "Work Entries Cost",
      "materialsCost": "Materials Cost",
      "totalCost": "Total Cost"
    },
    "stats": {
      "draft": "Draft",
      "sent": "Sent", 
      "accepted": "Accepted",
      "declined": "Declined",
      "completed": "Completed",
      "invoiced": "Invoiced",
      "paid": "Paid",
      "quotes": "Quotes",
      "jobs": "Jobs",
      "rejected": "Rejected",
      "unassigned": "Unassigned",
      "inProgress": "In Progress",
      "onHold": "On Hold",
      "toInvoice": "To Invoice",
      "complete": "Complete",
      "cancelled": "Cancelled",
      "overdue": "Overdue",
      "pending": "Pending",
      "approved": "Approved",
      "organizationOverview": "Organization Overview",
      "offers": "Offers",
      "invoices": "Invoices",
      "bills": "Bills",
      "clickToView": "Click to view all offers",
      "clickToViewJobs": "Click to view all jobs",
      "clickToViewInvoices": "Click to view all invoices",
      "clickToViewBills": "Click to view all bills"
    },
    "priorityStatus": {
      "priority": "Priority",
      "jobType": "Job Type",
      "jobDates": "Job Dates",
      "teamMember": "Team Member",
      "customerInfo": "Customer Info",
      "startDate": "Start Date",
      "endDate": "End Date",
      "assignedTo": "Assigned to",
      "selectTeamMember": "Select team member",
      "noTeamMemberAssigned": "No team member assigned"
    },
    "priorities": {
      "low": "Low",
      "medium": "Medium", 
      "high": "High",
      "urgent": "Urgent"
    },
    "jobTypes": {
      "maintenance": "Maintenance",
      "inspection": "Inspection",
      "installation": "Installation",
      "repair": "Repair",
      "consultation": "Consultation",
      "service": "Service",
      "callOut": "Call Out"
    },
    "serviceAgreement": {
      "title": "Service Agreement",
      "description": "Configure this job as a recurring service agreement with assigned team member",
      "makeRecurring": "Make this a recurring service agreement",
      "serviceFrequency": "Service Frequency",
      "serviceSchedule": "Service Schedule",
      "daysOfWeek": "Days of the Week",
      "dayOfMonth": "Day of the Month",
      "monthOfQuarter": "Month of Quarter",
      "monthOfYear": "Month of Year",
      "startTime": "Start Time",
      "endTime": "End Time",
      "endDateLabel": "Service Agreement End Date (Optional)",
      "endDateDescription": "Leave empty for an ongoing service agreement. Set a date to automatically end the recurring services.",
      "timeWindowDescription": "Set the preferred time window for service appointments",
      "assignedTeamMember": "Assigned Team Member",
      "selectTeamMember": "Select a team member...",
      "loadingTeamMembers": "Loading team members...",
      "pleasSelectAtLeastOneDay": "Please select at least one day of the week",
      "saveChanges": "Save Changes",
      "savingChanges": "Saving Changes...",
      "saving": "Saving...",
      "saveSchedule": "Save Recurring Schedule",
      "configuredSchedule": "This job is configured as a recurring service agreement with the following schedule:",
      "activeTitle": "Service Agreement Active",
      "activeDescription": "This job is configured as a recurring service agreement with the following schedule:",
      "frequency": "Frequency",
      "serviceTime": "Service Time",
      "days": "Days",
      "month": "Month",
      "assignedTo": "Assigned to",
      "schedule": "Schedule",
      "timeWindow": "Time Window",
      "automatically": "Automatically"
    },
    "frequencies": {
      "daily": "Daily",
      "weekly": "Weekly", 
      "biweekly": "Bi-weekly",
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "annually": "Annually"
    },
    "daysOfWeek": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday", 
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu", 
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "ordinals": {
      "lastDay": "Last day of month",
      "first": "1st",
      "second": "2nd", 
      "third": "3rd",
      "nth": "{{number}}th"
    },
    "projectTimeline": "Project Timeline",
    "unknownMember": "Unknown Member",
    "unknown": "Unknown",
    "currentCustomer": "Current Customer",
    "changeTo": "Change to",
    "priorityLevel": "Priority Level",
    "jobType": "Job Type",
    "priority": {
      "high": "High Priority",
      "medium": "Medium Priority", 
      "low": "Low Priority"
    }
  },
  "jobs": {
    "activeJobs": "Active Jobs",
    "searchJobs": "Search jobs...",
    "newJob": "New Job",
    "allJobs": "All Jobs",
    "unassignedJobs": "Unassigned Jobs",
    "inProgressJobs": "In Progress Jobs",
    "onHoldJobs": "On Hold Jobs",
    "toInvoiceJobs": "Jobs To Invoice",
    "completeJobs": "Complete Jobs",
    "cancelledJobs": "Cancelled Jobs",
    "viewAndManageJobs": "View and manage all your jobs",
    "allJobsWithStatus": "All jobs with \"{{status}}\" status",
    "noJobsFound": "No jobs found",
    "noJobsFoundSearch": "No jobs match your search for \"{{searchTerm}}\"",
    "noJobsFoundStatus": "There are no {{status}} jobs yet",
    "title": "Title",
    "customer": "Customer",
    "status": "Status",
    "viewDetails": "View details",
    "statusBadges": {
      "inProgress": "In Progress",
      "onHold": "On Hold",
      "complete": "Complete",
      "cancelled": "Cancelled",
      "toInvoice": "To Invoice",
      "unassigned": "Unassigned"
    },
    "tabs": {
      "all": "All",
      "unassigned": "Unassigned",
      "inProgress": "In Progress",
      "onHold": "On Hold",
      "toInvoice": "To Invoice",
      "complete": "Complete",
      "cancelled": "Cancelled"
    }
  },
  "addressInput": {
    "customer": "Customer",
    "selectCustomer": "Select a customer",
    "address": "Address",
    "enterAddress": "Enter address or select a customer",
    "linkedToCustomer": "Linked to customer",
    "description": "Description",
    "characters": "characters",
    "startDate": "Start Date",
    "expiryDate": "Expiry Date",
    "save": "Save",
    "saving": "Saving...",
    "searchCustomer": "Search for customer",
    "customerInformation": "Customer Information",
    "selectOrAddCustomer": "Select or add a customer for this quote",
    "addNewCustomer": "Add new customer",
    "customerDetails": "Customer Details",
    "editCustomer": "Edit Customer",
    "site": "Site",
    "selectSite": "Select a site (optional)",
    "selectCustomerFirst": "Select a customer first",
    "loadingSites": "Loading sites...",
    "addNewSite": "Add new site",
    "editSelectedSiteTooltip": "Edit selected site",
    "editSite": "Edit site",
    "quoteDetails": "Quote Details",
    "preview": "Preview",
    "customerId": "Customer ID",
    "customerIdPlaceholder": "Search for customers...",
    "createNewCustomer": "Create new customer",
    "edit": "Edit",
    "noCustomersFound": "No customers found",
    "selectOption": "Select an option",
    "selectCustomerToEnableSite": "Select a customer to enable site selection",
    "noSitesAvailable": "No sites available for this customer. Add a new site.",
    "loadingSiteInformation": "Loading site information...",
    "siteDetails": "Details",
    "addressLabel": "Address:",
    "contactLabel": "Contact:",
    "notProvided": "Not provided",
    "pleaseSelectCustomerFirst": "Please select a customer first",
    "errorOpeningCustomerDialog": "Error opening add customer dialog. Please try again.",
    "failedToOpenSiteModal": "Failed to open site creation modal",
    "pleaseSelectCustomerFirstTooltip": "Please select a customer first",
    "addNewSiteTooltip": "Add new site",
    "siteNotBelongToCustomer": "Site does not belong to the selected customer",
    "rateLimitReached": "Rate limit reached. Please try again later.",
    "databaseConnectionLimit": "Database connection limit reached. Please try again later.",
    "connectionLimitReached": "Connection limit reached. Please try again in a moment.",
    "failedToUpdateSiteData": "Failed to update site data. Please try again.",
    "navigationTakingLonger": "Navigation taking longer than expected. Please try again.",
    "companyLabel": "Company:",
    "emailLabel": "Email:",
    "phoneLabel": "Phone:",
    "phone": "Phone",
    "email": "Email",
    "addCustomer": "Add Customer",
    "addSite": "Add Site",
    "bothDatesRequired": "Both dates are required",
    "enterDescriptionAndTimeFrame": "Enter the description and time frame for the quote",
    "quoteStatus": "Quote Status",
    "termsAndNotes": "Terms & Notes",
    "setTermsAndNotes": "Set the terms and additional notes for this quote",
    "uploadRelatedDocuments": "Upload related documents",
    "openingCustomerPage": "Opening Customer Page...",
    "viewCustomer": "View Customer",
    "mustSelectCustomerFirst": "You must select a customer before selecting a site",
    "siteCannotBeAccessed": "This site cannot be accessed with the current customer",
    "siteBelongsToDifferentCustomer": "This site belongs to a different customer",
    "pleaseSelectCustomerFromList": "Please select a customer from the list",
    "startDateAndExpiryRequired": "Start date and expiry date are required",
    "failedToSaveChanges": "Failed to save changes",
    "invalidBoardId": "Invalid board ID",
    "errorLinkingCustomer": "Error linking customer to quote. Please try saving manually.",
    "failedToSaveSiteSelection": "Failed to save site selection. Please try again.",
    "failedToUpdateBoard": "Failed to update board",
    "allChangesSavedSuccessfully": "All changes saved successfully",
    "customerSelectedForQuote": "Customer selected for this quote",
    "customerCreatedSuccessfully": "Customer created successfully",
    "siteCreatedAndSelected": "Site created and selected successfully",
    "overview": "Overview",
    "details": "Details",
    "pricing": "Pricing",
    "aiFixGrammar": "Fix Grammar",
    "aiMakeFormal": "Make Formal",
    "aiImproving": "Improving...",
    "aiFormalizing": "Formalizing...",
    "aiFixGrammarTooltip": "Fix grammar and spelling using AI",
    "aiMakeFormalTooltip": "Rewrite in formal tone using AI",
    "aiBusinessLicenseRequired": "Business License required for AI features",
    "aiBusinessLicenseRequiredBadge": "AI features require Business License",
    "aiBusinessLicenseRequiredToast": "Business License required for AI features",
    "aiEnterDescriptionFirst": "Please enter a description first",
    "aiDescriptionTooShort": "Description must be at least 10 characters to use AI improvement",
    "aiMinimumCharacters": "Enter at least 10 characters to use AI improvement",
    "aiGrammarImproved": "Grammar and spelling improved successfully",
    "aiFormalImproved": "Text has been rewritten in formal tone",
    "aiInvalidResponse": "Invalid response from AI service",
    "aiFailedToImprove": "Failed to improve description. Please try again.",
    "selectSiteToViewDetails": "Select a site to view details",
    "cancel": "Cancel",
    "savingChanges": "Saving changes...",
    "unsavedChangesWarning": "You have unsaved changes. Please click Save before leaving.",
    "unsavedChangesTitle": "Unsaved Changes Detected",
    "unsavedChangesMessage": "You have unsaved changes to this offer. If you leave now, your changes will be lost.",
    "unsavedChangesHint": "Click \"Save & Leave\" to keep your changes, or \"Leave Without Saving\" to discard them.",
    "saveAndLeave": "Save & Leave",
    "leaveWithoutSaving": "Leave Without Saving",
    "stayOnPage": "Stay on Page",
    "saveBeforeLeaving": "Please save your changes before leaving this page",
    "saveNow": "Save Now",
    "termsShort": "Terms",
    "previewShort": "PDF",
    "newQuote": "New Quote",
    "quote": "Quote",
    "quoteId": "Quote ID",
    "organizationName": "Organization Name",
    "organizationDetailsInSettings": "Edit in Settings",
    "contact": "Contact",
    "noAddressProvided": "No address provided",
    "enterProjectDescription": "Enter a description of the project or work to be done...",
    "moreItems": "more items",
    "noProductsAdded": "No products added yet",
    "goToPricingTab": "Go to Pricing tab to add items",
    "noLaborAdded": "No labor hours added yet",
    "noTermsSet": "No terms set - default terms will be used",
    "noNotesSet": "No additional notes",
    "pdfPreview": "PDF Preview",
    "sendOfferEmail": "Send Offer",
    "generating": "Generating...",
    "sendOfferToCustomer": "Send Offer to Customer",
    "sendOfferDescription": "Send a link to your customer where they can view and respond to this offer.",
    "offerLink": "Shareable Offer Link",
    "customerCanViewAndRespond": "Your customer can view the offer details and accept or request changes using this link.",
    "to": "To",
    "subject": "Subject",
    "message": "Message",
    "openEmailClient": "Open Email Client",
    "copy": "Copy",
    "copied": "Copied!",
    "linkCopied": "Link copied to clipboard",
    "failedToCopyLink": "Failed to copy link",
    "emailClientOpened": "Email client opened",
    "noCustomerLinked": "No customer linked to this offer",
    "customerNotFound": "Customer not found",
    "customerNoEmail": "Customer has no email address",
    "saveBeforeSending": "Please save changes before sending the offer",
    "failedToGenerateOfferLink": "Failed to generate offer link"
  },
  "customerModal": {
    "companyNameRequired": "Company name is required",
    "addressRequired": "Address is required",
    "orgIdMissing": "Organization ID is missing",
    "networkError": "Network error - no response received",
    "invalidResponse": "Invalid response from server",
    "createFailed": "Failed to create customer",
    "missingId": "Invalid response data - missing customer ID",
    "createSuccess": "Customer created successfully",
    "handlingError": "Error handling new customer. Please try again.",
    "createError": "Failed to create customer",
    "selectCustomer": "Select Customer",
    "close": "Close",
    "createNew": "Create New Customer",
    "companyName": "Company Name",
    "companyNamePlaceholder": "Enter company name",
    "address": "Address",
    "addressPlaceholder": "Enter address",
    "email": "Email",
    "emailPlaceholder": "customer@example.com",
    "phoneNumber": "Phone Number",
    "phonePlaceholder": "+45 12 34 56 78",
    "cvrNumber": "CVR Number",
    "cvrPlaceholder": "12345678",
    "cancel": "Cancel",
    "creating": "Creating...",
    "createCustomer": "Create Customer"
  },
  "siteModal": {
    "createSuccess": "Site created successfully",
    "createFailed": "Failed to create site",
    "updateSuccess": "Site updated successfully",
    "updateFailed": "Failed to update site",
    "nameAddressRequired": "Name and address are required",
    "submitFailed": "Failed to submit site data. Please try again.",
    "editSite": "Edit Site",
    "createNew": "Create New Site",
    "updateDescription": "Update the site information below.",
    "createDescription": "Enter the details for the new site.",
    "siteName": "Site Name",
    "siteNamePlaceholder": "Enter site name",
    "address": "Address",
    "addressPlaceholder": "Enter site address",
    "contactPerson": "Contact Person",
    "contactPlaceholder": "Enter contact name",
    "phoneNumber": "Phone Number",
    "phonePlaceholder": "Enter phone number",
    "email": "Email",
    "emailPlaceholder": "Enter email address",
    "cancel": "Cancel",
    "saving": "Saving...",
    "saveChanges": "Save Changes",
    "createSite": "Create Site"
  },
  "boardPriceSummary": {
    "title": "Price Summary",
    "description": "Combined cost overview of materials and labor",
    "category": "Category",
    "subtotal": "Subtotal",
    "subtotalExclVat": "Subtotal (excl. VAT)",
    "materials": "Materials",
    "labor": "Labor",
    "items": "items",
    "item": "item",
    "include25Vat": "Include 25% VAT",
    "notApplied": "Not applied",
    "discount": "Discount",
    "percentage": "Percentage",
    "fixedAmount": "Fixed Amount",
    "noDiscount": "No discount",
    "total": "Total",
    "inclVat": "(incl. VAT)",
    "savePriceSummary": "Save Price Summary",
    "priceSummarySaved": "Price summary saved successfully",
    "failedToSavePriceSummary": "Failed to save price summary",
    "profitAnalysis": "Profit Analysis",
    "combinedTotal": "Combined Total",
    "totalCost": "Total Cost",
    "totalSales": "Total Sales",
    "totalProfit": "Total Profit",
    "margin": "Margin",
    "salesPrice": "Sales Price",
    "costPrice": "Cost Price",
    "profit": "Profit",
    "costs": "Costs",
    "totalCostPrice": "Total Cost Price",
    "grossProfit": "Gross Profit",
    "profitMargin": "Profit Margin",
    "marginOnCost": "Margin on Cost",
    "profitStatus": {
      "excellent": "Excellent",
      "good": "Good",
      "fair": "Fair",
      "low": "Low",
      "loss": "Loss"
    }
  },
  "boardProfitAnalysis": {
    "description": "Cost vs. sales analysis and profit margins",
    "addItemsToSeeAnalysis": "Add products or labor to see profit analysis",
    "noDataYet": "No data yet",
    "addProductsOrLabor": "Add products or labor items to see profit analysis",
    "marginsAndAnalysis": "Profit Margins & Analysis"
  },
  "boardActivity": {
    "created": "Offer Created",
    "emailSent": "Offer Sent by Email",
    "statusChanged": "Status Changed",
    "offerAccepted": "Offer Accepted",
    "convertedToJob": "Converted to Active Job",
    "offerReopened": "Offer Reopened",
    "createdBy": "Created by {{userName}}",
    "sentByTo": "Sent by {{userName}} to {{recipient}}",
    "changedBy": "Changed by {{userName}} from {{oldStatus}} to {{newStatus}}",
    "acceptedBy": "Accepted by {{userName}} on {{date}}",
    "convertedByWithDate": "Converted to \"{{jobTitle}}\" by {{userName}} on {{date}}",
    "reopenedBy": "Reopened by {{userName}} on {{date}}",
    "reopenedFromDeclined": "Reopened from \"{{oldStatus}}\" by {{userName}} on {{date}}",
    "reopenedFromAdminApproved": "Reopened from \"{{oldStatus}}\" by {{userName}} on {{date}}",
    "reopenedFromAccepted": "Reopened from \"{{oldStatus}}\" by {{userName}} on {{date}}",
    "reopenedFromActiveJob": "Reopened from \"{{oldStatus}}\" by {{userName}} on {{date}}"
  },
  "boardStatus": {
    "newOffer": "New Offer",
    "newOfferDescription": "Newly created offer awaiting review",
    "pendingOffer": "Pending Offer",
    "pendingOfferDescription": "Offer ready for review",
    "pendingAdminApproval": "Pending Admin Approval",
    "pendingAdminApprovalDescription": "Waiting for admin approval",
    "adminApproved": "Admin Approved",
    "adminApprovedDescription": "Approved by admin, awaiting customer acceptance",
    "accepted": "Accepted",
    "acceptedDescription": "Offer has been accepted and approved",
    "activeJob": "Active Job",
    "activeJobDescription": "Work has started - moved to active jobs",
    "declined": "Declined",
    "declinedDescription": "Offer has been declined",
    "awaitingAdminApproval": "Awaiting admin approval before customer acceptance",
    "requirementsNotMet": "Requirements not met",
    "missing": "Missing",
    "markAccepted": "Mark Accepted",
    "markDeclined": "Mark Declined",
    "reopenForEdit": "Reopen for Edit",
    "awaitingAdmin": "Awaiting admin review",
    "viewJob": "View Job",
    "failedToUpdateStatus": "Failed to update status",
    "convertingToActiveJob": "Converting to Active Job - Redirecting to active job in 2 seconds...",
    "statusUpdated": "Status Updated - Quote status changed to {{label}}",
    "failedToUpdateQuoteStatus": "Failed to update quote status. Please try again.",
    "reviewActivateOffer": "Review & Activate Offer",
    "reviewActivateOfferDescription": "Review the offer details and activate it for processing",
    "activateOfferConfirmTitle": "Activate This Offer?",
    "activateOfferConfirmDescription": "This will move the offer to \"Pending Offer\" status, making it ready for review and potential acceptance.",
    "sendForAdminApproval": "Send for Admin Approval",
    "sendForAdminApprovalDescription": "Submit this offer for admin review and approval",
    "requestAdminApprovalConfirmTitle": "Request Admin Approval?",
    "requestAdminApprovalConfirmDescription": "This will send the offer to administrators for review. Once approved by an admin, customers will be able to accept it.",
    "markAsAccepted": "Mark as accepted?",
    "markAsAcceptedButton": "Mark as Accepted",
    "markAsAcceptedDescription": "Accept this offer directly (skip admin approval)",
    "directAcceptConfirmTitle": "Accept Offer Directly?",
    "directAcceptConfirmDescription": "This will mark the offer as accepted, bypassing the admin approval process. The offer will be ready to convert to an active job.",
    "acceptOfferCustomer": "Accept Offer (Customer)",
    "acceptOfferCustomerDescription": "Customer can now accept this approved offer",
    "customerAcceptConfirmTitle": "Customer Accept Offer?",
    "customerAcceptConfirmDescription": "This simulates the customer accepting the offer. In production, this would be done by the customer through their interface.",
    "convertToActiveJob": "Convert to Active Job",
    "convertToActiveJobDescription": "Start working on this accepted offer",
    "convertJobConfirmTitle": "Convert to Active Job?",
    "convertJobConfirmDescription": "This will create an active job from this offer and move it to the jobs section. You'll be redirected to the new active job page.",
    "readyForAdminReview": "Ready for Admin Review",
    "requiresAdminApproval": "This organization requires admin approval for offers. Click below to send this offer to administrators for review and approval.",
    "readyToAccept": "Ready to Accept",
    "readyToProceed": "When you're ready to proceed with this quote (after customer confirmation), click the button below to accept the offer and move forward.",
    "approvedReadyForCustomer": "Approved - Ready for Customer",
    "approvedByAdmin": "This offer has been approved by an admin and is now ready for customer acceptance. You can proceed with acceptance, decline, or reopen for further review.",
    "reopenForReview": "Reopen for Review",
    "reopenConfirmTitle": "Reopen for Review?",
    "reopenConfirmMessage": "This will move the offer back to \"Pending Offer\" status, removing the admin approval. The offer will need to go through the approval process again if admin approval is required.",
    "markAsDeclined": "Mark as Declined",
    "declineConfirmTitle": "Mark as Declined?",
    "declineConfirmMessage": "This will mark the offer as declined. This action indicates that the offer has been rejected and will update the status accordingly. This cannot be undone easily.",
    "acceptThisOffer": "Accept This Offer?",
    "acceptConfirmMessage": "This will mark the offer as accepted and allow you to proceed with converting it to an active job. You can do this once the customer has confirmed they want to proceed.",
    "confirmReopen": "Confirm Reopen",
    "confirmDecline": "Confirm Decline", 
    "confirmAccept": "Confirm Accept",
    "offerAcceptedTitle": "Offer Accepted",
    "offerAcceptedDescription": "This offer has been accepted and is ready to be converted to an active job. You can proceed with conversion or reopen for modifications if needed.",
    "markAsDeclinedButton": "Mark as Declined",
    "declineConfirmTitleAdmin": "Mark as Declined?",
    "declineConfirmMessageAdmin": "This will mark the offer as declined. This action indicates that the offer has been rejected and will update the status accordingly. This cannot be undone easily.",
    "acceptOfferCustomerButton": "Accept Offer (Customer)",
    "customerAcceptOfferTitle": "Customer Accept Offer?",
    "customerAcceptOfferDescription": "This simulates the customer accepting the offer. In production, this would be done by the customer through their interface.",
    "reopenOfferButton": "Reopen Offer",
    "reopenOfferTitle": "Reopen This Offer?",
    "reopenOfferDescription": "This will move the offer back to \"Pending Offer\" status, removing the acceptance. You can then make modifications or go through the approval process again if needed.",
    "convertJobButton": "Convert to Active Job",
    "convertJobDialogTitle": "Convert to Active Job?",
    "convertJobDialogDescription": "This will create a new active job from this accepted quote and move it to the active jobs section. All pricing and details will be copied over, and you will be redirected to the active jobs page to begin tracking work progress.",
    "confirmConvert": "Confirm Convert",
    "newOfferCreatedTitle": "New Offer Created",
    "newOfferCreatedDescription": "This offer has been newly created and is waiting to be activated. You can activate it to proceed with the approval process or reset it if changes are needed.",
    "resetOfferButton": "Reset Offer",
    "resetOfferTitle": "Reset This Offer?",
    "resetOfferDescription": "This will reset the offer back to its initial new state. Any progress or changes will be maintained, but the status will remain as \"New Offer\" for further modifications.",
    "confirmReset": "Confirm Reset",
    "reviewActivateOfferButton": "Review & Activate Offer",
    "activateOfferTitle": "Activate This Offer?",
    "activateOfferDescription": "This will move the offer to \"Pending Offer\" status, making it ready for review and potential acceptance. Once activated, the offer will enter the approval workflow.",
    "confirmActivate": "Confirm Activate",
    "confirm": "Confirm",
    "offerDeclinedTitle": "Offer Declined",
    "offerDeclinedDescription": "This offer has been declined and will not proceed further. You can reopen the offer below if circumstances have changed.",
    "reopenDeclinedOfferTitle": "Reopen This Offer?",
    "reopenDeclinedOfferDescription": "This will move the offer back to the \"Pending Offer\" status, allowing you to proceed with acceptance or make modifications. The offer will be available for review and acceptance again.",
    "awaitingAdminApprovalTitle": "Awaiting Admin Approval",
    "awaitingAdminApprovalDescription": "This offer has been submitted for admin review. An administrator will review and either approve or request changes. You will be notified once a decision has been made.",
    "convertedToActiveJobTitle": "✓ This quote has been converted to an active job",
    "convertedToActiveJobDescription": "Check the Active Jobs section to manage this project",
    "reopenActiveJobOfferTitle": "Reopen This Offer?",
    "reopenActiveJobOfferDescription": "This will move the offer back to \"Pending Offer\" status, effectively reversing the conversion to active job. The active job will remain, but the offer status will be reset for further modifications.",
    "goToActiveJobButton": "Go to Active Job",
    "cancel": "Cancel",
    "updating": "Updating...",
    "loadingOfferSettings": "Loading offer settings...",
    "convertingToActiveJobMessage": "Converting to Active Job",
    "progress": "Progress",
    "pleaseWaitCreatingJob": "Please wait while we create your active job..."
  },
  "boardNotes": {
    "title": "Notes",
    "editNotes": "Edit Notes",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "addNotesPlaceholder": "Add your notes here...",
    "characters": "characters",
    "noNotesAdded": "No notes have been added yet.",
    "notesSavedSuccess": "Notes saved successfully",
    "failedToSaveNotes": "Failed to save notes"
  },
  "boardTerms": {
    "title": "Terms & Conditions",
    "editTerms": "Edit Terms",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "enterTermsPlaceholder": "Enter terms and conditions...",
    "characters": "characters",
    "noTermsAdded": "No terms have been added yet.",
    "termsSavedSuccess": "Terms saved successfully",
    "failedToSaveTerms": "Failed to save terms"
  },
  "board": {
    "backToOffers": "Back to Offers"
  },
  "boardOptions": {
    "viewPdf": "View PDF",
    "printPdf": "Print PDF",
    "delete": "Delete",
    "deleteConfirmation": "Are you sure you want to delete this offer? This action cannot be undone.",
    "offerDeletedSuccess": "Offer deleted successfully",
    "failedToPrint": "Failed to print PDF",
    "navigatingToPdf": "Navigating to PDF view for printing..."
  },
  "offerApprovals": {
    "title": "Offer Approvals",
    "subtitle": "Review and manage pending offer approvals",
    "noPendingApprovals": "No Pending Approvals",
    "allOffersReviewed": "All offers have been reviewed. New offers requiring approval will appear here.",
    "pendingReview": "Pending Review",
    "projectDescription": "Project Description",
    "projectAddress": "Project Address",
    "start": "Start",
    "end": "End",
    "hourlyRate": "Hourly Rate",
    "profitMargin": "Profit Margin",
    "taxMargin": "Tax Margin",
    "submittedBy": "Submitted by",
    "boardId": "Board ID",
    "viewDetails": "View Details",
    "client": "Client",
    "submitted": "Submitted",
    "reject": "Reject",
    "approve": "Approve",
    "rejectOffer": "Reject Offer",
    "rejectOfferDescription": "This offer will be returned to the submitter for revision. Please provide a reason for rejection.",
    "reasonForRejection": "Reason for rejection",
    "rejectionPlaceholder": "Please explain why this offer is being rejected and what changes are needed...",
    "cancel": "Cancel",
    "rejectOfferAction": "Reject Offer",
    "approveOffer": "Approve Offer",
    "approveOfferDescription": "This will approve the offer for {{clientName}} worth {{amount}}. The customer will be notified and can proceed with acceptance.",
    "approveOfferAction": "Approve Offer",
    "refreshOffers": "Refresh Offers",
    "failedToLoadOffers": "Failed to load pending offers",
    "offerApprovedSuccess": "Offer approved successfully",
    "offerRejectedSuccess": "Offer rejected successfully",
    "failedToApproveOffer": "Failed to approve offer",
    "failedToRejectOffer": "Failed to reject offer"
  },
  "timeRequests": {
    "title": "Pending Time Requests",
    "subtitle": "Review and approve employee time requests",
    "noPendingRequests": "No pending requests",
    "allRequestsReviewed": "All time requests have been reviewed",
    "hours": "hours",
    "approve": "Approve",
    "reject": "Reject",
    "requestApprovedSuccess": "Request approved successfully",
    "requestRejectedSuccess": "Request rejected successfully",
    "failedToUpdateRequest": "Failed to update request",
    "failedToLoadRequests": "Failed to load time requests",
    "to": "to",
    "workType": {
      "HOLIDAY": "Holiday",
      "SICK": "Sick",
      "WORK": "Work",
      "OVERTIME": "Overtime"
    }
  },
  "marketing": {
    "redirecting": "Redirecting to your dashboard...",
    "nav": {
      "features": "Features",
      "testimonials": "Testimonials",
      "pricing": "Pricing",
      "login": "Login",
      "startFreeTrial": "Start Free Trial"
    },
    "hero": {
      "title": "Get Control of",
      "titleHighlight": "Your Daily Operations",
      "titleAnd": "and",
      "titleHighlight2": "Faster Payment",
      "subtitle": "The complete solution for tradespeople who want to save time, avoid mistakes, and get paid faster. No lock-in period. Try free for 30 days.",
      "benefit1": "More time for your craft",
      "benefit2": "Faster payment",
      "benefit3": "Full overview of your business",
      "ctaFree": "Try Free for 30 Days",
      "ctaDemo": "Book Demo",
      "socialProof": "Used by tradespeople across Denmark",
      "helpsText": "Svendetid helps with",
      "helpsItem1": "Order management",
      "helpsItem2": "Time tracking",
      "helpsItem3": "Invoicing",
      "helpsItem4": "Creating quotes",
      "stats": {
        "companies": "Danish tradespeople",
        "support": "Support in Danish",
        "uptime": "Uptime"
      }
    },
    "trust": {
      "description": "Svendetid is built specifically for Danish tradespeople and complies with all Danish regulations. We understand your industry – because we've worked closely with electricians, plumbers, carpenters, and painters.",
      "item1": {
        "title": "Hundreds of Danish tradespeople",
        "description": "Join companies like Hansen El-Service, Andersen VVS, and Tømrermester Jørgensen"
      },
      "item2": {
        "title": "GDPR-compliant",
        "description": "All your data is securely stored on Danish servers"
      },
      "item3": {
        "title": "Danish support",
        "description": "Get help in Danish when you need it – no call centers abroad"
      },
      "item4": {
        "title": "Easy setup",
        "description": "Get started in 10 minutes – no technical knowledge required"
      },
      "item5": {
        "title": "30-day free trial",
        "description": "Try all features with no commitment or credit card required"
      }
    },
    "features": {
      "badge": "Everything you need",
      "title": "Built for your workday",
      "subtitle": "All the tools you need to run your business efficiently – from quote to payment.",
      "quotes": {
        "title": "Quotes & Invoices",
        "description": "Create professional quotes in minutes. Send invoices directly from the app and get paid faster."
      },
      "scheduling": {
        "title": "Planning & Calendar",
        "description": "Keep track of all jobs, deadlines, and team schedules in one intuitive calendar."
      },
      "timeTracking": {
        "title": "Time Tracking",
        "description": "Employees register hours directly in the app – you get precise billing and payroll."
      },
      "materials": {
        "title": "Material Management",
        "description": "Keep track of materials used on each job – automatically included in invoicing."
      },
      "customers": {
        "title": "Customer Management",
        "description": "All customer information, communication history, and documents in one place."
      },
      "jobs": {
        "title": "Job Management",
        "description": "Full overview of all active and completed jobs with status, economy, and communication."
      }
    },
    "testimonials": {
      "badge": "What do users say?",
      "title": "Real-world results",
      "subtitle": "Hear how Danish tradespeople use Svendetid to save time and increase revenue.",
      "testimonial1": {
        "quote": "We saved 10 hours per week on administration after switching to Svendetid. Now we can focus on what we're good at – namely installing electrical systems.",
        "author": "Lars Hansen",
        "company": "Hansen El-Service • Roskilde"
      },
      "testimonial2": {
        "quote": "It used to take weeks before we got payment. Now we get paid immediately. It has completely changed our cash flow.",
        "author": "Mette Andersen",
        "company": "Andersen VVS • Odense"
      },
      "testimonial3": {
        "quote": "I was skeptical about computer solutions, but Svendetid is so simple that even my installers embrace it. We've never been more efficient.",
        "author": "Peter Jørgensen",
        "company": "Tømrermester Jørgensen • Aarhus"
      }
    },
    "pricing": {
      "badge": "Transparent pricing",
      "title": "Choose the solution that suits you",
      "subtitle": "Start with the Pro license and upgrade to Business+ when you're ready for even more automation.",
      "currency": "DKK",
      "perUserMonth": "per user, per month",
      "pro": {
        "name": "Pro",
        "description": "The complete solution for small and medium-sized businesses",
        "included": "Included in Pro:",
        "feature1": "Quotes & invoices",
        "feature2": "Planning & calendar",
        "feature3": "Time tracking",
        "feature4": "Material management",
        "feature5": "Customer management",
        "feature6": "Job management",
        "feature7": "Integrations (e-conomic, Dinero, QuickPay)",
        "feature8": "Danish support",
        "feature9": "Mobile app",
        "feature10": "Unlimited users",
        "cta": "Try Free for 30 Days"
      },
      "business": {
        "badge": "⭐ Most popular",
        "name": "Business+",
        "description": "Pro + AI features for even greater efficiency",
        "plusFeatures": "Everything from Pro, plus:",
        "aiTitle": "AI-assisted work",
        "aiFeature1Title": "Automatic invoice scanning",
        "aiFeature1Description": "Upload supplier invoices – AI reads and registers data automatically",
        "aiFeature2Title": "AI quote improvement",
        "aiFeature2Description": "Get help improving, rewriting, and fixing spelling mistakes in your quotes",
        "standardFeatures": "Plus all standard features:",
        "feature1": "All features from Pro license",
        "feature2": "Priority support",
        "feature3": "Dedicated onboarding",
        "feature4": "Advanced reporting",
        "cta": "Try Business+ Free"
      },
      "whyBusinessPlus": "Why choose Business+?",
      "value1Title": "Save even more time",
      "value1Description": "AI handles tedious tasks so you can focus on important work.",
      "value2Title": "Fewer mistakes",
      "value2Description": "AI catches spelling mistakes and suggests improvements before you send quotes.",
      "value3Title": "More professional",
      "value3Description": "Send error-free, well-written quotes that win more customers."
    },
    "benefits": {
      "title": "Make your daily life easier",
      "subtitle": "Svendetid helps you reduce administration, avoid mistakes, and get better oversight of your business.",
      "benefit1Title": "Less administration",
      "benefit1Description": "Automate tedious tasks and spend time on what matters.",
      "benefit2Title": "Fewer mistakes",
      "benefit2Description": "Avoid misunderstandings and forgotten tasks with digital workflows.",
      "benefit3Title": "Better overview",
      "benefit3Description": "See status on all jobs, finances, and team on one dashboard.",
      "benefit4Title": "Faster payment",
      "benefit4Description": "Send invoices immediately and receive payment lightning fast."
    },
    "footer": {
      "description": "Job management for Danish tradespeople. Save time, avoid mistakes, and get better oversight of your business.",
      "product": "Product",
      "features": "Features",
      "pricing": "Pricing",
      "demo": "Demo",
      "integrations": "Integrations",
      "company": "Company",
      "about": "About Us",
      "contact": "Contact",
      "blog": "Blog",
      "support": "Support",
      "help": "Help",
      "privacy": "Privacy Policy",
      "terms": "Terms of Service",
      "security": "Security",
      "copyright": "© {{year}} Svendetid ApS. All rights reserved.",
      "madeWith": "Made with ❤️ in Denmark",
      "systemStatus": "All systems running",
      "location": "🇩🇰 Denmark"
    }
  },
  "qualityControl": {
    "title": "Quality Control Documents",
    "description": "Upload and manage quality control documentation for this job",
    "uploadFile": "Upload File",
    "upload": "Upload",
    "uploading": "Uploading...",
    "selected": "Selected",
    "fileDescription": "Description",
    "addDescription": "Add a description for this file...",
    "uploadedDocuments": "Uploaded Documents",
    "reviewAndManage": "Review and manage your quality control files",
    "refresh": "Refresh",
    "loadingFiles": "Loading files...",
    "preview": "Preview",
    "download": "Download",
    "downloadFile": "Download File",
    "delete": "Delete",
    "deleting": "Deleting...",
    "close": "Close",
    "loadingPreview": "Loading preview...",
    "previewNotAvailable": "Preview not available for this file type.",
    "storageUsage": "Storage Usage",
    "gbUsed": "GB of",
    "gbUsedTotal": "GB used",
    "files": "files",
    "noFilesUploadedYet": "No files uploaded yet",
    "uploadFirstDocument": "Upload your first quality control document using the form above.",
    "fileUploadedSuccessfully": "File uploaded successfully",
    "failedToUploadFile": "Failed to upload file",
    "pleaseSelectFileToUpload": "Please select a file to upload",
    "failedToLoadFiles": "Failed to load files",
    "unknownError": "Unknown error",
    "failedToPreviewFile": "Failed to preview file",
    "cameraSupport": "Camera support",
    "available": "Available",
    "notAvailable": "Not available",
    "mediaDevicesApi": "MediaDevices API",
    "loadingYourFiles": "Loading your files...",
    "checkingUploadedDocuments": "Checking for uploaded documents...",
    "startingPreview": "Starting preview for"
  },
  "organizationSettings": {
    "title": "Organization Settings",
    "description": "Manage your organization's configuration, members, and billing.",
    "loading": "Loading...",
    "error": "Error",
    "accessDenied": "Access Denied",
    "accessDeniedMessage": "You don't have permission to access organization settings. Only Pro administrators can manage these settings.",
    "common": {
      "error": "Error"
    },
    "licenses": {
      "purchaseTeamLicenses": "Purchase Team Licenses",
      "addLicensesDescription": "Add licenses for your team members to access the platform",
      "numberOfLicenses": "Number of Licenses",
      "licenseInfo": "Each team member needs one license. 50 DKK per license per month.",
      "pricePerLicense": "Price per license:",
      "monthlyPrice": "15.00 DKK / month",
      "total": "Total:",
      "totalPrice": "{{price}} DKK / month",
      "redirectingToCheckout": "Redirecting to checkout...",
      "redirecting": "Redirecting to checkout...",
      "preparingOrder": "Preparing your order...",
      "purchaseLicenses": "Purchase {{count}} {{licensePlural}}",
      "licenseSingular": "License",
      "licensePlural": "Licenses",
      "monthly": "Monthly",
      "annual": "Annual",
      "annualSave": "Annual (Save 20%)",
      "youSave": "You save",
      "month": "month",
      "year": "year",
      "checkout": "Proceed to Checkout",
      "billingPeriod": "Billing Period", 
      "checkoutError": "Checkout Error",
      "unknownError": "An unknown error occurred",
      "unlockFullAccess": "Unlock full access to the platform for your team members",
      "organizationNotFound": "Organization not found",
      "organizationRequired": "You must be in an organization to purchase licenses.",
      "priceIdMissing": "Product price ID is not configured",
      "minimumLicense": "Please select at least 1 license",
      "licensesUpdated": "Licenses Updated",
      "subscriptionUpdated": "Your subscription now has {{count}} licenses.",
      "noCheckoutUrl": "No checkout URL or subscription update returned from server",
      "checkoutFailed": "Failed to start checkout process. Please try again or contact support.",
      "errorLoadingLicenseData": "Error Loading License Data",
      "retry": "Retry",
      "getStarted": "Get Started",
      "chooseLicenseType": "Choose the license type that best fits your business needs.",
      "proLicense": "Pro License",
      "popular": "Popular",
      "proLicenseDescription": "Perfect for small to medium teams. Includes core project management features.",
      "proFeatures": {
        "projectManagement": "Project & job management",
        "customerInvoiceManagement": "Customer & invoice management",
        "basicReporting": "Basic reporting",
        "mobileAppAccess": "Mobile app access",
        "emailSupport": "Email support"
      },
      "proDkkPerMonth": "99 DKK/month per user (excl. VAT)",
      "businessPlusLicense": "Business+ License",
      "advanced": "Advanced",
      "businessPlusDescription": "For growing businesses that need advanced features and priority support.",
      "businessPlusFeatures": {
        "everythingInPro": "Everything in Pro",
        "advancedAnalytics": "Advanced analytics & reporting",
        "teamCollaboration": "Team collaboration tools",
        "apiAccess": "API access",
        "priorityPhoneSupport": "Priority phone support",
        "customIntegrations": "Custom integrations"
      },
      "businessPlusDkkPerMonth": "199 DKK/month per user (excl. VAT)",
      "loading": "Loading...",
      "loadingSubscriptionInfo": "Loading subscription information...",
      "billingManagement": "Billing Management",
      "billingManagementDescription": "Manage your subscription, view invoices, and update payment methods.",
      "openBillingPortal": "Open Billing Portal",
      "needToPurchaseOrRenew": "Need to Purchase or Renew?",
      "purchaseRenewDescription": "If your subscription has expired or you need additional licenses, you can purchase them here.",
      "coreFeatures": "Core features for small teams",
      "advancedFeaturesPriority": "Advanced features & priority support",
      "billingPortalNote": "If you encounter issues accessing the billing portal, your subscription may have expired or been cancelled. You can purchase new licenses above or contact support for assistance.",
      "billingPortalError": "Billing Portal Error",
      "billingPortalErrorDescription": "Failed to open billing management. Please try again.",
      "noSubscriptionFound": "No Subscription Found",
      "noSubscriptionFoundDescription": "You need to purchase licenses first before accessing the billing portal.",
      "loadingPleaseWait": "License data is still loading. Please try again in a moment.",
      "noActiveSubscription": "No active subscription found. Your subscription may have expired or been cancelled. Please purchase new licenses or contact support for assistance.",
      "noBillingAccount": "No billing account found for this organization. Please contact support to set up billing.",
      "organizationNotFoundError": "Organization not found. Please contact support for assistance.",
      "networkError": "Network Error",
      "genericError": "Something Went Wrong",
      "refreshPage": "Refresh Page",
      "currentLicensePlan": "Current License Plan",
      "licensePlanHelp": "This is your organization's current license plan and feature access level.",
      "licenses": "licenses",
      "importantNote": "Important Note:",
      "singleLicenseTypeRule": "All licenses in your organization must be of the same type (Pro or Business+). Mixing license types is not allowed.",
      "licenseActive": "License Active",
      "licenseActiveDescription": "You have full access to all platform features.",
      "activationPending": "Activation Pending",
      "activationPendingDescription": "Your account is awaiting license activation from an administrator.",
      "whatToDoNext": "What to do next:",
      "contactAdminStep": "Contact your organization admin to request license assignment",
      "adminWillAssignStep": "An admin will assign a license to your account",
      "receiveNotificationStep": "You'll receive a notification when your license is activated",
      "cannotPerformActionsNotice": "You won't be able to perform certain actions until your license is activated.",
      "getStartedHelp": "Choose the license plan that best fits your team's needs.",
      "billingManagementHelp": "Manage your subscription, update payment methods, and view billing history.",
      "purchaseMoreHelp": "Add more licenses to your existing subscription.",
      "utilizationLabel": "License Utilization",
      "availableLicenses": "licenses available for assignment",
      "allLicensesUsed": "All licenses are currently assigned",
      "recentActivity": "Recent Activity",
      "noRecentActivity": "No recent license activity",
      "status": {
        "active": "Active",
        "pending": "Pending",
        "inactive": "No License",
        "expired": "Expired",
        "available": "Available"
      },
      "tabs": {
        "myLicense": "My License",
        "purchase": "Purchase",
        "manageTeam": "Manage Team"
      },
      "licenseAssignment": {
        "title": "License Assignment",
        "loadingMembers": "Loading team members...",
        "errorLoadingMembers": "Error Loading Members",
        "retry": "Retry",
        "searchPlaceholder": "Search members by name or email...",
        "filterAll": "All",
        "filterLicensed": "Licensed",
        "filterUnlicensed": "Unlicensed",
        "noAvailableLicenses": "No Available Licenses",
        "noAvailableLicensesDesc": "You have no available licenses to assign. Purchase more licenses to add team members.",
        "licenseManagementInfo": "License Management",
        "licenseManagementDesc": "Admin users maintain administrative access regardless of license status. Licenses control access to premium features and can be assigned to any team member.",
        "admin": "Admin",
        "licensed": "Licensed",
        "you": "You",
        "license": "License",
        "noMembers": "No members found.",
        "noSearchResults": "No members match your search.",
        "licensed_one": "{{count}} licensed",
        "licensed_other": "{{count}} licensed",
        "admins_one": "{{count}} admin",
        "admins_other": "{{count}} admins",
        "available_one": "{{count}} available",
        "available_other": "{{count}} available",
        "licensedCountOf": "{{licensed}} of {{total}} members have licenses",
        "refresh": "Refresh",
        "refreshing": "Refreshing...",
        "licenseUpdateSuccess": "License Updated Successfully",
        "licenseAssigned": "License {{action}} {{user}}.",
        "licenseAssignedTo": "assigned to",
        "licenseRemovedFrom": "removed from",
        "licenseUpdateFailed": "License Update Failed",
        "noAvailableLicensesToast": "No Available Licenses",
        "noAvailableLicensesToastDesc": "You need to purchase more licenses before assigning them to users.",
        "selected": "selected",
        "assignToSelected": "Assign Licenses",
        "removeFromSelected": "Remove Licenses",
        "clearSelection": "Clear",
        "selectAll": "Select All",
        "deselectAll": "Deselect All",
        "bulkUpdateSuccess": "Bulk Update Complete",
        "bulkUpdateFailed": "Bulk Update Failed",
        "insufficientLicenses": "Insufficient Licenses",
        "insufficientLicensesDesc": "Not enough licenses available for bulk assignment",
        "role": "Role",
        "roleAdmin": "Admin",
        "roleMember": "Member",
        "changeRole": "Change Role",
        "roleUpdateSuccess": "Role Updated",
        "roleUpdateFailed": "Role Update Failed",
        "cannotRemoveLastAdmin": "Cannot Remove Last Admin",
        "cannotRemoveLastAdminDesc": "At least one admin is required for the organization.",
        "roleUpdatedTo": "Role updated to {{role}} for {{user}}",
        "updatingRole": "Updating role..."
      },
      "manageLicenses": {
        "title": "License Management",
        "loadingPlanInfo": "Loading plan information...",
        "managePlanLicenses": "Manage your {{plan}} licenses",
        "refreshSubscriptionData": "Refresh subscription data from Stripe",
        "totalPurchased": "Total Purchased",
        "availableToAssign": "Available to Assign",
        "used": "used",
        "currentPlan": "Current Plan",
        "businessPlanDesc": "Business+ plan includes advanced team collaboration features, unlimited storage, and priority support.",
        "professionalPlanDesc": "Professional plan includes productivity features, enhanced reporting, and standard support.",
        "standardPlanDesc": "Standard plan includes basic features. Upgrade to Professional or Business+ for additional capabilities.",
        "totalLicenses": "Total Licenses",
        "licenseType": "License Type",
        "subscriptionStatus": "Subscription Status",
        "source": "Source",
        "stripeSubscription": "Stripe Subscription",
        "database": "Database",
        "pendingInvitations": "Pending Invitations",
        "pendingInvitationsCount": "Pending Invitations ({{count}})",
        "show": "Show",
        "hide": "Hide",
        "loadingInvitations": "Loading invitations...",
        "invited": "Invited {{date}}",
        "invitationsUsingLicenses": "These invitations are using {{count}} of your available licenses.",
        "inviteTeamMembers": "Invite Team Members",
        "error": "Error",
        "emailDomainIssue": "Email Domain Issue?",
        "emailDomainDesc": "If you're testing with example.com or similar domains, try using a real email domain instead:",
        "emailDomainExamples": "yourname+test1@gmail.com (+ addressing), testuser@outlook.com, sample@yahoo.com",
        "alternativeSolutions": "Alternative Solutions:",
        "alternativeSolutionsList": "Ask the user to sign in directly to your organization, Have them visit your organization's login page, If they don't have an account, ask them to create one first, Check if they're already a member under a different email, Contact support if the user continues to have access issues",
        "success": "Success",
        "invalidEmails": "Invalid Email",
        "invalidEmailsPlural": "Invalid Emails",
        "invalidEmailsDesc": "The following email addresses are invalid:",
        "dismiss": "Dismiss",
        "emailAddresses": "Email Addresses",
        "enterEmailPlaceholder": "Enter email addresses",
        "add": "Add",
        "emailInstructions": "Enter multiple emails separated by commas or press Add after each one. Use real email domains (gmail.com, outlook.com) - test domains like example.com are blocked.",
        "recipients": "Recipients",
        "customMessage": "Custom Message (Optional)",
        "customMessagePlaceholder": "Add a personal note to your invitation",
        "availableLicensesInfo": "You have {{count}} available license.",
        "availableLicensesInfoPlural": "You have {{count}} available licenses.",
        "noLicensesAvailable": "Purchase more licenses to invite additional team members.",
        "sendInvitations": "Send {{count}} Invitation",
        "sendInvitationsPlural": "Send {{count}} Invitations",
        "sending": "Sending...",
        "cancel": "Cancel",
        "inviteMembers": "Invite Members",
        "noAvailableLicenses": "No available licenses",
        "purchaseMoreLicenses": "Purchase more licenses before inviting team members.",
        "inviteFormInstructions": "Use the form above to invite team members to your organization",
        "subscriptionDataRefreshed": "Subscription data refreshed",
        "subscriptionRefreshSuccess": "Updated to {{plan}} plan with {{quantity}} licenses",
        "refreshFailed": "Refresh failed",
        "refreshFailedDesc": "Could not refresh subscription data",
        "invitationRevoked": "Invitation revoked",
        "invitationRevokedDesc": "Invitation for {{email}} has been revoked.",
        "failedToRevokeInvitation": "Failed to revoke invitation",
        "revokeInvitationError": "An error occurred while revoking the invitation"
      },
      "upgradeToBusinessPlus": "Upgrade to Business+",
      "upgradeDescription": "Unlock advanced features, priority support, and more for your entire team.",
      "upgradeNote": "Note",
      "allLicensesUpgradedNote": "All licenses will be upgraded. You'll be charged the prorated difference immediately.",
      "viewUpgradeOptions": "View Upgrade Options",
      "upgradeAllLicensesDescription": "All your licenses will be upgraded to Business+. You'll be charged immediately for the prorated difference.",
      "calculatingCosts": "Calculating upgrade costs...",
      "alreadyOnBusinessPlan": "You are already on the Business+ plan.",
      "currentPlan": "Current Plan",
      "newPlan": "New Plan",
      "licenseType": "License Type",
      "currentMonthlyTotal": "Current Monthly Total",
      "newMonthlyTotal": "New Monthly Total",
      "immediateCharge": "Immediate Charge",
      "proratedChargeExplanation": "You'll be charged today for the prorated difference for the remaining days of your billing cycle.",
      "chargeToday": "Charge Today",
      "monthlyIncreaseNote": "Your monthly bill will increase starting next billing cycle.",
      "businessPlusBenefits": "Business+ Benefits",
      "allLicensesUpgraded": "All licenses will be upgraded immediately",
      "cardChargedNow": "Your card will be charged immediately",
      "canManageAnytime": "You can manage your subscription anytime through the billing portal",
      "confirmUpgrade": "Confirm Upgrade",
      "processing": "Processing...",
      "upgradeSuccess": "Upgrade Successful! 🎉",
      "upgradeError": "Upgrade Error",
      "paymentFailed": "Payment Failed"
    },
    "createJob": {
      "title": "Create New Job",
      "jobTitle": "Job Title",
      "jobTitlePlaceholder": "Enter job title",
      "jobTitleRequired": "Please enter a job title",
      "cancel": "Cancel",
      "createJob": "Create Job",
      "creating": "Creating...",
      "successMessage": "Job created successfully",
      "errorMessage": "Failed to create job"
    },
    "language": {
      "english": "English",
      "danish": "Dansk",
      "englishFlag": "GB Flag",
      "danishFlag": "DK Flag"
    },
    "tabs": {
      "general": "General",
      "members": "Members",
      "billingRates": "Billing Rates",
      "storage": "Storage",
      "licenses": "Licenses"
    },
    "general": {
      "organizationInformation": "Organization Information",
      "organizationInformationDesc": "Basic information about your organization",
      "organizationName": "Organization Name",
      "organizationId": "Organization ID",
      "organizationLogo": "Organization Logo",
      "cvrNumber": "CVR Number",
      "address": "Address",
      "websiteUrl": "Website URL",
      "contactEmail": "Contact Email",
      "additionalInformation": "Additional Information",
      "notSpecified": "Not specified",
      "cvrNumberPlaceholder": "12345678",
      "addressPlaceholder": "Enter organization address",
      "websiteUrlPlaceholder": "https://example.com",
      "contactEmailPlaceholder": "contact@example.com",
      "organizationDetails": "Organization Details",
      "organizationDetailsDesc": "Timeline and membership information",
      "organizationFeatures": "Organization Features",
      "organizationFeaturesDesc": "Available features and capabilities for this organization",
      "organizationSettings": "Organization Settings",
      "organizationSettingsDesc": "Advanced configuration options for your organization",
      "createdDate": "Created Date",
      "memberCount": "Member Count",
      "members": "members",
      "member": "member",
      "unknown": "Unknown",
      "edit": "Edit",
      "update": "Update",
      "remove": "Remove",
      "uploadLogo": "Upload Logo",
      "save": "Save",
      "cancel": "Cancel",
      "fileSupport": "Supported formats: JPEG, PNG, GIF, WebP, ICO (max 10MB)",
      "features": {
        "organizationManagement": "Organization Management",
        "memberManagement": "Member Management",
        "roleBasedAccess": "Role-Based Access Control",
        "timeTracking": "Time Tracking",
        "projectManagement": "Project Management"
      },
      "settingsItems": {
        "billingRates": "Configure billing rates for different service types",
        "storageUsage": "Manage and monitor storage usage",
        "licenseAssignment": "Assign licenses to team members",
        "memberRoles": "Define member roles and permissions",
        "timeRegistration": "Configure time registration settings",
        "projectJob": "Project and job management configuration"
      },
      "errors": {
        "organizationNameEmpty": "Organization name cannot be empty",
        "updateNameFailed": "Failed to update organization name",
        "invalidFileType": "Invalid file type. Please upload a JPEG, PNG, GIF, WebP, or ICO file",
        "fileSizeTooBig": "File size exceeds 10MB limit",
        "updateLogoFailed": "Failed to update organization logo",
        "deleteLogoFailed": "Failed to delete organization logo",
        "updateDetailsFailed": "Failed to update organization details",
        "invalidWebsiteUrl": "Invalid website URL format",
        "invalidEmail": "Invalid email format"
      },
      "success": {
        "nameUpdated": "Organization name updated successfully",
        "logoUpdated": "Organization logo updated successfully",
        "logoDeleted": "Organization logo deleted successfully",
        "detailsUpdated": "Organization details updated successfully"
      },
      "confirmations": {
        "deleteLogo": "Are you sure you want to delete the organization logo?"
      }
    },
    "storage": {
      "title": "Storage Management",
      "description": "Manage your organization's storage allocation and usage.",
      "loading": "Loading storage information...",
      "errorLoading": "Error Loading Storage Data",
      "debugInfo": "Debug Information",
      "retry": "Try Again",
      "noStats": "No storage statistics available.",
      "refresh": "Refresh",
      "mockDataNote": "Note: This is sample data for demonstration purposes.",
      "usageDetails": "Usage Details",
      "lastUpdated": "Last Updated",
      "qualityControlDocs": "Quality Control Documents",
      "files": "files",
      "ofTotal": "of total",
      "otherStorage": "Other Storage",
      "storageInformation": "Storage Information",
      "storageInfoDesc": "Your organization's storage allocation includes:",
      "includedStorage": "10GB included with your plan",
      "additionalStorage": "Additional Storage",
      "perPackage": "per storage package",
      "totalAvailableStorage": "Total Available Storage",
      "adminStorageNote": "As an admin, you can purchase additional storage below.",
      "adminStorageNoteDefault": "As an admin, you can purchase additional storage if needed.",
      "errors": {
        "fetchFailed": "Failed to fetch storage statistics."
      }
    }
  },
  "pdfPreview": {
    "title": "PDF Preview",
    "livePreview": "Live preview of",
    "loading": "Loading PDF preview...",
    "fullscreen": "Fullscreen",
    "exitFullscreen": "Exit",
    "print": "Print",
    "downloadPdf": "Download PDF",
    "creating": "Creating PDF...",
    "generating": "Generating PDF document...",
    "downloading": "Downloading...",
    "preparing": "Preparing document for print...",
    "success": "PDF downloaded successfully!",
    "error": "Failed to generate PDF",
    "printError": "Failed to prepare document for printing",
    "noCustomer": "No Customer",
    "document": "Document"
  },
  "pdfTemplate": {
    "invoice": "INVOICE",
    "quotation": "QUOTATION",
    "customer": "Customer",
    "timeline": "Timeline",
    "startDate": "Start",
    "endDate": "End",
    "start": "Start:",
    "end": "End:",
    "notSet": "Not set",
    "projectDescription": "Project Description",
    "productsAndMaterials": "Products and Materials",
    "noProductsSpecified": "No products specified",
    "productName": "Product Name",
    "quantity": "Quantity",
    "unit": "Unit",
    "unitPrice": "Unit Price",
    "totalPrice": "Total Price",
    "description": "Description",
    "basePrice": "Base Price",
    "salesPrice": "Sales Price",
    "discount": "Discount",
    "finalPrice": "Final Price",
    "laborAndBillingHours": "Labor and Billing Hours",
    "jobsAndServices": "Jobs and Services",
    "billingRate": "Billing Rate",
    "hours": "Hours",
    "ratePerHour": "Rate/Hour",
    "total": "Total",
    "billableHours": "Billable hours",
    "serviceDescription": "Service Description",
    "hourlyRate": "Hourly Rate",
    "untitledService": "Untitled Service",
    "financialSummary": "Financial Summary",
    "includeVat": "Include VAT (25%)",
    "productsTotal": "Products Total:",
    "servicesTotal": "Services Total:",
    "subtotal": "Subtotal:",
    "salesTax": "Sales Tax",
    "totalAmount": "Total Amount:",
    "termsAndConditions": "Terms and Conditions",
    "paymentDue30Days": "Payment is due within 30 days of invoice date",
    "latePaymentCharges": "Late payments may incur additional charges",
    "pricesInDKK": "All prices are in Danish Kroner (DKK) and include applicable taxes",
    "questionsContact": "For questions regarding this",
    "invoiceLower": "invoice",
    "quotationLower": "quotation",
    "pleaseContactUs": "please contact us",
    "defaultTerms": {
      "payment": "• Payment is due within 30 days of invoice date",
      "latePayment": "• Late payments may incur additional charges",
      "prices": "• All prices are in Danish Kroner (DKK) and include applicable taxes",
      "questions": "• For questions regarding this {type}, please contact us"
    },
    "additionalNotes": "Additional Notes",
    "thankYou": "Thank you for choosing {organizationName}",
    "generatedOn": "Generated on {dateTime}"
  },
  "allOffers": "All Offers",
  "offersOffers": "Offers",
  "sentOffers": "Sent",
  "approvedOffers": "Approved",
  "acceptedOffers": "Accepted",
  "declinedOffers": "Declined",
  "viewAndManageOffers": "View and manage all your offers",
  "allOffersWithStatus": "All offers with \"{{status}}\" status",
  "boardInventorySelector": {
    "title": "Inventory Items",
    "description": "Select products from inventory to include in this offer",
    "selectedItems": "Selected Items",
    "tableHeaders": {
      "purchasePrice": "Purchase Price",
      "salesPrice": "Sales Price",
      "profitMargin": "Profit Margin",
      "product": "Product",
      "unit": "Unit",
      "unitPrice": "Unit Price",
      "quantity": "Quantity",
      "total": "Total",
      "actions": "Actions"
    },
    "noItemsSelected": "No inventory items selected yet. Browse and select items below.",
    "saveChanges": "Save Changes",
    "addItemsFromInventory": "Add Items from Inventory",
    "searchDescription": "Search for items to add to your offer",
    "addItem": "Add Item",
    "searchPlaceholder": "Search inventory items...",
    "addFirstMatch": "Add First Match",
    "refresh": "Refresh",
    "browseItems": "Browse Items",
    "loadingItems": "Loading items...",
    "noItemsFound": "No items found matching \"{{searchTerm}}\"",
    "startTyping": "Start typing to search inventory items",
    "refreshing": "Refreshing...",
    "refreshItems": "Refresh Items",
    "toastMessages": {
      "itemsConnected": "Inventory items successfully connected to offer",
      "itemRemoved": "Item removed from offer",
      "itemsSaved": "Inventory items saved to offer",
      "saveFailed": "Failed to save inventory items"
    }
  },
  "boardLaborSelector": {
    "title": "Billing Hours",
    "description": "Add billable hours using your organization's billing rates",
    "selectedBillingRates": "Selected Billing Rates",
    "newLaborType": "New Labor Type",
    "newLaborDescription": "Create a new labor type with cost price, sales price, and profit margin.",
    "laborName": "Labor Name",
    "laborNamePlaceholder": "e.g., Electrician, Plumber",
    "laborDescription": "Description",
    "descriptionPlaceholder": "Optional description",
    "costPrice": "Cost Price (DKK/hr)",
    "salesPrice": "Sales Price (DKK/hr)",
    "profitMargin": "Profit Margin",
    "profitPerHour": "Profit",
    "cancel": "Cancel",
    "create": "Create",
    "creating": "Creating...",
    "createNewLaborType": "Create New Labor Type",
    "tableHeaders": {
      "purchasePrice": "Purchase Price",
      "salesPrice": "Sales Price",
      "profitMargin": "Profit Margin",
      "billingRate": "Billing Rate",
      "costPrice": "Cost Price",
      "description": "Description",
      "ratePerHour": "Rate/Hour",
      "hours": "Hours",
      "total": "Total",
      "actions": "Actions"
    },
    "noBillingRatesAdded": "No billing rates added yet. Browse and select billing rates below.",
    "saveChanges": "Save Changes",
    "addBillingRates": "Add Billing Rates",
    "searchDescription": "Search for billing rates to add to your offer",
    "searchPlaceholder": "Search billing rates...",
    "addFirstMatch": "Add First Match",
    "refresh": "Refresh",
    "browseItems": "Browse Items",
    "loadingBillingRates": "Loading billing rates...",
    "noBillingRatesFound": "No billing rates found matching \"{{searchTerm}}\"",
    "startTyping": "Start typing to search billing rates",
    "refreshing": "Refreshing...",
    "refreshBillingRates": "Refresh Billing Rates",
    "noDescription": "No description",
    "default": "Default",
    "toastMessages": {
      "hoursConnected": "Billing hours successfully connected to offer",
      "updateFailed": "Failed to update offer with billing hours: {{error}}",
      "offline": "You are currently offline. Some features may be unavailable.",
      "cachedData": "Using cached billing rates data. Refresh when back online.",
      "loadFailed": "Failed to load billing rates. Please try again later.",
      "hoursIncreased": "Increased hours for {{name}}",
      "rateAdded": "Added {{name}} to offer",
      "rateRemoved": "Billing rate removed from offer",
      "ratesSaved": "Billing rates saved to offer",
      "saveRatesFailed": "Failed to save billing rates"
    }
  },
  "inventory": {
    "search": {
      "placeholder": "Search products by name or unit... (Ctrl+F to focus, Esc to clear)",
      "resultsFound": "{{count}} result found",
      "resultsFoundPlural": "{{count}} results found",
      "searchingIn": "Searching in: Product Name, Unit",
      "pressEscToClear": "Press Esc to clear search",
      "clear": "Clear",
      "clearSearchTitle": "Clear search (Esc)"
    },
    "filters": {
      "title": "Filters:",
      "showUnusedOnly": "Show only unused products",
      "showingUnusedProducts": "Showing products not connected to any active job",
      "selectSupplier": "Select Supplier",
      "allSuppliers": "All Suppliers",
      "noSupplier": "No Supplier",
      "filteringNoSupplier": "No Supplier",
      "filteringBySupplier": "Supplier: {{name}}",
      "clearFilters": "Clear Filters",
      "withFiltersApplied": "with filters applied"
    },
    "multiSelect": {
      "enableMultiSelect": "Multi-Select",
      "exitMultiSelect": "Exit Multi-Select",
      "deleteSelected": "Delete Selected",
      "deleting": "Deleting..."
    },
    "form": {
      "productNamePlaceholder": "Product Name",
      "unitPlaceholder": "Unit",
      "pricePlaceholder": "Price",
      "selectSupplier": "Select supplier",
      "noSupplier": "No supplier",
      "addProduct": "Add Product",
      "adding": "Adding..."
    },
    "notice": {
      "title": "Note:",
      "cannotDeleteInUse": "Products that are being used in active jobs cannot be deleted.",
      "removeFromJobsFirst": "You must first remove the product from all jobs before it can be deleted from inventory.",
      "useFilterToShowUnused": "Use the filter above to show only unused products that are safe to delete."
    },
    "table": {
      "headers": {
        "productName": "Product Name",
        "unit": "Unit",
        "price": "Price",
        "supplier": "Supplier",
        "status": "Status",
        "actions": "Actions"
      },
      "status": {
        "inUse": "In Use",
        "available": "Available",
        "unknown": "Unknown"
      },
      "noSupplier": "No supplier"
    },
    "emptyStates": {
      "noProductsFoundSearch": "No products found matching \"{{searchTerm}}\"",
      "tryDifferentKeywords": "Try searching with different keywords or clear the search",
      "noUnusedProducts": "No unused products found",
      "allProductsInUse": "All products are currently being used in active jobs",
      "noProducts": "No products found",
      "addFirstProduct": "Start by adding your first product using the form above"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete",
      "deleting": "Deleting...",
      "save": "Save",
      "cancel": "Cancel",
      "update": "Update",
      "updating": "Updating..."
    },
    "confirmations": {
      "deleteProduct": "Are you sure you want to delete this product?",
      "deleteMultipleProducts": "Are you sure you want to delete the selected products?"
    },
    "toastMessages": {
      "productAdded": "Product added successfully",
      "productUpdated": "Product updated successfully",
      "productDeleted": "Product deleted successfully",
      "addProductFailed": "Failed to add product: {{error}}",
      "updateProductFailed": "Failed to update product: {{error}}",
      "deleteProductFailed": "Failed to delete product: {{error}}",
      "checkConsoleForDetails": "Please check the console for details.",
      "fillAllFields": "Please fill in all fields",
      "cannotDeleteProductInUse": "This product cannot be deleted because it's being used in one or more jobs. Please remove it from all jobs before deleting.",
      "cannotDeleteProductUsedInJobs": "Cannot delete \"{{productName}}\" because it's being used in jobs. Check where it's being used.",
      "bulkDeleteSuccess": "Successfully deleted {{count}} product(s)",
      "partialBulkDeleteSuccess": "Successfully deleted {{count}} out of {{total}} product(s)",
      "cannotDeleteProductsInUse": "Cannot delete products currently in use",
      "bulkDeleteFailed": "Failed to delete some products",
      "bulkDeleteError": "An error occurred during bulk delete"
    }
  },
  "suppliers": {
    "pageTitle": "Suppliers",
    "pageDescription": "Manage your suppliers and vendor relationships",
    "loadingSuppliers": "Loading suppliers...",
    "failedToLoadSuppliers": "Failed to load suppliers data",
    "retry": "Retry",
    "searchSuppliers": "Search suppliers...",
    "addSupplier": "Add Supplier",
    "addNewSupplier": "Add New Supplier",
    "editSupplier": "Edit Supplier",
    "updateSupplier": "Update Supplier",
    "deleteSupplier": "Delete Supplier",
    "supplierName": "Supplier Name",
    "supplierNameRequired": "Supplier name is required",
    "companyName": "Company name",
    "contactPerson": "Contact Person",
    "contactName": "Contact name",
    "email": "Email",
    "emailPlaceholder": "contact@supplier.com",
    "phoneNumber": "Phone Number",
    "phonePlaceholder": "+45 12 34 56 78",
    "website": "Website",
    "websitePlaceholder": "www.supplier.com",
    "address": "Address",
    "addressPlaceholder": "Street address, city",
    "notes": "Notes",
    "notesPlaceholder": "Additional notes about this supplier...",
    "cancel": "Cancel",
    "adding": "Adding...",
    "supplier": "Supplier",
    "contact": "Contact",
    "phone": "Phone",
    "actions": "Actions",
    "suppliersCount": "Suppliers ({{count}})",
    "noSuppliersFound": "No suppliers found matching \"{{searchTerm}}\"",
    "tryDifferentKeywords": "Try searching with different keywords or clear the search",
    "noSuppliers": "No suppliers found",
    "addFirstSupplier": "Start by adding your first supplier using the button above",
    "supplierAddedSuccessfully": "Supplier added successfully",
    "supplierUpdatedSuccessfully": "Supplier updated successfully",
    "supplierDeletedSuccessfully": "Supplier deleted successfully",
    "failedToAddSupplier": "Failed to add supplier",
    "failedToUpdateSupplier": "Failed to update supplier",
    "failedToDeleteSupplier": "Failed to delete supplier",
    "cannotDeleteSupplierWithInventory": "Cannot delete supplier with associated inventory items",
    "selectMultiple": "Select Multiple",
    "exitSelectMode": "Exit Select Mode",
    "noSuppliersSelected": "No suppliers selected",
    "confirmDeleteMultiple": "Are you sure you want to delete {{count}} suppliers?",
    "suppliersDeletedSuccessfully": "{{count}} suppliers deleted successfully",
    "someSuppliersDeletionFailed": "{{count}} supplier deletions failed",
    "failedToDeleteSuppliers": "Failed to delete suppliers"
  },
  "timeRegistration": {
    "title": "Time Registration",
    "description": "Manage your work hours and attendance",
    "pageDescription": "Log and track work hours for employees and projects.",
    "status": {
      "active": "Active",
      "live": "Live"
    },
    "sections": {
      "manualEntry": "Manual Entry",
      "manualTimeEntry": "Manual Time Entry",
      "clockInOut": "Clock In/Out",
      "calendarView": "Calendar View",
      "quickStats": "Quick Stats",
      "weeklySummary": "Weekly Summary",
      "weekLookup": "Week Lookup"
    },
    "badges": {
      "quickAdd": "Quick Add",
      "live": "Live",
      "overview": "Overview"
    },
    "loading": {
      "date": "Loading date...",
      "time": "Loading time..."
    },
    "error": {
      "message": "Error: "
    },
    "overview": {
      "title": "Time Overview",
      "yearPlaceholder": "Year",
      "weekPlaceholder": "Week",
      "weekLabel": "Week {{week}}",
      "tabs": {
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly"
      },
      "timeLabels": {
        "hoursToday": "hours today",
        "hoursThisWeek": "hours this week",
        "hoursThisMonth": "hours this month"
      }
    },
    "userFilter": {
      "loading": "Loading...",
      "filterByUser": "Filter by user",
      "allUsers": "All Users"
    },
    "entryMode": {
      "singleDay": "Single Day",
      "dateRange": "Date Range"
    },
    "dateRange": {
      "startDate": "Start Date",
      "endDate": "End Date",
      "selectedDates": "Selected Dates ({{count}} days):",
      "moreLabel": "+{{count}} more..."
    },
    "manualEntry": {
      "entryMode": "Entry Mode",
      "date": "Date",
      "type": "Type",
      "holidayDetails": "+ Holiday Details",
      "holidayType": "Holiday Type",
      "start": "Start",
      "end": "End",
      "duration": "Duration:",
      "daysMultiplier": "days ×",
      "total": "total",
      "saving": "Saving...",
      "save": "Save",
      "entries": "Entries",
      "entry": "Entry",
      "errors": {
        "endTimeAfterStart": "End time must be after start time",
        "selectHolidayType": "Please select a holiday type",
        "cannotAddFutureWork": "Cannot add work entries in the future ({{date}})",
        "failedToSave": "Failed to save time entries"
      },
      "success": {
        "multipleEntriesSaved": "{{count}} time entries saved successfully!",
        "entrySaved": "Time entry saved successfully!",
        "entrySubmitted": "Time entry for {{workType}} submitted for approval"
      }
    },
    "weeklySummary": {
      "thisWeek": "This Week",
      "lastWeek": "Last Week",
      "current": "Current",
      "previous": "Previous",
      "workTypes": {
        "work": "Work",
        "sick": "Sick",
        "holiday": "Holiday"
      },
      "progressTo40h": "Progress to 40h",
      "trends": {
        "upFromLastWeek": "Up from last week",
        "downFromLastWeek": "Down from last week",
        "sameAsLastWeek": "Same as last week"
      }
    },
    "weekLookup": {
      "selectDate": "Select a date",
      "currentWeek": "Current Week",
      "workTypes": {
        "work": "Work",
        "sick": "Sick",
        "holiday": "Holiday",
        "total": "Total"
      },
      "stats": {
        "days": "Days",
        "avg": "Avg"
      },
      "noData": {
        "title": "No Data",
        "message": "No entries this week"
      },
      "dailyHours": "Daily Hours",
      "noWorkingDays": "No working days"
    },
    "quickStats": {
      "today": "Today",
      "thisWeek": "This Week",
      "thisMonth": "This Month",
      "overtime": "Overtime",
      "complete": "Complete",
      "remaining": "remaining",
      "targetReached": "Target reached",
      "toTarget": "to target",
      "avg": "Avg"
    },
    "clock": {
      "loading": "Loading...",
      "working": "Working",
      "elapsed": "elapsed",
      "clockOut": "Clock Out",
      "clockIn": "Clock In",
      "success": {
        "clockedIn": "Successfully clocked in!",
        "clockedOut": "Successfully clocked out!"
      },
      "errors": {
        "clockOutFailed": "Failed to clock out. Please try again."
      }
    },
    "recentEntries": {
      "title": "Recent Entries",
      "today": "Today",
      "yesterday": "Yesterday",
      "noEntries": "No time entries yet",
      "noEntriesDescription": "Start tracking your time to see entries here",
      "confirmDelete": "Are you sure you want to delete this entry?",
      "deleteSuccess": "Entry deleted successfully",
      "deleteError": "Failed to delete entry",
      "type": "Type",
      "status": "Status",
      "holidayType": "Holiday Type"
    },
    "insights": {
      "title": "Productivity Insights",
      "workStreak": "Work Streak",
      "daysLabel": "days",
      "avgDaily": "Avg Daily",
      "efficiency": "Efficiency",
      "bestDay": "Best Day",
      "weeklyTrend": "Weekly Trend",
      "steady": "Steady",
      "totalDaysWorked": "Total Days Worked",
      "streakMessages": {
        "startStreak": "Start your streak today!",
        "building": "Building momentum!",
        "keepGoing": "Keep it going!",
        "onFire": "You're on fire! 🔥",
        "unstoppable": "Unstoppable! 🚀"
      },
      "days": {
        "sunday": "Sunday",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday"
      }
    },
    "quickActions": {
      "keyboardShortcuts": "Keyboard Shortcuts",
      "clockInOut": "Clock In/Out",
      "manualEntry": "Manual Entry",
      "showShortcuts": "Show Shortcuts",
      "addEntry": "Add Entry",
      "viewCalendar": "View Calendar"
    },
    "progressRing": {
      "readyToStart": "Ready to start your day?",
      "todayProgress": "Today's Progress",
      "extra": "extra",
      "messages": {
        "overtime": "Great work! Take a break soon",
        "complete": "Goal achieved! 🎉",
        "almostThere": "Almost there!",
        "halfwayThere": "Halfway through!",
        "goodStart": "Good start!",
        "justStarted": "Just getting started",
        "readyToStart": "Ready to start your day?"
      }
    }
  },
  "map": {
    "title": "Job Placeringer",
    "subtitle": "Se alle job placeringer på kortet",
    "filterByDate": "Filter by Date",
    "from": "From",
    "to": "To",
    "clearFilters": "Clear Filters",
    "jobLocations": "Job Locations",
    "mapView": "Map View",
    "show": "Show",
    "map": "Map",
    "list": "List",
    "noLocationsMatch": "No locations match your filter criteria",
    "start": "Start",
    "noStartDate": "No start date",
    "noOrganization": "Ingen organisation fundet. Kontakt venligst support."
  },
  "agreements": {
    "daily": "Daily",
    "weekly": "Weekly",
    "biweekly": "Bi-weekly",
    "monthly": "Monthly",
    "quarterly": "Quarterly",
    "annually": "Annually",
    "service": "Service",
    "installation": "Installation",
    "callOut": "Call Out",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "assigned": "Assigned",
    "unassigned": "Unassigned",
    "noAgreementsToday": "No recurring service agreements scheduled for today",
    "noAgreementsTomorrow": "No recurring service agreements scheduled for tomorrow",
    "allClearToday": "All clear for today!",
    "allClearTomorrow": "Nothing scheduled tomorrow",
    "noAgreementsTodayDesc": "No recurring service agreements scheduled for today.",
    "noAgreementsTomorrowDesc": "No recurring service agreements scheduled for tomorrow.",
    "viewAllJobs": "View All Jobs",
    "allServiceAgreements": "All Service Agreements",
    "myServiceAgreements": "My Service Agreements",
    "my": "My",
    "all": "All",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "from": "From",
    "until": "Until"
  },
  "materials": {
    "loading": "Loading materials...",
    "loadingDescription": "Please wait while we fetch the latest materials",
    "noMaterials": "No materials added yet",
    "noMaterialsDescription": "Click \"Add Material\" to track materials for this job",
    "updatingMaterials": "Updating materials...",
    "materialName": "Material Name",
    "fromInventoryNote": "From inventory - name cannot be changed",
    "quantity": "Quantity",
    "pricePerUnit": "Price per Unit (DKK)",
    "setInInventory": "Set in inventory",
    "description": "Description",
    "totalCost": "Total Cost",
    "currency": "DKK",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "fromInventory": "From Inventory",
    "qty": "Qty",
    "unitPrice": "Unit Price",
    "total": "Total",
    "editMaterial": "Edit material",
    "removeMaterial": "Remove material from job (will remain in any invoices)",
    "materialCost": "Material Cost",
    "totalMaterialsCost": "Total Materials Cost",
    "nameRequired": "Material name is required",
    "validQuantityRequired": "Valid quantity is required",
    "validPriceRequired": "Valid price is required",
    "updatedSuccessfully": "Material updated successfully",
    "updateFailed": "Failed to update material",
    "materialNotFound": "Material not found",
    "removedFromJob": "Material removed from job and returned to inventory (preserved in any existing invoices)",
    "deleteFailed": "Failed to delete material"
  },
  "billingTab": {
    "title": "Billing & Inventory Upload",
    "description": "Upload CSV files or scan images to add inventory items to your organization and automatically add them as materials to this job",
    "downloadTemplate": "Download Template",
    "csvUploadTitle": "Upload Inventory CSV",
    "csvUploadDescription": "Upload a CSV file with columns: productName, unit, price, amount. Items will be added to your inventory and automatically included as materials for this job. Existing items with the same name will be skipped.",
    "defaultSupplier": "Default Supplier (Optional)",
    "selectSupplier": "Select supplier (optional)",
    "noSupplier": "No Supplier",
    "supplierNote": "This supplier will be assigned to items without a supplier specified in the CSV",
    "selectCsvFile": "Select CSV File",
    "csvFormatTitle": "CSV Format Requirements:",
    "csvFormat": {
      "headers": "First row should contain headers: productName, unit, price, amount",
      "productName": "productName: Name of the product/material",
      "unit": "unit: Unit of measurement (e.g., piece, gallon, meter, box)",
      "price": "price: Price per unit (numeric value)",
      "amount": "amount: Quantity/amount of the item (numeric value)",
      "autoAdd": "Items will be added to inventory and job materials automatically",
      "ignored": "Additional columns will be ignored"
    },
    "preview": "Preview ({{count}} items)",
    "productName": "Product Name",
    "unit": "Unit",
    "price": "Price",
    "amount": "Amount",
    "supplier": "Supplier",
    "moreItems": "... and {{count}} more items",
    "uploadToInventory": "Upload to Inventory",
    "uploading": "Uploading...",
    "uploadCompleted": "Upload Completed Successfully!",
    "itemsProcessed": "Items processed: {{count}}",
    "itemsSkipped": "Items skipped (already exist): {{count}}",
    "itemsWithErrors": "Items with errors: {{count}}",
    "uploadErrors": "Upload Errors:",
    "aiTitle": "AI-Powered Invoice Analysis",
    "aiDescription": "Upload an image of an invoice, receipt, or material list and our AI will automatically extract inventory items. Items will be added to your inventory and automatically included as materials for this job. The AI analyzes the image to identify product names, units, prices, and quantities with high accuracy.",
    "businessRequired": "Business License Required",
    "businessLicenseRequired": "Business License Required",
    "businessLicenseDescription": "AI-Powered Invoice Analysis is an advanced feature available exclusively to Business License holders. Upgrade your license to unlock:",
    "features": {
      "aiScanning": "AI Invoice Scanning - Automatic data extraction from images",
      "geminiAi": "Google Gemini 2.0 Flash - Latest AI technology for high accuracy", 
      "editableResults": "Editable Results - Review and modify AI-extracted data before upload",
      "autoIntegration": "Automatic Integration - Seamless addition to inventory and job materials"
    },
    "currentLicense": "Current License: {{license}} License",
    "upgradeNote": "Upgrade to Business for AI features",
    "supplierForScanned": "Default Supplier for Scanned Items (Optional)",
    "supplierForScannedNote": "This supplier will be assigned to all scanned items",
    "selectImageFile": "Select Image File",
    "aiTips": "AI Analysis Tips for Best Results:",
    "aiTipsContent": {
      "clearImages": "Use clear, high-resolution images for better AI accuracy",
      "readableText": "Ensure text is readable and well-lit (avoid shadows or glare)",
      "supportedFormats": "Supported formats: JPEG, PNG, WebP (max 10MB)",
      "bestWith": "Works best with invoices, receipts, purchase orders, or material lists",
      "variousLayouts": "AI can handle various layouts and formats automatically",
      "reviewData": "Always review extracted data before uploading - AI is very accurate but not perfect"
    },
    "selectedImage": "Selected Image: {{name}}",
    "imageSize": "Size: {{size}} MB",
    "imageType": "Type: {{type}}",
    "analyzeWithAi": "Analyze with AI",
    "aiAnalyzing": "AI Analyzing Image...",
    "clear": "Clear",
    "aiExtracted": "AI Extracted Items ({{count}} found)",
    "reviewEdit": "Review and Edit:",
    "reviewEditDescription": "The AI has extracted the following items from your image. You can edit any values before adding them to your inventory. Click on any field to modify it.",
    "productNamePlaceholder": "Product name",
    "unitPlaceholder": "Unit",
    "pricePlaceholder": "0.00",
    "amountPlaceholder": "0",
    "remove": "Remove",
    "itemsReady": "{{count}} items ready for upload",
    "addToInventory": "Add to Inventory & Job Materials",
    "scanningErrors": "Scanning Errors:",
    "howItWorks": "How it Works",
    "csvMethod": "CSV Upload Method",
    "csvSteps": {
      "download": "Download Template",
      "downloadDesc": "Get the CSV template with the correct format and sample data.",
      "fill": "Fill Your Data",
      "fillDesc": "Add your inventory items following the productName, unit, price, amount format.",
      "upload": "Upload & Process",
      "uploadDesc": "Upload the file and the system will add items to your inventory automatically."
    },
    "aiMethod": "AI-Powered Image Analysis",
    "aiSteps": {
      "uploadImage": "Upload Image",
      "uploadImageDesc": "Select a clear image of an invoice, receipt, or material list (JPEG, PNG, WebP).",
      "aiAnalysis": "AI Analysis", 
      "aiAnalysisDesc": "AI intelligently analyzes the image and extracts product details with high accuracy.",
      "editConfirm": "Edit & Confirm",
      "editConfirmDesc": "Review and edit extracted data, then add items to your inventory and job materials automatically."
    }
  },
  "calendar": {
    "title": "Calendar",
    "today": "Today",
    "previous": "Previous",
    "next": "Next",
    "month": "Month",
    "week": "Week",
    "day": "Day",
    "agenda": "Agenda",
    "allDay": "All Day",
    "noEventsInRange": "No work entries scheduled for this time period.",
    "filters": "Filters",
    "teamMember": "Team Member",
    "selectTeamMember": "Select team member",
    "allTeamMembers": "All Team Members",
    "activeJob": "Active Job",
    "selectJob": "Select job",
    "allJobs": "All Jobs",
    "statistics": "Statistics",
    "entries": "entries",
    "users": "users",
    "quickView": "Quick View",
    "entryTypes": "Entry Types",
    "work": "Work",
    "holiday": "Holiday", 
    "overtime": "Overtime",
    "transportation": "Transportation",
    "tasks": "Tasks",
    "exportToGoogleCalendar": "Export to Google Calendar",
    "exportCalendar": "Export Calendar",
    "weekNumber": "Week {{number}}",
    "noUsersAvailable": "No users available",
    "unnamedUser": "(Unnamed User)",
    "unassigned": "Unassigned",
    "manageWorkEntriesAndSchedules": "Manage work entries and track team schedules",
    "refresh": "Refresh",
    "teamCalendar": "Team Calendar",
    "fetchingData": "Fetching your work entries and schedule data..."
  }
};

export const da = {
  "loading": "Indlæser...",
  "save": "Gem",
  "cancel": "Annuller", 
  "editDates": "Rediger Datoer",
  "projectStartDate": "Projekt Start Dato",
  "projectEndDate": "Projekt Slut Dato",
  "editDatesNotAvailable": "Dataredigering ikke tilgængelig",
  "startDateNotEditable": "Startdato kan ikke redigeres",
  "endDateNotEditable": "Slutdato kan ikke redigeres", 
  "startDateReadOnly": "Startdato er skrivebeskyttet",
  "endDateReadOnly": "Slutdato er skrivebeskyttet",
  "siteProjectStartDate": "Projekt Startdato",
  "siteProjectEndDate": "Projekt Slutdato",
  "jobDetailsFromQuote": "Job Detaljer Fra Tilbud",
  "noJobDetailsAvailable": "Ingen Job Detaljer Tilgængelige",
  "jobNotFromQuote": "Dette job er ikke oprettet fra et tilbud",
  "errorLoadingJobDetails": "Fejl Ved Indlæsning Af Job Detaljer",
  "serviceAgreementTitle": "Serviceaftale",
  "serviceAgreementDescription": "Konfigurer dette job som en tilbagevendende serviceaftale med tildelt teammedlem",
  "serviceAgreementMakeRecurring": "Gør dette til en tilbagevendende serviceaftale",
  "serviceAgreementServiceFrequency": "Service Frekvens",
  "serviceAgreementServiceSchedule": "Service Tidsplan",
  "serviceAgreementDaysOfWeek": "Dage i Ugen",
  "frequenciesDaily": "Dagligt",
  "frequenciesWeekly": "Ugentligt",
  "frequenciesBiweekly": "Hver anden uge",
  "frequenciesMonthly": "Månedligt",
  "frequenciesQuarterly": "Kvartalsvis",
  "frequenciesAnnually": "Årligt",
  "daysOfWeekMon": "Man",
  "daysOfWeekTue": "Tir", 
  "daysOfWeekWed": "Ons",
  "daysOfWeekThu": "Tor",
  "daysOfWeekFri": "Fre",
  "daysOfWeekSat": "Lør",
  "daysOfWeekSun": "Søn",
  "daysOfWeekMonday": "Mandag",
  "daysOfWeekTuesday": "Tirsdag",
  "daysOfWeekWednesday": "Onsdag", 
  "daysOfWeekThursday": "Torsdag",
  "daysOfWeekFriday": "Fredag",
  "daysOfWeekSaturday": "Lørdag",
  "daysOfWeekSunday": "Søndag",
  "nav": {
    "overview": "Oversigt",
    "reports": "Rapporter",
    "dashboard": "Dashboard",
    "jobs": "Job",
    "quotes": "Tilbud",
    "activity": "Aktivitet",
    "customers": "Kunder",
    "map": "Kort",
    "calendar": "Kalender",
    "inventory": "Produkt lager",
    "suppliers": "Leverandører",
    "billing": "Fakturering",
    "settings": "Indstillinger",
    "timeRequests": "Tidsanmodninger",
    "timeRegistration": "Tidsregistering",
    "admin": "Admin",
    "adminPage": "Admin Side",
    "serviceAgreements": "Serviceaftaler"
  },
  "invoices": {
    "title": "Fakturaer",
    "createNew": "Opret Ny Faktura",
    "invoice": "Faktura",
    "issueDate": "Udstedelsesdato",
    "dueDate": "Forfaldsdato",
    "status": "Status",
    "amount": "Beløb",
    "view": "Vis",
    "noInvoices": "Ingen Fakturaer Endnu",
    "createFirstInvoice": "Opret din første faktura for at begynde at fakturere for dette job",
    "confirmCreate": "Opret Ny Faktura",
    "confirmCreateDescription": "Dette vil oprette en ny faktura for dette job. Du kan redigere detaljerne, før du sender den til kunden.",
    "importantNote": "Vigtig Bemærkning",
    "includesUnbilled": "Denne faktura vil inkludere alle ikke-fakturerede varer tilknyttet dette job.",
    "cancel": "Annuller",
    "creating": "Opretter...",
    "createInvoice": "Opret Faktura",
    "deleteInvoice": "Slet Faktura",
    "deleteWarning": "Er du sikker på, at du vil slette denne kladde-faktura? Denne handling kan ikke fortrydes.",
    "invoiceNumber": "Fakturanummer",
    "date": "Dato",
    "totalAmount": "Totalbeløb",
    "delete": "Slet",
    "deleting": "Sletter...",
    "onlyDraftDelete": "Kun fakturakladder kan slettes",
    "searchInvoices": "Søg fakturaer...",
    "viewAndManageAll": "Se og administrer alle dine fakturaer",
    "allInvoices": "Alle Fakturaer",
    "draftInvoices": "Kladde Fakturaer",
    "sentInvoices": "Sendte Fakturaer",
    "paidInvoices": "Betalte Fakturaer",
    "overdueInvoices": "Forfaldne Fakturaer",
    "allInvoicesWithStatus": "Alle fakturaer med \"{{status}}\" status",
    "overdueDescription": "Fakturaer der er overskredet deres forfaldsdato",
    "customer": "Kunde",
    "job": "Job",
    "organization": "Organisation",
    "remaining": "Resterende",
    "viewDetails": "Se detaljer",
    "noInvoicesFound": "Ingen fakturaer fundet",
    "noInvoicesMatchSearch": "Ingen fakturaer matcher din søgning efter \"{{searchTerm}}\"",
    "noInvoicesYet": "Der er ingen {{status}} fakturaer endnu",
    "unnamedCustomer": "Unavngivet Kunde",
    "draft": "Kladde",
    "sent": "Sendt",
    "paid": "Betalt",
    "overdue": "Forfalden",
    "all": "Alle",
    "drafts": "Kladder",
    "create": {
      "jobSelection": "Job Valg",
      "jobSelectionDesc": "Vælg jobbet til denne faktura",
      "selectJob": "Vælg et job",
      "jobDetails": "Job Detaljer",
      "customerInformation": "Kundeinformation",
      "customerInformationDesc": "Kundedetaljer til fakturaen",
      "selectCustomer": "Vælg Kunde (Valgfrit)",
      "selectCustomerPlaceholder": "Vælg en kunde eller indtast manuelt",
      "selectOrEnterCustomer": "Vælg en eksisterende kunde eller indtast nye kundeoplysninger manuelt",
      "clearSelection": "Ryd valg",
      "customerName": "Kundenavn",
      "customerNamePlaceholder": "Indtast kundenavn",
      "customerEmail": "Kunde Email",
      "customerEmailPlaceholder": "kunde@eksempel.dk",
      "customerAddress": "Kundeadresse",
      "customerAddressPlaceholder": "Indtast kundeadresse",
      "invoiceDetails": "Fakturaoplysninger",
      "invoiceDetailsDesc": "Indstil fakturadatoer og yderligere information",
      "notes": "Bemærkninger",
      "notesPlaceholder": "Yderligere bemærkninger til fakturaen",
      "invoiceItems": "Fakturaposter",
      "invoiceItemsDesc": "Poster der skal inkluderes i fakturaen",
      "addItem": "Tilføj Post",
      "noItemsYet": "Ingen poster tilføjet endnu. Vælg et job for at auto-udfylde poster eller tilføj dem manuelt.",
      "description": "Beskrivelse",
      "descriptionPlaceholder": "Post beskrivelse",
      "quantity": "Antal",
      "rate": "Pris",
      "total": "Total",
      "required": "*"
    },
    "detail": {
      "backToInvoices": "Tilbage til Fakturaer",
      "sendEmail": "Send Email",
      "downloadPdf": "Download PDF",
      "viewAndManageDetails": "Se og administrer fakturadetaljer",
      "viewAndManageDetailsWithBranding": "Se og administrer fakturadetaljer med firmabranding",
      "sendInvoice": "Send Faktura",
      "setFixedCost": "Sæt Fast Pris",
      "markAsPaid": "Marker som Betalt",
      "recordPayment": "Registrer Betaling",
      "delete": "Slet",
      "status": "Status",
      "invoiceDetails": "Fakturadetaljer",
      "pdfPreview": "PDF Forhåndsvisning",
      "payments": "Betalinger",
      "settings": "Indstillinger",
      "customerInformation": "Kundeinformation",
      "invoiceItems": "Fakturaposter",
      "item": "Vare",
      "qty": "Antal",
      "rate": "Pris",
      "hours": "Timer",
      "workPerformed": "Udført Arbejde",
      "customerText": "Kundetekst",
      "customerTextTitle": "Kundetekst",
      "customerTextPlaceholder": "Indtast specielle instruktioner eller noter til kunden...",
      "customerTextDescription": "Denne tekst vil blive vist på fakturaen og være synlig for kunden.",
      "noCustomerText": "Ingen kundetekst tilføjet",
      "noCustomerTextDescription": "Klik på Rediger for at tilføje specielle instruktioner eller noter til kunden.",
      "customerTextCannotBeModified": "Kundetekst kan ikke ændres for betalte fakturaer.",
      "customerTextTemplates": {
        "title": "Kundetekst Skabeloner",
        "description": "Administrer genanvendelige tekstskabeloner til dine fakturaer.",
        "refresh": "Opdater skabeloner",
        "createTemplate": "Opret Skabelon",
        "loading": "Indlæser skabeloner...",
        "noTemplates": "Ingen skabeloner fundet",
        "createFirstTemplate": "Opret din første skabelon for at komme i gang.",
        "isDefault": "Standard",
        "useTemplate": "Brug Skabelon",
        "editTemplate": "Rediger Skabelon",
        "templateName": "Skabelonnavn",
        "templateNamePlaceholder": "f.eks. Standardbetingelser",
        "templateContent": "Skabelonindhold",
        "templateContentPlaceholder": "Indtast tekstindholdet...",
        "charactersCount": "tegn",
        "setAsDefault": "Sæt som standardskabelon",
        "creating": "Opretter...",
        "failedToLoad": "Kunne ikke indlæse skabeloner",
        "nameRequired": "Skabelonnavn og indhold er påkrævet",
        "maxTemplatesReached": "Maksimalt antal skabeloner nået (3)",
        "templateCreated": "Skabelon oprettet succesfuldt",
        "failedToCreate": "Kunne ikke oprette skabelon",
        "templateUpdated": "Skabelon opdateret succesfuldt",
        "failedToUpdate": "Kunne ikke opdatere skabelon",
        "templateDeleted": "Skabelon slettet succesfuldt",
        "failedToDelete": "Kunne ikke slette skabelon",
        "deleteConfirmation": {
          "title": "Slet Skabelon",
          "message": "Er du sikker på, at du vil slette skabelonen \"{{templateName}}\"?",
          "warning": "Denne handling kan ikke fortrydes.",
          "cancelButton": "Annuller",
          "confirmButton": "Slet"
        }
      },
      "templates": "Skabeloner",
      "notes": "Bemærkninger",
      "invoiceSummary": "Faktura Oversigt",
      "issueDate": "Udstedelsesdato",
      "dueDate": "Forfaldsdato",
      "subtotal": "Subtotal",
      "tax": "Moms",
      "total": "Total",
      "paid": "Betalt",
      "balanceDue": "Resterende Saldo",
      "paymentHistory": "Betalingshistorik",
      "setFixedCostOverride": "Sæt Fast Pris Override",
      "replaceAllItems": "Erstat alle nuværende fakturaposter med en enkelt fast pris. Dette vil oprette en forenklet faktura med én linjepost til dit angivne beløb.",
      "fixedCostLabel": "Fast Pris Beløb (DKK)",
      "fixedCostDescription": "Beskrivelse (Valgfri)",
      "describeFixedCost": "Beskriv hvad denne faste pris dækker",
      "applyFixedCost": "Anvend Fast Pris",
      "applying": "Anvender...",
      "cancel": "Annuller",
      "unknownCustomer": "Ukendt kunde",
      "paymentProgress": "Betalingsfremskridt",
      "goToPayments": "Gå til Betalinger",
      "noPaymentsRecorded": "Ingen betalinger registreret endnu",
      "goToPaymentsTab": "Gå til \"Betalinger\" fanen for at registrere en betaling",
      "invoiceFullyPaid": "Faktura Fuldt Betalt",
      "invoiceFullyPaidDesc": "Denne faktura er blevet fuldt betalt af kunden.",
      "fullBalance": "Fuld Saldo",
      "maximum": "Maksimum:",
      "remainingAfterPayment": "Resterende efter betaling:",
      "selectPaymentMethodTab": "Vælg betalingsmetode",
      "optionalField": "Valgfri",
      "accountEndingPlaceholder": "Konto der ender på... eller banknavn",
      "referenceNumberGeneral": "Referencenummer",
      "checkNumber": "Checknummer",
      "wireReference": "Overførselsreference",
      "transactionId": "Transaktions-ID",
      "referenceNumberPlaceholder": "Referencenummer",
      "additionalNotesPlaceholder": "Yderligere bemærkninger om denne betaling",
      "currentBalance": "Nuværende Saldo",
      "newBalance": "Ny Saldo",
      "invoiceWillBeMarkedPaid": "Faktura vil blive markeret som BETALT",
      "addingPayment": "Tilføjer Betaling...",
      "addPayment": "Tilføj Betaling",
      "clearForm": "Ryd Formular",
      "payment": "betaling",
      "method": "Metode:",
      "reference": "Reference:",
      "account": "Konto:",
      "note": "Bemærkning:",
      "noPaymentsRecordedTitle": "Ingen Betalinger Registreret",
      "noPaymentsRecordedDesc": "Der er ikke blevet registreret nogen betalinger for denne faktura endnu.",
      "useFormToRecord": "Brug formularen til venstre til at registrere din første betaling.",
      "paymentStatistics": "Betalingsstatistik",
      "totalPaid": "Samlet Betalt",
      "paymentMethodsUsed": "Betalingsmetoder Brugt:",
      "invoiceSettings": "Fakturaindstillinger",
      "paymentDetails": "Betalingsdetaljer",
      "recordPaymentDesc": "Registrer en betaling modtaget for denne faktura",
      "paymentAmount": "Betalingsbeløb",
      "paymentMethod": "Betalingsmetode",
      "paymentDate": "Betalingsdato",
      "paymentReference": "Betalingsreference (Valgfri)",
      "paymentNotes": "Betalingsbemærkninger (Valgfri)",
      "bankTransfer": "Bankoverførsel",
      "cash": "Kontant",
      "check": "Check",
      "creditCard": "Kreditkort",
      "other": "Andet",
      "recordPaymentButton": "Registrer Betaling",
      "recording": "Registrerer...",
      "invoicePreview": "Faktura Forhåndsvisning",
      "downloadPdf": "Download PDF",
      "previewInvoice": "Forhåndsvis Faktura",
      "loading": "Indlæser...",
      "close": "Luk",
      "taxSettings": "Momsindstillinger",
      "enableTax": "Aktiver Moms",
      "taxRate": "Momssats (%)",
      "save": "Gem",
      "saving": "Gemmer...",
      "draftInvoice": "Kladde Faktura",
      "edit": "Rediger",
      "saveChanges": "Gem Ændringer",
      "workPerformed": "Udført Arbejde",
      "fixedCostDialog": {
        "title": "Indstil Fast Pris Override",
        "description": "Erstat alle nuværende faktura elementer med en enkelt fast pris. Dette vil oprette en forenklet faktura med én linje til dit specificerede beløb.",
        "amount": "Fast Pris Beløb (DKK)",
        "amountPlaceholder": "0.00",
        "costDescription": "Beskrivelse (Valgfri)",
        "descriptionPlaceholder": "Beskriv hvad denne faste pris dækker",
        "cancel": "Annuller",
        "applyFixedCost": "Anvend Fast Pris",
        "applying": "Anvender...",
        "costBreakdownPreview": "Omkostningsopgørelse Forhåndsvisning",
        "fixedCost": "Fast Pris:",
        "tax": "Moms",
        "total": "Total:",
        "currentTotal": "Nuværende total:"
      },
      "previewModal": {
        "title": "Faktura Forhåndsvisning",
        "description": "Forhåndsvis hvordan din faktura vil se ud når den printes eller downloades som PDF",
        "closePreview": "Luk Forhåndsvisning",
        "print": "Print",
        "downloadPdf": "Download PDF",
        "livePreview": "Live forhåndsvisning af faktura",
        "exit": "Afslut",
        "fullscreen": "Fuldskærm",
        "previewError": "Forhåndsvisningsfejl",
        "exitFullscreen": "Afslut Fuldskærm",
        "generatePdfError": "Kunne ikke generere PDF",
        "generatingPdf": "Genererer PDF... Dette kan tage et øjeblik.",
        "downloadSuccess": "Faktura PDF downloadet med succes!",
        "downloadError": "Kunne ikke downloade PDF:",
        "printError": "Tillad venligst pop-ups for at printe fakturaen",
        "previewLoadError": "Kunne ikke indlæse PDF forhåndsvisning. Prøv venligst at opdatere eller downloade PDF'en direkte.",
        "unknownError": "Ukendt fejl",
        "invoice": "Faktura"
      },
      "paymentDialog": {
        "title": "Tilføj Betalingsregistrering",
        "description": "Registrer en betaling modtaget fra klienten. Dette vil opdatere fakturasaldo og betalingshistorik.",
        "paymentAmount": "Betalingsbeløb",
        "remainingBalance": "Resterende Saldo",
        "paymentMethod": "Betalingsmetode",
        "selectPaymentMethod": "Vælg betalingsmetode",
        "paymentDate": "Betalingsdato",
        "referenceNumber": "Referencenummer",
        "referenceNumberPlaceholder": "Transaktions ID, Check nummer, osv.",
        "bankAccount": "Bankkonto",
        "bankAccountPlaceholder": "Konto slutter på...",
        "notes": "Bemærkninger",
        "notesPlaceholder": "Yderligere bemærkninger om denne betaling",
        "optional": "Valgfri",
        "paymentSummary": "Betalingsoversigt",
        "newBalance": "Ny Saldo",
        "invoiceWillBePaid": "Faktura vil blive markeret som BETALT",
        "cancel": "Annuller",
        "addPayment": "Tilføj Betaling",
        "addingPayment": "Tilføjer Betaling..."
      },
      "tabs": {
        "payments": {
          "recordNewPayment": "Registrer Ny Betaling",
          "balance": "Saldo",
          "paymentPrefilledNotice": "Betalingsbeløbet er blevet forudfyldt med hele den resterende saldo. Du kan justere det efter behov.",
          "paymentMethods": {
            "bankTransfer": "Bankoverførsel",
            "cash": "Kontant",
            "creditCard": "Kreditkort",
            "debitCard": "Debetkort",
            "check": "Check",
            "paypal": "PayPal",
            "mobilepay": "MobilePay",
            "wireTransfer": "Bankoverførsel",
            "cryptocurrency": "Kryptovaluta",
            "other": "Andet"
          }
        }
      },
      "settingsTab": {
        "invoiceSettings": "Faktura Indstillinger",
        "invoiceStatus": "Fakturastatus",
        "currentStatus": "Nuværende Status",
        "selectStatus": "Vælg status",
        "statusChangeDesc": "Skift status for denne faktura. Dette vil være synligt for dit team.",
        "statusDescriptions": {
          "cancelled": "Annulleret",
          "notSentToCustomer": "Ikke sendt til kunde",
          "invoiceSentToCustomer": "Faktura sendt til kunde",
          "fullyPaidByCustomer": "Fuldt betalt af kunde",
          "paymentDeadlinePassed": "Betalingsfrist overskredet",
          "invoiceCancelledShort": "Faktura annulleret",
          "draftDesc": "Kladde fakturaer er kun synlige for dit team og ikke sendt til kunder.",
          "sentDesc": "Sendt status indikerer at fakturaen er blevet leveret til kunden og betaling forventes.",
          "paidDesc": "Betalt status indikerer at denne faktura er fuldt afregnet af kunden.",
          "overdueDesc": "Forfalden status indikerer at betalingsfristen er overskredet og du skal muligvis følge op med kunden.",
          "cancelledDesc": "Annulleret status indikerer at denne faktura ikke længere er gyldig og vil ikke blive talt med i rapporter."
        },
        "taxSettings": "Momsindstillinger",
        "enableTax": "Aktiver Moms",
        "applyTaxToInvoice": "Anvend moms på denne faktura",
        "taxRate": "Momssats (%)",
        "enterTaxRate": "Indtast momssats",
        "commonTaxRates": "Almindelige satser: 25% (Danmark), 20% (UK), 19% (Tyskland)",
        "currencySettings": "Valutaindstillinger",
        "currency": "Valuta",
        "selectCurrency": "Vælg valuta",
        "currencyUpdateDesc": "Dette vil opdatere alle beløb vist i fakturaen",
        "previewChanges": "Forhåndsvis Ændringer",
        "newTotal": "Ny Total",
        "invoiceSettingsUpdate": "Faktura Indstillinger Opdatering",
        "changesWillRecalculate": "Ændringer vil genberegne alle faktura totaler og beløb",
        "updating": "Opdaterer...",
        "updateSettings": "Opdater Indstillinger",
        "settingsCannotBeModified": "Indstillinger kan ikke ændres for betalte fakturaer"
      },
      "activityLog": {
        "title": "Aktivitetslog",
        "loading": "Indlæser aktiviteter...",
        "noActivity": "Ingen aktivitet registreret",
        "noActivityDesc": "Aktivitet vil vises her når handlinger udføres på denne faktura",
        "by": "Af {{userName}}",
        "actions": {
          "invoiceSent": "Faktura Sendt",
          "invoiceCreated": "Faktura Oprettet",
          "statusChanged": "Status Ændret",
          "paymentRecorded": "Betaling Registreret"
        }
      }
    }
  },
  "customers": {
    "title": "Kunder",
    "addNewCustomer": "Tilføj Ny Kunde",
    "refreshCustomerList": "Opdater kundeliste",
    "searchCustomers": "Søg kunder...",
    "allCustomers": "Alle Kunder",
    "manageCustomerDatabase": "Administrer din kundedatabase",
    "companyName": "Firmanavn",
    "address": "Adresse",
    "phone": "Telefon",
    "email": "Email",
    "created": "Oprettet",
    "sites": "Steder",
    "actions": "Handlinger",
    "addSite": "Tilføj Sted",
    "addNewSiteForCustomer": "Tilføj nyt sted til denne kunde",
    "deleteCustomer": "Slet kunde",
    "noCustomersFound": "Ingen kunder fundet. Prøv at justere din søgning eller tilføj en ny kunde.",
    "areYouSure": "Er du sikker?",
    "deleteConfirmation": "Denne handling vil permanent slette {{customerName}}.",
    "deleteWarning": "Advarsel: Denne kunde har {{count}} {{sitePlural}} tilknyttet.",
    "siteSingular": "sted",
    "sitePlural": "steder",
    "cancel": "Annuller",
    "delete": "Slet",
    "deleting": "Sletter...",
    "customerDeleted": "Kunde slettet",
    "customerDeletedSuccess": "{{customerName}} er blevet fjernet.",
    "error": "Fejl",
    "deleteCustomerError": "Kunne ikke slette kunden. Prøv venligst igen.",
    "offerAlreadyAcceptedError": "Dette tilbud er allerede blevet accepteret af kunden. Kan ikke sende et nyt tilbudslink.",
    "createNew": "Opret Ny Kunde",
    "backToCustomers": "Tilbage til Kunder",
    "companyNameRequired": "Firmanavn *",
    "addressRequired": "Adresse *",
    "phoneNumber": "Telefonnummer",
    "cvrNumber": "CVR Nummer",
    "creating": "Opretter...",
    "createCustomer": "Opret Kunde",
    "customerCreatedSuccess": "Kunde oprettet succesfuldt",
    "createCustomerError": "Kunne ikke oprette kunde",
    "editCustomer": "Rediger Kunde",
    "customerDetails": "Kundedetaljer",
    "quotes": "Tilbud",
    "jobs": "Jobs",
    "invoices": "Fakturaer",
    "saveChanges": "Gem Ændringer",
    "saving": "Gemmer...",
    "customerUpdatedSuccess": "Kunde opdateret succesfuldt",
    "updateCustomerError": "Kunne ikke opdatere kunde",
    "updated": "Opdateret",
    "viewQuote": "Se Tilbud",
    "viewJob": "Se Job",
    "viewInvoice": "Se Faktura",
    "noQuotesFound": "Ingen tilbud fundet for denne kunde",
    "noJobsFound": "Ingen jobs fundet for denne kunde",
    "noInvoicesFound": "Ingen fakturaer fundet for denne kunde",
    "noSitesFound": "Ingen steder tilføjet for denne kunde",
    "addNewSite": "Tilføj Nyt Sted",
    "addNewSiteDescription": "Tilføj en ny stedsplacering for denne kunde",
    "siteName": "Stednavn",
    "siteNameRequired": "Stednavn *",
    "contactName": "Kontaktperson",
    "contact": "Kontakt",
    "addingSite": "Tilføjer Sted...",
    "siteAddedSuccess": "Sted tilføjet succesfuldt",
    "addSiteError": "Kunne ikke tilføje sted",
    "customerSites": "Kundesteder",
    "name": "Navn",
    "edit": "Rediger",
    "deleteSiteConfirm": "Er du sikker på, at du vil slette dette sted?",
    "siteDeletedSuccess": "Sted slettet succesfuldt",
    "deleteSiteError": "Kunne ikke slette sted",
    "updatingSite": "Gemmer...",
    "save": "Gem",
    "siteUpdatedSuccess": "Sted opdateret succesfuldt",
    "updateSiteError": "Kunne ikke opdatere sted",
    "enterSiteName": "Indtast stednavn",
    "contactPersonName": "Kontaktpersonens navn",
    "contactPhoneNumber": "Kontaktpersonens telefonnummer",
    "contactEmailAddress": "Kontaktpersonens e-mailadresse",
    "invoiceNumber": "Faktura #",
    "amount": "Beløb",
    "dueDate": "Forfaldsdato",
    // Settings dropdown keys
    "settings": "Indstillinger",
    "customerManagementOptions": "Kundeadministrationsmuligheder",
    "exportToCSV": "Eksporter til CSV",
    "exporting": "Eksporterer...",
    "selectMultiple": "Vælg Flere",
    // Export and selection keys
    "noData": "Ingen Data",
    "noCustomersToExport": "Ingen kunder tilgængelige til eksport.",
    "exportSuccessful": "Eksport Gennemført",
    "exportedCustomers": "Eksporterede {{count}} {{count, plural, one {kunde} other {kunder}}} til {{filename}}",
    "exportFailed": "Eksport Fejlede",
    "exportFailedDescription": "Kunne ikke eksportere kunder. Prøv venligst igen.",
    "noSelection": "Intet Valgt",
    "pleaseSelectCustomersToExport": "Vælg venligst kunder til eksport.",
    "selectedCustomersNotFound": "Valgte kunder ikke fundet.",
    "exportedSelectedCustomers": "Eksporterede {{count}} valgte {{count, plural, one {kunde} other {kunder}}} til {{filename}}",
    "exportSelectedFailedDescription": "Kunne ikke eksportere valgte kunder. Prøv venligst igen.",
    "deselectAll": "Fravælg Alle",
    "selectAll": "Vælg Alle",
    "exportSelected": "Eksporter Valgte ({{count}})",
    "deleteSelected": "Slet Valgte ({{count}})",
    "noCustomersMatchSearch": "Ingen kunder matcher din søgning.",
    "customersTotal": "{{count}} {{customerWord}} i alt",
    "customerSingular": "kunde",
    "customerPlural": "kunder",
    "status": "Status",
    // Bulk Upload translations
    "bulkUpload": {
      "title": "Masseupload af Kunder",
      "menuItem": "Importer fra CSV",
      "description": "Upload en CSV-fil for at tilføje op til {{max}} kunder på én gang.",
      "emptyStateDescription": "Kom i gang ved at importere kunder fra en CSV-fil eller tilføje dem én ad gangen.",
      "importFromCSV": "Importer fra CSV",
      "dragAndDrop": "Træk og slip din CSV-fil her",
      "orClickToSelect": "eller klik for at vælge en fil",
      "selectFile": "Vælg CSV-fil",
      "csvFormat": "CSV-filformat",
      "csvFormatDescription": "Din CSV-fil skal indeholde en header-række med følgende kolonner:",
      "requiredColumns": "Påkrævede kolonner",
      "optionalColumns": "Valgfrie kolonner",
      "downloadTemplate": "Download Skabelon",
      "noDataRows": "CSV-filen indeholder ingen datarækker.",
      "missingCompanyNameColumn": "CSV-filen mangler kolonnen 'Company Name'.",
      "missingAddressColumn": "CSV-filen mangler kolonnen 'Address'.",
      "noValidRows": "Ingen gyldige kundedata fundet i CSV-filen.",
      "companyNameRequired": "Firmanavn er påkrævet",
      "addressRequired": "Adresse er påkrævet",
      "invalidEmail": "Ugyldigt e-mailformat",
      "invalidFileType": "Ugyldig Filtype",
      "pleaseUploadCSV": "Upload venligst en CSV-fil.",
      "fileTooLarge": "Filen er for Stor",
      "maxFileSize": "Maksimal filstørrelse er 5MB.",
      "tooManyRows": "For Mange Rækker",
      "maxCustomersAllowed": "Maksimalt {{max}} kunder tilladt pr. upload.",
      "parseError": "Læsefejl",
      "invalidCSVFormat": "Ugyldigt CSV-format. Tjek venligst din fil.",
      "valid": "gyldig",
      "invalid": "ugyldig",
      "invalidRowsWarning": "{{count}} række(r) indeholder fejl og vil blive sprunget over under upload.",
      "noValidCustomers": "Ingen Gyldige Kunder",
      "fixErrorsFirst": "Ret venligst fejlene eller fjern ugyldige rækker.",
      "uploadSuccessful": "Upload Gennemført",
      "customersCreated": "Oprettede {{count}} kunde(r) succesfuldt.",
      "uploadFailed": "Upload Fejlede",
      "unknownError": "Der opstod en ukendt fejl.",
      "selectDifferentFile": "Vælg Anden Fil",
      "uploading": "Uploader...",
      "uploadCustomers": "Upload {{count}} Kunde(r)",
      "uploadComplete": "Upload Fuldført",
      "successSummary": "Oprettede {{created}} kunde(r). {{failed}} fejlede.",
      "noCustomersCreated": "Ingen kunder kunne oprettes.",
      "errors": "Fejl",
      "done": "Færdig"
    }
  },
  "addressAutocomplete": {
    "startTypingAddress": "Begynd at skrive en adresse...",
    "enterAddressManually": "Indtast adresse manuelt...",
    "autocompleteUnavailable": "Adresse autofuldførelse er ikke tilgængelig - indtast venligst adresse manuelt"
  },
  "activeJob": {
    "customerInformation": "Kundeinformation",
    "editCustomer": "Rediger Kunde",
    "linkCustomer": "Tilknyt Kunde",
    "saveChanges": "Gem Ændringer",
    "cancel": "Annuller",
    "companyNameRequired": "Firmanavn *",
    "email": "Email",
    "phone": "Telefon",
    "cvrNumber": "CVR Nummer",
    "addressRequired": "Adresse *",
    "companyName": "Firmanavn",
    "address": "Adresse",
    "noCustomerInformation": "Ingen kundeinformation tilgængelig",
    "customerNotAvailable": "Kundeinformation er ikke tilgængelig for dette job",
    "addNewCustomer": "Tilføj Ny Kunde",
    "changeCustomer": "Skift Kunde",
    "selectCustomer": "Vælg en kunde...",
    "selectCustomerLabel": "Vælg Kunde",
    "updatingCustomer": "Opdaterer kunde...",
    "noCustomersAvailable": "Ingen kunder tilgængelige. Opret en kunde først.",
    "unknownCustomer": "Ukendt kunde",
    "companyNamePlaceholder": "Indtast firmanavn",
    "emailPlaceholder": "firma@eksempel.dk",
    "phonePlaceholder": "+45 12 34 56 78",
    "cvrPlaceholder": "12345678",
    "projectTimeline": "Projekt Tidslinje",
    "siteInformation": "Stedsinformation",
    "costs": "Omkostninger",
    "assignedTeamMembers": "Tildelte Teammedlemmer",
    "member": "medlem",
    "members": "medlemmer",
    "assigned": "tildelt",
    "unknownMember": "Ukendt Medlem",
    "assignedOn": "Tildelt den",
    "removeTeamMember": "Fjern teammedlem",
    "noTeamMembersAssigned": "Ingen teammedlemmer tildelt endnu",
    "addTeamMember": "Tilføj Teammedlem",
    "selectToAdd": "Vælg et medlem at tilføje...",
    "noTeamMembersAvailable": "Ingen teammedlemmer tilgængelige",
    "allMembersAssigned": "Alle tilgængelige teammedlemmer er allerede tildelt",
    "noPermissionToManage": "Ingen tilladelse til at administrere teammedlemmer",
    "onlyAdminsAndCreatorsCanManage": "Kun administratorer og jobopretteren kan tilføje eller fjerne teammedlemmer.",
    "jobCreatedBy": "Job oprettet af",
    "addSite": "Tilføj Sted",
    "editDates": "Rediger Datoer",
    "editDatesNotAvailable": "Datoudarbejdning ikke tilgængelig",
    "serviceAgreementTitle": "Serviceaftale",
    "serviceAgreementDescription": "Konfigurer dette job som en tilbagevendende serviceaftale med tildelt teammedlem",
    "serviceAgreementMakeRecurring": "Gør dette til en tilbagevendende serviceaftale",
    "serviceAgreementServiceFrequency": "Service Frekvens",
    "serviceAgreementServiceSchedule": "Service Tidsplan",
    "serviceAgreementDaysOfWeek": "Dage i Ugen",
    "serviceAgreementDayOfMonth": "Dag i Måneden",
    "serviceAgreementMonthOfQuarter": "Måned i Kvartalet",
    "serviceAgreementMonthOfYear": "Måned i Året",
    "serviceAgreementStartTime": "Starttid",
    "serviceAgreementEndTime": "Sluttid",
    "serviceAgreementEndDateLabel": "Serviceaftale Slutdato (Valgfri)",
    "serviceAgreementEndDateDescription": "Lad være tom for en løbende serviceaftale. Sæt en dato for automatisk at afslutte de tilbagevendende services.",
    "serviceAgreementTimeWindowDescription": "Sæt det foretrukne tidsvindue for serviceaftaler",
    "serviceAgreementAssignedTeamMember": "Tildelt Teammedlem",
    "serviceAgreementSelectTeamMember": "Vælg et teammedlem...",
    "serviceAgreementLoadingTeamMembers": "Indlæser teammedlemmer...",
    "serviceAgreementPleaseSelectAtLeastOneDay": "Vælg venligst mindst én dag i ugen",
    "serviceAgreementSaving": "Gemmer...",
    "serviceAgreementSaveSchedule": "Gem Tilbagevendende Tidsplan",
    "serviceAgreementActiveTitle": "Serviceaftale Aktiv",

    // Ugedage - kort form
    "daysOfWeekMon": "Man",
    "daysOfWeekTue": "Tir",
    "daysOfWeekWed": "Ons",
    "daysOfWeekThu": "Tor",
    "daysOfWeekFri": "Fre",
    "daysOfWeekSat": "Lør",
    "daysOfWeekSun": "Søn",

    // Ugedage - fuld form
    "daysOfWeekMonday": "Mandag",
    "daysOfWeekTuesday": "Tirsdag",
    "daysOfWeekWednesday": "Onsdag",
    "daysOfWeekThursday": "Torsdag",
    "daysOfWeekFriday": "Fredag",
    "daysOfWeekSaturday": "Lørdag",
    "daysOfWeekSunday": "Søndag",

    // Frekvenser
    "frequenciesDaily": "Dagligt",
    "frequenciesWeekly": "Ugentligt",
    "frequenciesBiweekly": "Hver anden uge",
    "frequenciesMonthly": "Månedligt",
    "frequenciesQuarterly": "Kvartalsvis",
    "frequenciesAnnually": "Årligt",

    // Ordinaler
    "ordinalsFirst": "1.",
    "ordinalsSecond": "2.",
    "ordinalsThird": "3.",
    "ordinalsNth": "{{number}}.",
    "ordinalsLastDay": "Sidste dag",
    "ordinals1st": "1.",
    "ordinals2nd": "2.",
    "ordinals3rd": "3.",

    // Måneder
    "monthsJanuary": "Januar",
    "monthsFebruary": "Februar",
    "monthsMarch": "Marts",
    "monthsApril": "April",
    "monthsMay": "Maj",
    "monthsJune": "Juni",
    "monthsJuly": "Juli",
    "monthsAugust": "August",
    "monthsSeptember": "September",
    "monthsOktober": "Oktober",
    "monthsNovember": "November",
    "monthsDecember": "December",

    // Serviceaftale Oversigt
    "serviceAgreementActiveDescription": "Dette job er konfigureret som en tilbagevendende serviceaftale. Systemet vil automatisk oprette nye aftaler baseret på tidsplanen nedenfor.",
    "serviceAgreementFrequency": "Frekvens",
    "serviceAgreementServiceTime": "Servicetid",
    "serviceAgreementDays": "Dage",
    "serviceAgreementMonth": "Måned",
    "serviceAgreementAssignedTo": "Tildelt til",
    "overviewUnknown": "Ukendt",
    "overviewUnknownMember": "Ukendt Medlem",
    "siteName": "Stednavn",
    "siteAddress": "Adresse for Sted",
    "selectSite": "Vælg Sted",
    "noSitesAvailable": "Ingen steder tilgængelige for denne kunde.",
    "jobDetailsFromQuote": "Job Detaljer fra Tilbud",
    "errorLoadingJobDetails": "Fejl ved indlæsning af job detaljer",
    "projectStartDate": "Projekt startdato",
    "projectEndDate": "Projekt slutdato",
    "loading": "Indlæser...",
    "status": "Status",
    "laborCost": "Arbejdsomkostninger",
    "totalHours": "Samlede timer",
    "materials": "Materialer",
    "customer": "Kunde",
    "selectACustomer": "Vælg en kunde...",
    "addNewSite": "Tilføj nyt sted",
    "selectedSite": "Valgt sted",
    "editSiteInformation": "Rediger sted information",
    "daily": "Dagligt",
    "weekly": "Ugentligt",
    "biweekly": "Hver 14. dag",
    "monthly": "Månedligt",
    "quarterly": "Kvartalsvis",
    "annually": "Årligt",
    "serviceSchedule": "Service plan",
    "lastDayOfMonth": "Sidste dag i måneden",
    "serviceAgreementActive": "Service aftale aktiv",
    "jobDescription": "Job beskrivelse",
    "hours": "Timer",
    "ratePerHour": "Takst pr. time",
    "totalPrice": "Samlet pris",
    "salesPrice": "Salgspris",
    "quoteDetailsTransferred": "Tilbud detaljer overført",
    "quoteDetailsTransferredDesc": "Disse job detaljer blev automatisk overført fra det oprindelige tilbud, da det blev konverteret til et aktivt job. Du kan se den fulde opdeling af tjenester og prissætning fra det oprindelige tilbud.",
    "totalJobs": "Samlede Jobs:",
    "totalEstimatedHours": "Samlede Estimerede Timer:",
    "totalSalesValue": "Samlet Salgsværdi:",
    "jobNotFromQuote": "Dette job er måske ikke oprettet fra et tilbud, eller ingen job detaljer blev specificeret i det oprindelige tilbud.",
    "noJobDetailsAvailable": "Ingen Jobdetaljer Tilgængelige",
    "priorityLevel": "Prioritetsniveau",
    "jobType": "Job Type",
    "viewOffer": "Se Tilbud",
    "delete": "Slet",
    "deleteJob": "Slet Job",
    "deleteJobConfirm": "Denne handling kan ikke fortrydes",
    "deleting": "Sletter...",
    "deleteJobButton": "Slet Job",
    "tabs": {
      "overview": "Oversigt",
      "workEntries": "Arbejdsposter",
      "tasks": "Opgaver",
      "materials": "Materialer",
      "qualityControl": "Kvalitetskontrol",
      "billing": "Fakturering",
      "invoices": "Fakturaer"
    },
    "statusOptions": {
      "unassigned": "Ikke tildelt",
      "inProgress": "I gang",
      "onHold": "På pause",
      "toInvoice": "Til fakturering",
      "complete": "Færdig",
      "cancelled": "Annulleret"
    },
    "addWorkEntry": "Tilføj Arbejdspost",
    "addTask": "Tilføj Opgave",
    "addMaterial": "Tilføj Materiale",
    "loadingWorkEntries": "Indlæser arbejdsposter...",
    "loadingTasks": "Indlæser opgaver...",
    "loadingMaterials": "Indlæser materialer...",
    "completeJobManagement": "Komplet Job Management System med Tilbud-til-Job Materiale Overførsel!",
    "completedFeatures": "Afsluttede Funktioner:",
    "materialsManagement": "Materialehåndtering - Fulde CRUD operationer med mængde og prissætning",
    "offerToJobConversion": "Tilbud-til-Job Konvertering - Materialer fra tilbud overføres automatisk til job materialer fanen",
    "qualityControlFiles": "Kvalitetskontrol Filer - Fil upload med S3 lagring og kvote sporing",
    "overviewIntegration": "Oversigt Integration - Materiale omkostninger beregnes og vises automatisk",
    "invoiceSystem": "Faktura System - Komplet fakturahåndtering med PDF generering, email afsendelse og betaling sporing",
    "workEntrySystem": "Arbejdspost System - Tidssporing med teammedlem tildeling",
    "taskManagement": "Opgavehåndtering - Fuldt opgavesystem med prioritet og status sporing",
    "timeRangeFeature": "Tidsinterval Funktion - Tilbagevendende tidsplan håndtering med kalender integration",
    "typescriptCompliance": "TypeScript Overholdelse - Ren build med korrekt type sikkerhed",
    "readyForProduction": "Klar til produktion: Komplet job management system med sømløs tilbud-til-job workflow!",
    "getStartedByCreating": "Kom i gang ved at oprette et sted for denne kunde.",
    "addFirstSite": "Tilføj Første Sted",
    "siteNameRequired": "Stednavn *",
    "siteContactName": "Kontaktperson",
    "sitePhoneNumber": "Telefonnummer",
    "siteEmailLabel": "Email",
    "siteAddressRequired": "Adresse *",
    "siteCancel": "Annuller",
    "siteCreating": "Opretter...",
    "createSite": "Opret Sted",
    "editSite": "Rediger Sted",
    "siteProjectStartDate": "Projekt Startdato",
    "siteProjectEndDate": "Projekt Slutdato",
    "notSet": "Ikke angivet",
    "overview": {
      "priorityLevel": "Prioritetsniveau",
      "jobType": "Jobtype",
      "projectTimeline": "Projekt Tidslinje",
      "currentCustomer": "Nuværende Kunde",
      "changeTo": "Skift til",
      "priority": {
        "high": "Høj Prioritet",
        "medium": "Medium Prioritet",
        "low": "Lav Prioritet"
      },
      "jobTypes": {
        "service": "Service",
        "installation": "Installation",
        "callOut": "Udrykningsjob"
      },
      "days": {
        "monday": "Mandag",
        "tuesday": "Tirsdag",
        "wednesday": "Onsdag",
        "thursday": "Torsdag",
        "friday": "Fredag",
        "saturday": "Lørdag",
        "sunday": "Søndag"
      }
    },
    "customerSignature": {
      "title": "Kunde Arbejds Godkendelse",
      "description": "Gennemgå venligst det udførte arbejde og angiv din digitale signatur for at bekræfte accept.",
      "workDescriptionLabel": "Arbejdsbeskrivelse *",
      "workDescriptionPlaceholder": "Beskriv venligst det arbejde, der blev udført...",
      "digitalSignatureLabel": "Digital Signatur *",
      "signInstructions": "Underskriv ovenfor med din mus eller finger",
      "clear": "Ryd",
      "legalNoticeTitle": "Juridisk Meddelelse",
      "legalNoticeIntro": "Ved at angive din digitale signatur ovenfor anerkender du, at:",
      "legalPoint1": "Du har gennemgået og accepterer det udførte arbejde som beskrevet",
      "legalPoint2": "Denne digitale signatur har samme juridiske effekt som en håndskreven signatur",
      "legalPoint3": "Arbejdet blev udført til din tilfredshed",
      "legalPoint4": "Denne signatur er dateret {{date}}",
      "submitting": "Indsender...",
      "submitWorkApproval": "Indsend Arbejds Godkendelse",
      "customerApprovals": "Kunde Godkendelser",
      "customerApproval": "Kunde Godkendelse",
      "signedOn": "Underskrevet den",
      "deleting": "Sletter",
      "delete": "Slet",
      "workDescriptionColon": "Arbejdsbeskrivelse:",
      "pleaseDescribeWork": "Beskriv venligst det udførte arbejde",
      "pleaseProvideSignature": "Angiv venligst din signatur",
      "failedToCaptureSignature": "Kunne ikke optage signatur",
      "signatureSubmittedSuccessfully": "Arbejdsafslutning signatur indsendt med succes!",
      "failedToSubmitSignature": "Kunne ikke indsende signatur"
    },
    "siteSaving": "Gemmer...",
    "siteContactPerson": "Stedets kontaktperson",
    "sitePhoneNumberPlaceholder": "Stedets telefonnummer",
    "siteEmailPlaceholder": "sted@eksempel.com",
    "fullSiteAddress": "Fuld stedsadresse",
    "mainOfficeWarehouse": "f.eks., Hovedkontor, Lager A",
    "noTasksCreated": "Ingen opgaver oprettet endnu",
    "clickAddTaskToCreate": "Klik på \"Tilføj Opgave\" for at oprette din første opgave",
    "deleteTask": "Slet Opgave",
    "deleteTaskConfirmation": "Er du sikker på, at du vil slette denne opgave? Denne handling kan ikke fortrydes.",
    "deletingTask": "Sletter...",
    "assignedTo": "Tildelt til:",
    "teamMember": "Teammedlem",
    "unassignedTask": "Ikke-tildelt Opgave",
    "due": "Forfalder",
    "time": "Tid:",
    "created": "Oprettet",
    "createdBy": "Oprettet af",
    "user": "Bruger",
    "toDo": "At Gøre",
    "inProgress": "I Gang",
    "done": "Færdig",
    "editTask": "Rediger opgave",
    "deleteTaskAction": "Slet opgave",
    "noWorkEntriesYet": "Ingen Arbejdsposter Endnu",
    "startTrackingTime": "Start med at spore tid ved at oprette din første arbejdspost.",
    "hoursUnit": "timer",
    "hourlyRate": "t",
    "deleteEntry": "Slet Post",
    "entryType": "Type:",
    "work": "Arbejde",
    "overtime": "Overtid",
    "transportation": "Transport",
    "areYouSureDeleteEntry": "Er du sikker på, at du vil slette denne arbejdspost?",
    "entryTypeUpdatedSuccess": "Posttype opdateret med succes",
    "failedUpdateEntryType": "Kunne ikke opdatere posttype",
    "workEntryDeletedSuccess": "Arbejdspost slettet med succes",
    "failedDeleteWorkEntry": "Kunne ikke slette arbejdspost",
    "editEntry": "Rediger Post",
    "workEntryModal": {
      "title": "Tilføj Arbejdspost",
      "assignToTeamMember": "Tildel til Teammedlem",
      "selectTeamMember": "Vælg teammedlem",
      "entryType": "Posttype",
      "date": "Dato",
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "hours": "Timer",
      "hourlyRate": "Timeløn (valgfri)",
      "hourlyRatePlaceholder": "0,00",
      "description": "Beskrivelse",
      "descriptionPlaceholder": "Beskriv det udførte arbejde...",
      "cancel": "Annuller",
      "creating": "Opretter...",
      "createWorkEntry": "Opret Arbejdspost",
      "pleaseSelectTeamMember": "Vælg venligst et teammedlem",
      "hoursMustBeGreaterThanZero": "Timer skal være større end 0",
      "workEntryCreatedSuccessfully": "Arbejdspost oprettet med succes",
      "failedToCreateWorkEntry": "Kunne ikke oprette arbejdspost",
      "purchasePrice": "Indkøbspris",
      "salesPrice": "Salgspris",
      "profitMargin": "Avance",
      "type": "Type",
      "workEntry": "Arbejdspost",
      "eventHolidayTeamActivity": "Begivenhed (Ferie/Teamaktivitet)",
      "trackBillableHours": "Spor fakturerbare arbejdstimer for et specifikt job",
      "addHolidaysMeetings": "Tilføj ferier, møder eller teambegivenheder (ingen fakturering påkrævet)",
      "teamMembers": "Teammedlemmer",
      "selectTeamMembers": "Vælg teammedlemmer...",
      "membersSelected": "medlemmer valgt",
      "ofSelected": "af",
      "selected": "valgt",
      "selectAll": "Vælg alle",
      "clear": "Ryd",
      "done": "Færdig",
      "more": "mere",
      "user": "Bruger",
      "selectATeamMember": "Vælg et teammedlem...",
      "job": "Job",
      "selectAJob": "Vælg et job",
      "eventTitle": "Begivenhedstitel",
      "eventTitlePlaceholder": "f.eks. Juleferie, Teammøde",
      "eventType": "Begivenhedstype",
      "holiday": "Ferie",
      "teamEvent": "Teambegivenhed",
      "meeting": "Møde",
      "other": "Andet",
      "allDayEvent": "Heldagsbegivenhed",
      "startDate": "Startdato",
      "endDate": "Slutdato",
      "findNextAvailableTime": "Find næste ledige tid",
      "searching": "Søger...",
      "selectTeamMembersFirst": "Vælg teammedlemmer først",
      "hoursCalculatedAutomatically": "Timer beregnes automatisk, hvis start- og sluttider er angivet",
      "billingRate": "Faktureringsrate",
      "loadingRates": "Indlæser satser...",
      "work": "Arbejde",
      "overtime": "Overarbejde",
      "transportation": "Transport",
      "descriptionOptional": "Beskrivelse (valgfri)",
      "addEventDetails": "Tilføj yderligere detaljer om denne begivenhed...",
      "markAsCompleted": "Marker som fuldført",
      "deleteEvent": "Slet begivenhed",
      "delete": "Slet",
      "deleteThisOccurrenceOnly": "Slet kun denne forekomst",
      "deleteEntireRecurringSeries": "Slet hele den gentagne serie",
      "save": "Gem",
      "pleaseSelectAtLeastOneTeamMember": "Vælg venligst mindst ét teammedlem",
      "pleaseEnterEventTitle": "Indtast venligst en begivenhedstitel",
      "pleaseSelectAJob": "Vælg venligst et job",
      "pleaseEnterValidHours": "Indtast venligst gyldige timer (større end 0)",
      "foundAvailableSlot": "Fandt ledig tid den",
      "at": "kl.",
      "for": "for",
      "noAvailableSlotsFound": "Ingen ledige tider fundet i de næste",
      "daysForSelectedTeamMembers": "dage for valgte teammedlemmer",
      "failedToFindSlot": "Kunne ikke finde ledig tid",
      "editEntry": "Rediger Post",
      "newEntry": "Ny Post"
    },
    "editJobTitle": "Rediger jobtitel",
    "saveJobTitle": "Gem",
    "cancelJobTitle": "Annuller",
    "jobTitleUpdated": "Jobtitel opdateret med succes",
    "failedToUpdateJobTitle": "Kunne ikke opdatere jobtitel",
    "jobTitleRequired": "Jobtitel er påkrævet",
    "profitAnalysis": "Profitanalyse",
    "labor": "Arbejdskraft",
    "costPrice": "Kostpris",
    "profit": "Profit",
    "margin": "Margin",
    "combinedTotal": "Samlet Total",
    "totalCostPrice": "Samlet kostpris",
    "grossProfit": "Bruttofortjeneste",
    "profitMargin": "Profitmargin",
    "marginOnCost": "Margin på omkostning",
    "backToJobs": "Tilbage til Jobs",
    "jobDeletedSuccess": "Job slettet med succes",
    "workEntryUpdatedSuccessfully": "Arbejdspost opdateret med succes",
    "deleteJobConfirmMessage": "Er du sikker på, at du vil slette",
    "deleteJobAllDataRemoved": "Alle data tilknyttet dette job vil blive fjernet.",
    "redirectingToJobs": "Omdirigerer til jobs...",
    "redirectingToOffer": "Omdirigerer til tilbud...",
    "pleaseWait": "Vent venligst",
    "materialsSection": {
      "nameRequired": "Materialenavn er påkrævet",
      "validQuantityRequired": "Indtast venligst en gyldig mængde",
      "validPriceRequired": "Indtast venligst en gyldig pris",
      "updatedSuccessfully": "Materiale opdateret med succes",
      "updateFailed": "Kunne ikke opdatere materiale",
      "materialNotFound": "Materiale ikke fundet",
      "removedFromJob": "Materiale fjernet fra job",
      "deleteFailed": "Kunne ikke slette materiale",
      "loading": "Indlæser materialer...",
      "loadingDescription": "Vent venligst mens materialer indlæses",
      "noMaterialsYet": "Ingen materialer tilføjet endnu",
      "addMaterialsDescription": "Tilføj materialer fra lager for at spore omkostninger",
      "totalMaterialsCost": "Samlede materialeomkostninger"
    },
    "materialForm": {
      "updatingMaterials": "Opdaterer materialer...",
      "materialName": "Materialenavn",
      "fromInventoryNote": "Materialenavn kommer fra lager",
      "quantity": "Mængde",
      "setInInventory": "Angivet i lager",
      "cancel": "Annuller",
      "saving": "Gemmer...",
      "save": "Gem",
      "fromInventory": "Fra Lager",
      "qty": "Antal",
      "editMaterial": "Rediger materiale",
      "removeMaterial": "Fjern materiale",
      "materialCost": "Materialeomkostning",
      "currency": "DKK"
    }
  },
  "profitStatus": {
    "excellent": "Fremragende",
    "good": "God",
    "fair": "Rimelig",
    "low": "Lav",
    "loss": "Tab"
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "Profit & Tab Analyse fra Jobs og Fakturaer",
    "loadingError": "Kunne ikke indlæse dashboard data",
    "timeRanges": {
      "30d": "30 Dage",
      "90d": "90 Dage",
      "1y": "1 År"
    },
    "metrics": {
      "collectedRevenue": "Indsamlet Omsætning",
      "collectedRevenueDesc": "Faktiske betalinger modtaget",
      "totalBilled": "Samlet Faktureret",
      "totalBilledDesc": "Samlet faktureret beløb",
      "totalCosts": "Samlede Omkostninger",
      "totalCostsDesc": "Arbejdskraft og materialer",
      "netProfit": "Nettofortjeneste",
      "profitMargin": "fortjenestemargen"
    },
    "tabs": {
      "overview": "Oversigt",
      "trends": "Tendenser",
      "breakdown": "Job Type Opdeling",
      "invoices": "Faktura Opdeling",
      "pending": "Afventende Fakturaer"
    },
    "charts": {
      "monthlyProfitLoss": "Månedlig Profit & Tab",
      "monthlyProfitLossDesc": "Omsætning, omkostninger og fortjeneste over de sidste 6 måneder",
      "financialTrends": "Finansielle Tendenser",
      "financialTrendsDesc": "Spor omsætning og fortjeneste tendenser over tid",
      "profitByJobType": "Fortjeneste efter Job Type",
      "profitByJobTypeDesc": "Fordeling af fortjeneste på tværs af forskellige job typer",
      "jobCountByType": "Job Antal efter Type",
      "jobCountByTypeDesc": "Antal job afsluttet efter type",
      "detailedJobTypeAnalysis": "Detaljeret Job Type Analyse",
      "detailedJobTypeAnalysisDesc": "Omsætning, omkostninger og fortjeneste opdeling efter job type med detaljerede job lister"
    },
    "legends": {
      "revenue": "Omsætning",
      "costs": "Omkostninger",
      "netProfit": "Nettofortjeneste",
      "profit": "Fortjeneste",
      "jobsCompleted": "Job Afsluttet",
      "unknown": "Ukendt"
    },
    "jobDetails": {
      "jobsCompleted": "job afsluttet",
      "netProfit": "Nettofortjeneste",
      "profitPerJob": "Fortjeneste pr. job:",
      "profitMargin": "Fortjenestemargen:",
      "individualJobs": "Individuelle Jobs",
      "noJobDetails": "Ingen job detaljer tilgængelige for denne job type",
      "duration": "Varighed",
      "margin": "margen"
    },
    "invoiceBreakdown": {
      "paidInvoices": "Betalte Fakturaer",
      "paidInvoicesDesc": "Fuldt betalte fakturaer",
      "partiallyPaidInvoices": "Delvist Betalte Fakturaer",
      "partiallyPaidInvoicesDesc": "Fakturaer med delvise betalinger",
      "unpaidInvoices": "Ubetalte Fakturaer",
      "unpaidInvoicesDesc": "Fakturaer uden betalinger endnu",
      "invoiceCount": "Faktura Antal:",
      "averageValue": "Gennemsnitlig Værdi:",
      "paidAmount": "Betalt Beløb:",
      "remaining": "Resterende:",
      "collected": "indsamlet",
      "invoiceStatusDistribution": "Faktura Status Fordeling",
      "invoiceStatusDistributionDesc": "Opdeling af samlet faktureret beløb efter status",
      "paid": "Betalt",
      "partiallyPaid": "Delvist Betalt",
      "unpaid": "Ubetalt",
      "invoiceSummary": "Faktura Sammendrag",
      "invoiceSummaryDesc": "Samlet faktureret beløb opdeling",
      "totalInvoicedAmount": "Samlet Faktureret Beløb:",
      "totalCollected": "Samlet Indsamlet:",
      "totalOutstanding": "Samlet Udestående:",
      "collectionRate": "Indsamlingsrate:"
    },
    "pendingInvoices": {
      "title": "Afventende Fakturaer",
      "description": "Fakturaer der afventer betaling sorteret efter dage forfaldne",
      "outstandingAmount": "Udestående beløb",
      "issueDate": "Udstedelsesdato",
      "dueDate": "Forfaldsdato",
      "daysOverdue": "Dage Forfaldne",
      "paidAmount": "Betalt Beløb",
      "notOverdue": "Ikke forfalden",
      "days": "dage",
      "noPendingInvoices": "Ingen afventende fakturaer fundet"
    }
  },
  "reports": {
    "overview": {
      "title": "Rapporter",
      "subtitle": "Få adgang til detaljeret analyse og indsigt om din virksomheds præstation",
      "profitabilityTitle": "Rentabilitetsrapport",
      "profitabilityDesc": "Omfattende profit & tab analyse med omsætning, omkostninger og marginer efter jobtype",
      "employeeTitle": "Medarbejderrapport",
      "employeeDesc": "Se aktive job og opgaver for hvert teammedlem i din organisation",
      "viewReport": "Se Rapport"
    },
    "employee": {
      "title": "Medarbejderrapport",
      "subtitle": "Se aktive jobtildelinger og arbejdstimer for hvert teammedlem",
      "totalEmployees": "Totale Medarbejdere",
      "employeesDesc": "Teammedlemmer i organisationen",
      "activeJobs": "Aktive Job",
      "activeJobsDesc": "Job der er i gang i øjeblikket",
      "totalHours": "Totale Timer (30d)",
      "totalHoursDesc": "Timer logget i de sidste 30 dage",
      "teamMembersTitle": "Teammedlemmer & Aktive Job",
      "teamMembersDesc": "Klik på en medarbejder for at se deres aktive jobtildelinger",
      "noEmployees": "Ingen medarbejdere fundet",
      "hours30d": "Timer (30d)",
      "noActiveJobs": "Ingen aktive job tildelt",
      "activeJobsCount": "Aktive Job",
      "hoursLogged": "timer logget",
      "lastEntry": "Sidst",
      "jobType": "Jobtype",
      "loadingError": "Kunne ikke indlæse medarbejderrapport",
      "revenue": "Omsætning",
      "cost": "Omkostning",
      "profit": "Profit"
    }
  },
  "licensing": {
    "pageTitle": "Licensadministration",
    "pageSubtitle": "Administrer dit teams licenser og abonnement",
    "loading": "Indlæser...",
    "organizationRequired": "Organisation Påkrævet",
    "organizationRequiredDesc": "Du skal oprette eller deltage i en organisation for at administrere licenser.",
    "createOrganization": "Opret Organisation",
    "noLicensesPurchased": "Ingen Licenser Købt",
    "noLicensesPurchasedDesc": "Din organisation har ingen aktive licenser. Du skal købe mindst én licens for at bruge platformen.",
    "subscriptionRequired": "Abonnement Påkrævet",
    "subscriptionRequiredDesc": "Et abonnement er påkrævet for at bruge denne applikation. Køb venligst en licens for at fortsætte.",
    "licenseManagement": "Licensadministration",
    "licenseRequired": "Licens Påkrævet",
    "licenseRequiredDesc": "Du skal købe licenser, før du kan invitere teammedlemmer. Hvert teammedlem kræver én licens.",
    "error": "Fejl",
    "overview": "Oversigt",
    "users": "Brugere",
    "noLicenseAssigned": "Ingen Licens Tildelt",
    "noLicenseAssignedDesc": "Du har ikke en licens. Køb venligst en licens eller bed en administrator om at tildele dig en.",
    "userLicenseManagement": "Brugerlicensadministration",
    "licenseCountDesc": "Du har {{licenses}} licenser i alt med {{assigned}} aktuelt tildelt.",
    "name": "Navn",
    "email": "E-mail",
    "licensed": "Licenseret"
  },
  "signUp": {
    "title": "Start Din Gratis Prøveperiode",
    "subtitle": "Tilslut dig tusindvis af håndværkere der bruger Svendetid til at udvide deres forretning",
    "backToHome": "← Tilbage til Forsiden",
    "alreadyHaveAccount": "Har du allerede en konto?",
    "signInHere": "Log ind her →",
    "signIn": "Log ind",
    "freeTrial": "14-dages gratis prøveperiode",
    "noCreditCard": "Intet kreditkort påkrævet",
    "termsAgreement": "Ved at tilmelde dig accepterer du vores Servicevilkår og Privatlivspolitik",
    "terms": "Ved at tilmelde dig accepterer du vores Servicevilkår og Privatlivspolitik",
    "footer": "© {{year}} Svendetid. Alle rettigheder forbeholdes. Lavet med ❤️ til håndværkere.",
    "welcome": {
      "title": "Velkommen til Svendetid",
      "subtitle": "Din komplette håndværksvirksomheds styringssløsning"
    },
    "features": {
      "scheduling": {
        "title": "Smart Planlægning & Udsendelse",
        "description": "Effektivt administrer jobs, teams og aftaler med intelligent automatisering"
      },
      "invoicing": {
        "title": "Øjeblikkelig Fakturering & Betalinger",
        "description": "Opret professionelle fakturaer og få betalt hurtigere med integreret betalingsbehandling"
      },
      "analytics": {
        "title": "Forretningsanalyse & Indsigt",
        "description": "Spor præstation og udvid din virksomhed med kraftfulde rapporteringsværktøjer"
      }
    },
    "form": {
      "title": "Start Din Gratis Prøveperiode",
      "subtitle": "Tilslut dig tusindvis af håndværkere der bruger Svendetid til at udvide deres forretning"
    },
    "trust": {
      "freeTrial": "14-dages gratis prøveperiode",
      "noCreditCard": "Intet kreditkort påkrævet"
    }
  },
  "create": "Opret",
  "organization": "Organisation",
  "signOut": "Log ud",
  "yourJobs": "Dine tilbud",
  "filterOffers": "Filtrer tilbud...",
  "createNewqoute": "Opret nyt tilbud",
  "forms": {
    "quoteTitle": "Skriv en titel til tilbuddet"
  },
  "navHelp": {
    "guideTitle": "Navigationsguide",
    "closeButton": "Luk",
    "helpMenu": "Hjælpemenu",
    "menuItemLabel": "Hjælp til navigationsmenuen",
    "gettingStarted": "Kom i gang",
    "previous": "Forrige",
    "next": "Næste",
    "close": "Luk",
    "stepCounter": "Trin {{current}} af {{total}}",
    "overview": {
      "subtitle": "Se og administrer dine opgaver for i dag",
      "description": "Se din virksomheds dashboard med nøglemetrikker og præstationsindikatorer."
    },
    "quotes": {
      "description": "Opret og administrer kundetilbud og estimater til potentielle job."
    },
    "jobs": {
      "description": "Følg alle aktive og afsluttede job med detaljerede statusoplysninger."
    },
    "billing": {
      "description": "Administrer fakturaer, betalinger og faktureringsrelaterede aktiviteter."
    },
    "activity": {
      "description": "Se nylige handlinger og ændringer i din organisations arbejdsområde."
    },
    "customers": {
      "description": "Vedligehold din kundedatabase med kontaktoplysninger og historik."
    },
    "map": {
      "description": "Se kundepositioner og job på et geografisk kort.",
      "title": "Job Lokationer",
      "subtitle": "Se alle job lokationer på kortet",
      "noOrganization": "Ingen organisation fundet. Kontakt venligst support."
    },
    "calendar": {
      "description": "Planlæg aftaler og se kommende deadlines og begivenheder."
    },
    "inventory": {
      "description": "Administrer dit produktlager, lagerniveauer og leverandører."
    },
    "settings": {
      "description": "Konfigurer dine organisationspræferencer, brugeradgang og systemindstillinger."
    },
    "adminPage": {
      "description": "Få adgang til administratorværktøjer og -indstillinger (kun for administratorer)."
    },
    "reports": {
      "description": "Generér og se detaljerede rapporter om forretningsydelse og aktiviteter."
    }
  },
  "qualityControl": {
    "title": "Kvalitetskontrol Dokumenter",
    "description": "Upload og administrer kvalitetskontrol dokumentation for dette job",
    "uploadFile": "Upload Fil",
    "upload": "Upload",
    "uploading": "Uploader...",
    "selected": "Valgt",
    "fileDescription": "Beskrivelse",
    "addDescription": "Tilføj en beskrivelse til denne fil...",
    "uploadedDocuments": "Uploadede Dokumenter",
    "reviewAndManage": "Gennemgå og administrer dine kvalitetskontrol filer",
    "refresh": "Opdater",
    "loadingFiles": "Indlæser filer...",
    "preview": "Vis",
    "download": "Download",
    "downloadFile": "Download Fil",
    "delete": "Slet",
    "deleting": "Sletter...",
    "close": "Luk",
    "loadingPreview": "Indlæser...",
    "previewNotAvailable": "Forhåndsvisning er ikke tilgængelig for denne filtype.",
    "storageUsage": "Lagerforbrug",
    "gbUsed": "GB af",
    "gbUsedTotal": "GB brugt",
    "files": "filer",
    "noFilesUploadedYet": "Ingen filer uploadet endnu",
    "uploadFirstDocument": "Upload dit første kvalitetskontrol dokument ovenfor.",
    "fileUploadedSuccessfully": "Fil uploadet succesfuldt",
    "failedToUploadFile": "Kunne ikke uploade fil",
    "pleaseSelectFileToUpload": "Vælg venligst en fil at uploade",
    "failedToLoadFiles": "Kunne ikke indlæse filer",
    "unknownError": "Ukendt fejl",
    "failedToPreviewFile": "Kunne ikke vise fil",
    "cameraSupport": "Kamera støtte",
    "available": "Tilgængelig",
    "notAvailable": "Ikke tilgængelig",
    "mediaDevicesApi": "MediaDevices API",
    "loadingYourFiles": "Indlæser dine filer...",
    "checkingUploadedDocuments": "Kontrollerer uploadede dokumenter...",
    "startingPreview": "Starter forhåndsvisning for"
  },
  "offerCreated": "Tilbud oprettet!",
  "adminApprovalRequired": "Administratorgodkendelse Påkrævet",
  "adminApprovalRequiredDesc": "Denne organisation kræver administratorgodkendelse, før tilbud kan accepteres af kunder. Som administrator skal du gennemgå og godkende dette tilbud først.",
  "adminApproved": "Administrator Godkendt",
  "adminApprovedDesc": "Godkendt af administrator, afventer kundeaccept",
  "approveOffer": "Godkend Tilbud (Administrator)",
  "approveOfferDesc": "Godkend dette tilbud til kundeaccept",
  "approveOfferConfirm": "Godkend Dette Tilbud?",
  "approveOfferConfirmDesc": "Dette vil godkende tilbuddet og tillade kunder at acceptere det. Når det er godkendt, kan kunder fortsætte med dette tilbud.",
  "approvedReadyForCustomer": "Godkendt - Klar til Kunde",
  "approvedReadyForCustomerDesc": "Dette tilbud er blevet godkendt af en administrator og er nu klar til kundeaccept. Kunden kan nu fortsætte med dette tilbud.",
  "requireAdminApprovalForOffers": "Kræv Administratorgodkendelse for Tilbud",
  "requireAdminApprovalForOffersDesc": "Kræv administratorgodkendelse før tilbud kan accepteres af kunder",
  "title": "Titel",
  "status": "Status",
  "customer": "Kunde",
  "new": "Ny",
  "tasks": {
    "title": "Opgaver",
    "taskToday": "opgave i dag",
    "tasksToday": "opgaver i dag",
    "taskTomorrow": "opgave i morgen",
    "tasksTomorrow": "opgaver i morgen",
    "highPriority": "høj prioritet",
    "today": "I Dag",
    "tomorrow": "I Morgen",
    "myTasksToday": "Mine opgaver i dag",
    "myTasks": "Mine opgaver",
    "noTasksToday": "Du har ingen opgaver planlagt til i dag!",
    "noTasksTomorrow": "Du har ingen opgaver planlagt til i morgen!",
    "allCaughtUpToday": "Alt er klaret for i dag!",
    "allCaughtUpTomorrow": "Intet planlagt til i morgen endnu",
    "noTasksTodayDesc": "Godt arbejde! Du har gennemført alle dine opgaver.",
    "noTasksTomorrowDesc": "Din tidsplan er klar for i morgen.",
    "viewAllJobs": "Se Alle Jobs",
    "markComplete": "Marker som fuldført",
    "edit": "Rediger Opgave",
    "refreshTasks": "Opdater opgaver",
    "createTestTask": "Opret testopgave",
    "viewDiagnostics": "Vis diagnostik",
    "low": "Lav",
    "medium": "Medium",
    "high": "Høj",
    "urgent": "Haster",
    "toDo": "Skal gøres",
    "inProgress": "I gang",
    "done": "Færdig",
    "unassigned": "Ikke tildelt",
    "markAsInProgress": "Marker som i gang",
    "markAsDone": "Marker som færdig",
    "delete": "Slet",
    "addTask": "Tilføj opgave",
    "noDueDate": "Ingen frist",
    "due": "Frist",
    "unknownUser": "Ukendt bruger",
    "refresh": "Opdater",
    "from": "Fra",
    "until": "Til",
    "createNewTask": "Opret Ny Opgave",
    "taskTitle": "Titel",
    "enterTaskTitle": "Indtast opgavetitel",
    "description": "Beskrivelse",
    "describeTask": "Indtast opgavebeskrivelse",
    "status": "Status",
    "priority": "Prioritet",
    "dueDate": "Forfaldsdato",
    "startTime": "Starttid",
    "endTime": "Sluttid",
    "assignTo": "Tildel til",
    "assigningTo": "Tildeler til:",
    "noOne": "Ingen",
    "cancel": "Annuller",
    "creating": "Opretter...",
    "createTask": "Opret Opgave",
    "taskCreationWithTiming": "Opgaveoprettelse med tidspunkt og tildeling!",
    "startEndTimeMandatory": "Starttid og Sluttid er obligatoriske for alle opgaver."
  },
  "nav": {
    "overview": "Oversigt",
    "reports": "Rapporter",
    "dashboard": "Dashboard",
    "jobs": "Job",
    "quotes": "Tilbud",
    "activity": "Aktivitet",
    "customers": "Kunder",
    "map": "Kort",
    "calendar": "Kalender",
    "inventory": "Lager",
    "suppliers": "Leverandører",
    "billing": "Fakturering",
    "settings": "Indstillinger",
    "timeRequests": "Tidsanmodninger",
    "timeRegistration": "Tidsregistering",
    "admin": "Admin",
    "adminPage": "Admin Side",
    "serviceAgreements": "Serviceaftaler"
  },
  "admin": {
    "title": "Admin Panel",
    "subtitle": "Administrer organisationsindstillinger, anmodninger og eksporter tidsposter",
    "accessLabel": "Admin Adgang",
    "tabs": {
      "offerApprovals": "Tilbudsgodkendelser",
      "timeRequests": "Tidsanmodninger", 
      "employeePayroll": "Medarbejder Løn",
      "timeExport": "Eksporter Tidsposter",
      "adminSettings": "Admin Indstillinger"
    },
    "settings": {
      "title": "Organisationsindstillinger",
      "subtitle": "Konfigurer organisationsdækkende indstillinger og præferencer",
      "loading": "Indlæser indstillinger...",
      "loadError": "Kunne ikke indlæse indstillinger",
      "saveSuccess": "Indstillinger gemt succesfuldt",
      "saveError": "Kunne ikke gemme indstillinger",
      "saveInfo": "Ændringer vil blive anvendt med det samme efter gem",
      "saving": "Gemmer...",
      "save": "Gem Indstillinger",
      "general": {
        "title": "Generelle Indstillinger",
        "description": "Grundlæggende organisationskonfiguration",
        "orgName": "Organisationsnavn",
        "orgNamePlaceholder": "Indtast organisationsnavn",
        "timezone": "Tidszone",
        "timezoneHelp": "Bruges til tidsberegninger og rapporter"
      },
      "timeEntry": {
        "title": "Tidsregistreringsindstillinger",
        "description": "Konfigurer hvordan medarbejdere kan registrere tid",
        "allowFuture": "Tillad Fremtidige Tidsregistreringer",
        "allowFutureDesc": "Tillad medarbejdere at registrere tid for fremtidige datoer",
        "requireApprovalTimeOff": "Kræv Godkendelse for Fravær",
        "requireApprovalTimeOffDesc": "Kræv admin godkendelse for ferie og sygeorlov",
        "requireApprovalOffers": "Kræv Admin Godkendelse for Tilbud",
        "requireApprovalOffersDesc": "Kræv admin godkendelse før tilbud kan accepteres af kunder",
        "maxDailyHours": "Maks Daglige Timer",
        "maxWeeklyHours": "Maks Ugentlige Timer"
      },
      "calendar": {
        "title": "Kalenderindstillinger",
        "description": "Konfigurer kalendervisning og arbejdstider",
        "workingHours": "Daglige Arbejdstider",
        "workingHoursDesc": "Indstil standard arbejdstider for din organisation. Disse timer vil blive fremhævet i kalenderen.",
        "startTime": "Starttidspunkt",
        "endTime": "Sluttidspunkt",
        "showWeekends": "Vis Weekender",
        "showWeekendsDesc": "Vis lørdag og søndag i kalendervisningen"
      }
    }
  },
  "employeePayroll": {
    "title": "Medarbejder Lønadministration",
    "subtitle": "Administrer CVR-numre, medarbejdernumre og løninformation til CSV-eksporter",
    "exportInformation": "Eksportinformation",
    "exportInformationDescription": "CVR-numre og medarbejdernumre administreret her vil automatisk blive inkluderet i tidspost-eksporter",
    "automaticExportIntegration": "Automatisk Eksportintegration",
    "exportIntegrationDescription": "Når du eksporterer tidsposter fra admin-panelet, vil følgende information automatisk blive inkluderet:",
    "cvrNumbers": "CVR-numre for hver medarbejder",
    "employeeNumbers": "Medarbejdernumre til lønidentifikation",
    "salaryTypeAndRates": "Løntype og takster til omkostningsberegninger",
    "employeePayrollInformation": "Medarbejder Løninformation",
    "managePayrollInfo": "Administrer CVR-numre, medarbejdernumre og løninformation til løneksporter",
    "addEditEmployeeData": "Tilføj/Rediger Medarbejderdata",
    "employee": "Medarbejder",
    "role": "Rolle",
    "cvrNumber": "CVR-nummer",
    "employeeNumber": "Medarbejdernummer",
    "salaryType": "Løntype",
    "rateSalary": "Takst/Løn",
    "actions": "Handlinger",
    "noEmployeesFound": "Ingen medarbejdere fundet i organisation",
    "noUserID": "Intet bruger-ID",
    "hourly": "TIMELØN",
    "fixedSalary": "FASTLØN",
    "freelance": "FREELANCE",
    "edit": "Rediger",
    "editEmployeeData": "Rediger Medarbejderdata",
    "addEmployeeData": "Tilføj Medarbejderdata",
    "enterCvrNumber": "Indtast CVR-nummer",
    "enterEmployeeNumber": "Indtast medarbejdernummer",
    "selectSalaryType": "Vælg løntype",
    "hourlyRate": "Timeløn (DKK)",
    "monthlySalary": "Månedlig Løn (DKK)",
    "enterHourlyRate": "Indtast timeløn",
    "enterMonthlySalary": "Indtast månedlig løn",
    "cancel": "Annuller",
    "saving": "Gemmer...",
    "saveEmployeeData": "Gem Medarbejderdata",
    "errorLoadingData": "Fejl: Kan ikke indlæse organisationsmedlemmer eller løndata. Prøv venligst igen senere.",
    "dkkPerHour": "DKK/time",
    "dkkPerMonth": "DKK/måned"
  },
  "timeEntriesExport": {
    "title": "Tidspost Eksport",
    "subtitle": "Eksporter alle tidsposter til CSV til HR- og lønsystemer",
    "loadingOrganization": "Indlæser organisationsdata...",
    "exportConfiguration": "Eksportkonfiguration",
    "configurationDescription": "Konfigurer eksportparametrene og download tidsposter som en CSV-fil",
    "fromDate": "Fra Dato",
    "toDate": "Til Dato",
    "employeeFilter": "Medarbejderfilter",
    "workTypeFilter": "Arbejdstypefilter",
    "selectEmployee": "Vælg medarbejder",
    "selectWorkType": "Vælg arbejdstype",
    "allEmployees": "Alle Medarbejdere",
    "allWorkTypes": "Alle Arbejdstyper",
    "work": "Arbejde",
    "holiday": "Ferie",
    "sickLeave": "Sygeorlov",
    "personalLeave": "Personlig Orlov",
    "noMembersFound": "Ingen organisationsmedlemmer fundet",
    "exportToCSV": "Eksporter til CSV",
    "exporting": "Eksporterer...",
    "csvFormatTitle": "Forenklet CSV Eksportformat",
    "cvrNumberDesc": "Dansk virksomhedsregistreringsnummer",
    "employeeNumberDesc": "Internt medarbejder-ID",
    "workTypeDesc": "Type af arbejde (ARBEJDE, FERIE, SYGEORLOV, osv.)",
    "salaryTypeDesc": "Betalingsstruktur (TIMELØN, FASTLØN, FREELANCE)",
    "hoursDesc": "Timer arbejdet for hver tidspost",
    "salaryPerHourDesc": "Timeløn fra medarbejder løndata",
    "salaryDesc": "Beregnet beløb (Timer × Timeløn)",
    "setupRequiredDesc": "Konfigurer medarbejderdata i \"Medarbejder Løn\" fanen først",
    "organizationNotFound": "Organisation ikke fundet",
    "unknownUser": "Ukendt Bruger",
    "errorArray": "Fejl: organisationsmedlemmer er ikke en array"
  },
  "adminSettings": {
    "title": "Organisationsindstillinger",
    "subtitle": "Konfigurer organisationsomfattende indstillinger",
    "loadingSettings": "Indlæser indstillinger...",
    "offerApprovalSettings": "Tilbudsgodkendelsesindstillinger",
    "offerApprovalDescription": "Styr hvordan tilbud behandles i din organisation",
    "requireAdminApproval": "Kræv Administratorgodkendelse for Tilbud",
    "requireAdminApprovalDesc": "Når aktiveret, skal alle tilbud godkendes af en administrator, før kunder kan acceptere dem",
    "saveSettings": "Gem Indstillinger",
    "saving": "Gemmer...",
    "settingsSaved": "Indstillinger gemt med succes",
    "failedToSave": "Kunne ikke gemme indstillinger",
    "adminApprovalEnabled": "Administratorgodkendelse aktiveret",
    "adminApprovalDisabled": "Administratorgodkendelse deaktiveret",
    "failedToUpdate": "Kunne ikke opdatere indstilling"
  },
  "vacationAllowance": {
    "title": "Administration af Ferietilgodehavende",
    "subtitle": "Sæt feriegrænser per medarbejder og ferietype",
    "loading": "Indlæser...",
    "year": "År",
    "setVacationAllowance": "Indstil Ferietilgodehavende",
    "employee": "Medarbejder",
    "selectEmployee": "Vælg medarbejder",
    "vacationType": "Ferietype",
    "selectType": "Vælg type",
    "allowedHours": "Tilladte Timer",
    "setAllowance": "Indstil Tilgodehavende",
    "setting": "Indstiller...",
    "currentVacationAllowances": "Nuværende Ferietilgodehavender",
    "noAllowancesSet": "Ingen ferietilgodehavender sat for",
    "useFormAbove": "Brug formularen ovenfor til at indstille tilgodehavender for medarbejdere",
    "hoursUsed": "t brugt",
    "remaining": "Resterende",
    "used": "brugt",
    "pleaseSelectAll": "Udfyld venligst alle felter",
    "allowanceUpdated": "Ferietilgodehavende opdateret med succes",
    "failedToLoad": "Kunne ikke indlæse ferietilgodehavende data",
    "failedToSet": "Kunne ikke indstille ferietilgodehavende"
  },
  "holidayTypes": {
    "title": "Administration af Ferietyper",
    "subtitle": "Administrer ferietyper som brugere kan vælge når de registrerer fri",
    "addHolidayType": "Tilføj Ferietype",
    "addNewHolidayType": "Tilføj Ny Ferietype",
    "createNewDescription": "Opret en ny ferietype som brugere kan vælge når de registrerer ferietid.",
    "editHolidayType": "Rediger Ferietype",
    "updateDescription": "Opdater ferietype informationen.",
    "name": "Navn",
    "namePlaceholder": "f.eks., Årlig Ferie, Sygeorlov, Personlig Dag",
    "nameRequired": "Navn *",
    "description": "Beskrivelse",
    "descriptionPlaceholder": "Valgfri beskrivelse for denne ferietype",
    "cancel": "Annuller",
    "createHolidayType": "Opret Ferietype",
    "creating": "Opretter...",
    "updateHolidayType": "Opdater Ferietype",
    "updating": "Opdaterer...",
    "deleteConfirm": "Er du sikker på, at du vil slette \"{name}\"? Denne handling kan ikke fortrydes.",
    "noHolidayTypes": "Ingen ferietyper konfigureret endnu",
    "createHolidayTypesDescription": "Opret ferietyper som dit team kan bruge når de registrerer fri.",
    "created": "Oprettet",
    "holidayTypeNameRequired": "Ferietype navn er påkrævet",
    "holidayTypeCreated": "Ferietype oprettet med succes",
    "failedToCreate": "Kunne ikke oprette ferietype",
    "holidayTypeUpdated": "Ferietype opdateret med succes",
    "failedToUpdate": "Kunne ikke opdatere ferietype",
    "holidayTypeDeleted": "Ferietype slettet med succes",
    "failedToDelete": "Kunne ikke slette ferietype",
    "loading": "Indlæser..."
  },
  "attendanceCalendar": {
    "thisWeek": "Denne Uge",
    "thisMonth": "Denne Måned",
    "work": "Arbejde",
    "holiday": "Ferie",
    "sick": "Syg",
    "pending": "Afventende",
    "calendarView": "Kalender Visning",
    "day": "Dag",
    "week": "Uge",
    "month": "Måned",
    "loadingCalendar": "Indlæser kalender...",
    "clickToAddEntries": "Klik på en dag for at tilføje tidsregistreringer",
    "dragToCreateEntries": "Træk for at oprette tidsregistreringer øjeblikkeligt",
    "creatingTimeEntry": "Opretter tidsregistrering...",
    "clickForManualEntry": "Klik for manuel indtastning • Skift til Uge/Dag visning for træk funktionalitet",
    "clickOrDragEntry": "Klik for manuel indtastning • Træk for hurtig registrering",
    "duration": "Varighed",
    "hours": "timer"
  },
  "materialModal": {
    "title": "Tilføj Materiale fra Lager",
    "selectExistingItem": "Vælg Eksisterende Vare",
    "createNewItem": "Opret Ny Vare",
    "selectMaterialFromInventory": "Vælg Materiale fra Lager *",
    "loadingInventoryItems": "Indlæser lagervarer...",
    "attemptOf": "Forsøg {{current}} af {{total}}",
    "slowConnectionDetected": "Langsom forbindelse opdaget. Indlæsning kan tage længere tid...",
    "youAppearOffline": "Du ser ud til at være offline. Tjek venligst din forbindelse.",
    "searchMaterials": "Søg materialer...",
    "available": "tilgængelig",
    "noItemsMatchSearch": "Ingen varer matcher din søgning",
    "selected": "Valgt",
    "errorLoadingInventory": "Fejl ved indlæsning af lager",
    "noInventoryItems": "Ingen lagervarer tilgængelige",
    "createFirstInventoryItem": "Opret din første lagervare for at komme i gang",
    "tryAgain": "Prøv Igen",
    "productName": "Produktnavn *",
    "enterProductName": "Indtast produktnavn",
    "price": "Pris *",
    "enterPrice": "Indtast pris (DKK)",
    "unit": "Enhed *",
    "enterUnit": "Indtast enhed (f.eks. stk, m, kg)",
    "quantity": "Antal *",
    "enterQuantity": "Indtast antal",
    "description": "Beskrivelse",
    "enterDescription": "Indtast beskrivelse (valgfrit)",
    "totalCost": "Samlet Omkostning",
    "cancel": "Annuller",
    "creating": "Opretter...",
    "adding": "Tilføjer...",
    "addMaterial": "Tilføj Materiale",
    "createMaterial": "Opret Materiale",
    "pleaseSelectInventoryItem": "Vælg venligst en lagervare",
    "validQuantityRequired": "Gyldigt antal er påkrævet",
    "productNameRequired": "Produktnavn er påkrævet",
    "validPriceRequired": "Gyldig pris er påkrævet",
    "unitRequired": "Enhed er påkrævet",
    "selectedInventoryItemNotFound": "Valgt lagervare blev ikke fundet",
    "notEnoughQuantityAvailable": "Ikke nok antal tilgængeligt. Kun {{available}} {{unit}} på lager.",
    "failedToAddMaterialFromInventory": "Kunne ikke tilføje materiale fra lager",
    "materialAddedSuccessfully": "Materiale tilføjet med succes",
    "failedToAddMaterial": "Kunne ikke tilføje materiale",
    "creatingInventoryItem": "Opretter lagervare...",
    "failedToCreateInventoryItem": "Kunne ikke oprette lagervare",
    "failedToAddMaterialToJob": "Kunne ikke tilføje materiale til job",
    "materialAndInventoryItemCreated": "Materiale og lagervare oprettet med succes",
    "failedToCreateMaterial": "Kunne ikke oprette materiale"
  },
  "overview": {
    "subtitle": "Se og administrer dine opgaver for i dag",
    "welcome": "Velkommen tilbage",
    "user": "Bruger",
    "tasksToday": "opgaver i dag",
    "tasksTomorrow": "opgaver i morgen",
    "highPriority": "høj prioritet",
    "updated": "Opdateret",
    "refresh": "Opdater",
    "noJobDetailsAvailable": "Ingen Jobdetaljer Tilgængelige",
    "jobNotFromQuote": "Dette job blev ikke oprettet fra et tilbud, eller tilbudsdetaljerne er ikke tilgængelige.",
    "quickActions": {
      "title": "Hurtige Handlinger",
      "subtitle": "Opret nye elementer hurtigt for at komme i gang",
      "createOffer": "Opret Tilbud",
      "createJob": "Opret Job",
      "createCustomer": "Opret Kunde",
      "createSupplier": "Opret Leverandør",
      "createInvoice": "Opret Faktura"
    },
    "days": {
      "monday": "Mandag",
      "tuesday": "Tirsdag", 
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lørdag",
      "sunday": "Søndag"
    },
    "summary": {
      "totalHours": "Samlede Timer",
      "workEntriesCost": "Arbejdspost Omkostninger",
      "materialsCost": "Materiale Omkostninger",
      "totalCost": "Samlet Omkostning"
    },
    "stats": {
      "draft": "Kladde",
      "sent": "Sendt", 
      "accepted": "Accepteret",
      "declined": "Afvist",
      "completed": "Fuldført",
      "invoiced": "Faktureret",
      "paid": "Betalt",
      "quotes": "Tilbud",
      "jobs": "Jobs",
      "rejected": "Afvist",
      "unassigned": "Ikke tildelt",
      "inProgress": "I gang",
      "onHold": "På Pause",
      "toInvoice": "Job Til faktura",
      "complete": "Fuldført",
      "cancelled": "Annulleret",
      "overdue": "Forfaldne",
      "pending": "Ventende",
      "approved": "Godkendt",
      "organizationOverview": "Organisations Oversigt",
      "offers": "Tilbud",
      "invoices": "Fakturaer",
      "bills": "Regninger",
      "clickToView": "Klik for at se alle tilbud",
      "clickToViewJobs": "Klik for at se alle jobs",
      "clickToViewInvoices": "Klik for at se alle fakturaer",
      "clickToViewBills": "Klik for at se alle regninger"
    },
    "priorityStatus": {
      "priority": "Prioritet",
      "jobType": "Jobtype",
      "jobDates": "Job Datoer",
      "teamMember": "Teammedlem",
      "customerInfo": "Kundeinfo",
      "startDate": "Startdato",
      "endDate": "Slutdato",
      "assignedTo": "Tildelt til",
      "selectTeamMember": "Vælg teammedlem",
      "noTeamMemberAssigned": "Intet teammedlem tildelt"
    },
    "priorities": {
      "low": "Lav",
      "medium": "Medium",
      "high": "Høj",
      "urgent": "Akut"
    },
    "jobTypes": {
      "maintenance": "Vedligeholdelse",
      "inspection": "Inspektion", 
      "installation": "Installation",
      "repair": "Reparation",
      "consultation": "Konsultation",
      "service": "Service",
      "callOut": "Udkald"
    },
    "serviceAgreement": {
      "title": "Serviceaftale",
      "description": "Konfigurer dette job som en tilbagevendende serviceaftale med tildelt teammedlem",
      "makeRecurring": "Gør dette til en tilbagevendende serviceaftale",
      "serviceFrequency": "Service Frekvens",
      "serviceSchedule": "Service Tidsplan",
      "daysOfWeek": "Dage i Ugen",
      "dayOfMonth": "Dag i Måneden",
      "monthOfQuarter": "Måned i Kvartalet",
      "monthOfYear": "Måned i Året",
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "endDateLabel": "Serviceaftale Slutdato (Valgfri)",
      "endDateDescription": "Lad være tom for en løbende serviceaftale. Sæt en dato for automatisk at afslutte de tilbagevendende services.",
      "timeWindowDescription": "Sæt det foretrukne tidsvindue for serviceaftaler",
      "assignedTeamMember": "Tildelt Teammedlem",
      "selectTeamMember": "Vælg et teammedlem...",
      "loadingTeamMembers": "Indlæser teammedlemmer...",
      "pleasSelectAtLeastOneDay": "Vælg venligst mindst én dag i ugen",
      "saveChanges": "Gem Ændringer",
      "savingChanges": "Gemmer Ændringer...",
      "saving": "Gemmer...",
      "saveSchedule": "Gem Tilbagevendende Tidsplan",
      "configuredSchedule": "Dette job er konfigureret som en tilbagevendende serviceaftale med følgende tidsplan:",
      "activeTitle": "Serviceaftale Aktiv",
      "activeDescription": "Dette job er konfigureret som en tilbagevendende serviceaftale med følgende tidsplan:",
      "frequency": "Frekvens",
      "serviceTime": "Servicetid",
      "days": "Dage",
      "month": "Måned",
      "assignedTo": "Tildelt til",
      "schedule": "Tidsplan",
      "timeWindow": "Tidsvindue",
      "automatically": "Automatisk"
    },
    "frequencies": {
      "daily": "Daglig",
      "weekly": "Ugentlig",
      "biweekly": "Hver anden uge", 
      "monthly": "Månedlig",
      "quarterly": "Kvartalsvis",
      "annually": "Årlig"
    },
    "daysOfWeek": {
      "monday": "Mandag",
      "tuesday": "Tirsdag",
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lørdag",
      "sunday": "Søndag",
      "mon": "Man",
      "tue": "Tir",
      "wed": "Ons",
      "thu": "Tor",
      "fri": "Fre",
      "sat": "Lør",
      "sun": "Søn"
    },
    "months": {
      "january": "Januar",
      "february": "Februar",
      "march": "Marts",
      "april": "April",
      "may": "Maj",
      "june": "Juni",
      "july": "Juli",
      "august": "August", 
      "september": "September",
      "october": "Oktober",
      "november": "November",
      "december": "December"
    },
    "ordinals": {
      "lastDay": "Sidste dag i måneden",
      "first": "1.",
      "second": "2.",
      "third": "3.", 
      "nth": "{{number}}."
    },
    "projectTimeline": "Projekt Tidslinje",
    "unknownMember": "Ukendt Medlem",
    "unknown": "Ukendt",
    "currentCustomer": "Nuværende Kunde",
    "changeTo": "Skift til",
    "priorityLevel": "Prioritetsniveau",
    "jobType": "Jobtype",
    "priority": {
      "high": "Høj Prioritet",
      "medium": "Middel Prioritet", 
      "low": "Lav Prioritet"
    }
  },
  "jobs": {
    "activeJobs": "Aktive Job",
    "searchJobs": "Søg job...",
    "newJob": "Nyt Job",
    "allJobs": "Alle Job",
    "unassignedJobs": "Ikke-tildelte Job",
    "inProgressJobs": "Aktive Job",
    "onHoldJobs": "Job på Pause",
    "toInvoiceJobs": "Job til Fakturering",
    "completeJobs": "Færdige Job",
    "cancelledJobs": "Annullerede Job",
    "viewAndManageJobs": "Se og administrer alle dine job",
    "allJobsWithStatus": "Alle job med \"{{status}}\" status",
    "noJobsFound": "Ingen job fundet",
    "noJobsFoundSearch": "Ingen job matcher din søgning efter \"{{searchTerm}}\"",
    "noJobsFoundStatus": "Der er ingen {{status}} job endnu",
    "title": "Titel",
    "customer": "Kunde",
    "status": "Status",
    "viewDetails": "Se detaljer",
    "statusBadges": {
      "inProgress": "Aktive",
      "onHold": "På Pause",
      "complete": "Færdig",
      "cancelled": "Annulleret",
      "toInvoice": "Til Fakturering",
      "unassigned": "Ikke-tildelt"
    },
    "tabs": {
      "all": "Alle",
      "unassigned": "Ikke-tildelt",
      "inProgress": "Aktive",
      "onHold": "På Pause",
      "toInvoice": "Til Fakturering",
      "complete": "Færdig",
      "cancelled": "Annulleret"
    }
  },
  "addressInput": {
    "customer": "Kunde",
    "selectCustomer": "Vælg en kunde",
    "address": "Adresse",
    "enterAddress": "Indtast adresse eller vælg en kunde",
    "linkedToCustomer": "Tilknyttet kunde",
    "description": "Beskrivelse",
    "characters": "tegn",
    "startDate": "Start dato",
    "expiryDate": "Udløbsdato",
    "save": "Gem",
    "saving": "Gemmer...",
    "searchCustomer": "Søg efter kunde",
    "customerInformation": "Kundeinformation",
    "selectOrAddCustomer": "Vælg eller tilføj en kunde til dette tilbud",
    "addNewCustomer": "Tilføj ny kunde",
    "customerDetails": "Kundedetaljer",
    "editCustomer": "Rediger Kunde",
    "site": "Lokalitet",
    "selectSite": "Vælg en lokalitet (valgfrit)",
    "selectCustomerFirst": "Vælg en kunde først",
    "loadingSites": "Indlæser lokaliteter...",
    "addNewSite": "Tilføj ny lokalitet",
    "editSelectedSiteTooltip": "Rediger valgt lokalitet",
    "editSite": "Rediger lokalitet",
    "quoteDetails": "Tilbudsdetaljer",
    "preview": "Forhåndsvisning",
    "customerId": "Kunde ID",
    "customerIdPlaceholder": "Søg efter kunder...",
    "createNewCustomer": "Opret ny kunde",
    "edit": "Rediger",
    "noCustomersFound": "Ingen kunder fundet",
    "selectOption": "Vælg en mulighed",
    "selectCustomerToEnableSite": "Vælg en kunde for at aktivere lokalitetsvalg",
    "noSitesAvailable": "Ingen lokaliteter tilgængelige for denne kunde. Tilføj en ny lokalitet.",
    "loadingSiteInformation": "Indlæser lokalitetsinformation...",
    "siteDetails": "Detaljer",
    "addressLabel": "Adresse:",
    "contactLabel": "Kontakt:",
    "notProvided": "Ikke angivet",
    "pleaseSelectCustomerFirst": "Vælg venligst en kunde først",
    "errorOpeningCustomerDialog": "Fejl ved åbning af kunde-dialog. Prøv venligst igen.",
    "failedToOpenSiteModal": "Kunne ikke åbne lokalitets-modal",
    "pleaseSelectCustomerFirstTooltip": "Vælg venligst en kunde først",
    "addNewSiteTooltip": "Tilføj ny lokalitet",
    "siteNotBelongToCustomer": "Lokaliteten tilhører ikke den valgte kunde",
    "rateLimitReached": "Hastighedsgrænse nået. Prøv venligst igen senere.",
    "databaseConnectionLimit": "Database forbindelsesgrænse nået. Prøv venligst igen senere.",
    "connectionLimitReached": "Forbindelsesgrænse nået. Prøv venligst igen om et øjeblik.",
    "failedToUpdateSiteData": "Kunne ikke opdatere lokalitetsdata. Prøv venligst igen.",
    "navigationTakingLonger": "Navigation tager længere tid end forventet. Prøv venligst igen.",
    "companyLabel": "Firma:",
    "emailLabel": "E-mail:",
    "phoneLabel": "Telefon:",
    "phone": "Telefon",
    "email": "E-mail",
    "addCustomer": "Tilføj Kunde",
    "addSite": "Tilføj Lokalitet",
    "bothDatesRequired": "Begge datoer er påkrævet",
    "enterDescriptionAndTimeFrame": "Indtast beskrivelsen og tidsrammen for tilbuddet",
    "endDate": "Slut dato",
    "quoteStatus": "Tilbudsstatus",
    "termsAndNotes": "Vilkår & Noter",
    "setTermsAndNotes": "Angiv vilkårene og yderligere noter for dette tilbud",
    "uploadRelatedDocuments": "Upload relaterede dokumenter",
    "openingCustomerPage": "Åbner Kunde Side...",
    "viewCustomer": "Se Kunde",
    "mustSelectCustomerFirst": "Du skal vælge en kunde før du vælger et site",
    "siteCannotBeAccessed": "Dette site kan ikke tilgås med den nuværende kunde",
    "siteBelongsToDifferentCustomer": "Dette site tilhører en anden kunde",
    "pleaseSelectCustomerFromList": "Vælg venligst en kunde fra listen",
    "startDateAndExpiryRequired": "Startdato og udløbsdato er påkrævet",
    "failedToSaveChanges": "Kunne ikke gemme ændringer",
    "invalidBoardId": "Ugyldigt board ID",
    "errorLinkingCustomer": "Fejl ved tilknytning af kunde til tilbud. Prøv at gemme manuelt.",
    "failedToSaveSiteSelection": "Kunne ikke gemme site-valg. Prøv igen.",
    "failedToUpdateBoard": "Kunne ikke opdatere board",
    "allChangesSavedSuccessfully": "Alle ændringer gemt succesfuldt",
    "customerSelectedForQuote": "Kunde valgt til dette tilbud",
    "customerCreatedSuccessfully": "Kunde oprettet succesfuldt",
    "siteCreatedAndSelected": "Site oprettet og valgt succesfuldt",
    "overview": "Oversigt",
    "details": "Detaljer",
    "pricing": "Prissætning",
    "aiFixGrammar": "Ret Grammatik",
    "aiMakeFormal": "Skrive i et formelt sprog",
    "aiImproving": "Forbedrer...",
    "aiFormalizing": "Formaliserer...",
    "aiFixGrammarTooltip": "Ret grammatik og stavning med AI",
    "aiMakeFormalTooltip": "Omskriv i formel tone med AI",
    "aiBusinessLicenseRequired": "Erhvervslicens krævet for AI-funktioner",
    "aiBusinessLicenseRequiredBadge": "AI-funktioner kræver erhvervslicens",
    "aiBusinessLicenseRequiredToast": "Erhvervslicens krævet for AI-funktioner",
    "aiEnterDescriptionFirst": "Indtast venligst først en beskrivelse",
    "aiDescriptionTooShort": "Beskrivelsen skal være mindst 10 tegn for at bruge AI-forbedring",
    "aiMinimumCharacters": "Indtast mindst 10 tegn for at bruge AI-forbedring",
    "aiGrammarImproved": "Grammatik og stavning forbedret med succes",
    "aiFormalImproved": "Teksten er blevet omskrevet i formel tone",
    "aiInvalidResponse": "Ugyldigt svar fra AI-tjeneste",
    "aiFailedToImprove": "Kunne ikke forbedre beskrivelsen. Prøv igen.",
    "selectSiteToViewDetails": "Vælg et sted for at se detaljer",
    "cancel": "Annuller",
    "savingChanges": "Gemmer ændringer...",
    "unsavedChangesWarning": "Du har ikke-gemte ændringer. Klik venligst Gem før du forlader siden.",
    "unsavedChangesTitle": "Ikke-gemte ændringer opdaget",
    "unsavedChangesMessage": "Du har ikke-gemte ændringer til dette tilbud. Hvis du forlader nu, vil dine ændringer gå tabt.",
    "unsavedChangesHint": "Klik \"Gem & Forlad\" for at beholde dine ændringer, eller \"Forlad uden at gemme\" for at kassere dem.",
    "saveAndLeave": "Gem & Forlad",
    "leaveWithoutSaving": "Forlad uden at gemme",
    "stayOnPage": "Bliv på siden",
    "saveBeforeLeaving": "Gem venligst dine ændringer før du forlader denne side",
    "saveNow": "Gem Nu",
    "termsShort": "Vilkår",
    "previewShort": "PDF",
    "newQuote": "Nyt Tilbud",
    "quote": "Tilbud",
    "quoteId": "Tilbuds-ID",
    "organizationName": "Organisationsnavn",
    "organizationDetailsInSettings": "Rediger i Indstillinger",
    "contact": "Kontakt",
    "noAddressProvided": "Ingen adresse angivet",
    "enterProjectDescription": "Indtast en beskrivelse af projektet eller arbejdet, der skal udføres...",
    "moreItems": "flere varer",
    "noProductsAdded": "Ingen produkter tilføjet endnu",
    "goToPricingTab": "Gå til Prissætning for at tilføje varer",
    "noLaborAdded": "Ingen arbejdstimer tilføjet endnu",
    "noTermsSet": "Ingen vilkår angivet - standardvilkår vil blive brugt",
    "noNotesSet": "Ingen yderligere noter",
    "pdfPreview": "PDF Forhåndsvisning",
    "sendOfferEmail": "Send Tilbud",
    "generating": "Genererer...",
    "sendOfferToCustomer": "Send Tilbud til Kunde",
    "sendOfferDescription": "Send et link til din kunde, hvor de kan se og svare på dette tilbud.",
    "offerLink": "Delbart Tilbudslink",
    "customerCanViewAndRespond": "Din kunde kan se tilbudsdetaljerne og acceptere eller anmode om ændringer via dette link.",
    "to": "Til",
    "subject": "Emne",
    "message": "Besked",
    "openEmailClient": "Åbn E-mail Program",
    "copy": "Kopier",
    "copied": "Kopieret!",
    "linkCopied": "Link kopieret til udklipsholder",
    "failedToCopyLink": "Kunne ikke kopiere link",
    "emailClientOpened": "E-mail program åbnet",
    "noCustomerLinked": "Ingen kunde tilknyttet dette tilbud",
    "customerNotFound": "Kunde ikke fundet",
    "customerNoEmail": "Kunden har ingen e-mailadresse",
    "saveBeforeSending": "Gem venligst ændringer før afsendelse af tilbuddet",
    "failedToGenerateOfferLink": "Kunne ikke generere tilbudslink"
  },
  "customerModal": {
    "companyNameRequired": "Firmanavn er påkrævet",
    "addressRequired": "Adresse er påkrævet",
    "orgIdMissing": "Organisations-ID mangler",
    "networkError": "Netværksfejl - intet svar modtaget",
    "invalidResponse": "Ugyldigt svar fra serveren",
    "createFailed": "Kunne ikke oprette kunde",
    "missingId": "Ugyldige svardata - mangler kunde-ID",
    "createSuccess": "Kunde oprettet succesfuldt",
    "handlingError": "Fejl ved håndtering af ny kunde. Prøv venligst igen.",
    "createError": "Kunne ikke oprette kunde",
    "selectCustomer": "Vælg Kunde",
    "close": "Luk",
    "createNew": "Opret Ny Kunde",
    "companyName": "Firmanavn",
    "companyNamePlaceholder": "Indtast firmanavn",
    "address": "Adresse",
    "addressPlaceholder": "Indtast adresse",
    "email": "E-mail",
    "emailPlaceholder": "kunde@eksempel.dk",
    "phoneNumber": "Telefonnummer",
    "phonePlaceholder": "+45 12 34 56 78",
    "cvrNumber": "CVR-nummer",
    "cvrPlaceholder": "12345678",
    "cancel": "Annuller",
    "creating": "Opretter...",
    "createCustomer": "Opret Kunde"
  },
  "siteModal": {
    "createSuccess": "Lokalitet oprettet succesfuldt",
    "createFailed": "Kunne ikke oprette lokalitet",
    "updateSuccess": "Lokalitet opdateret succesfuldt",
    "updateFailed": "Kunne ikke opdatere lokalitet",
    "nameAddressRequired": "Navn og adresse er påkrævet",
    "submitFailed": "Kunne ikke indsende lokalitetsdata. Prøv venligst igen.",
    "editSite": "Rediger Lokalitet",
    "createNew": "Opret Ny Lokalitet",
    "updateDescription": "Opdater lokalitetsinformationen nedenfor.",
    "createDescription": "Indtast detaljerne for den nye lokalitet.",
    "siteName": "Lokalitetsnavn",
    "siteNamePlaceholder": "Indtast lokalitetsnavn",
    "address": "Adresse",
    "addressPlaceholder": "Indtast lokalitetsadresse",
    "contactPerson": "Kontaktperson",
    "contactPlaceholder": "Indtast kontaktnavn",
    "phoneNumber": "Telefonnummer",
    "phonePlaceholder": "Indtast telefonnummer",
    "email": "E-mail",
    "emailPlaceholder": "Indtast e-mailadresse",
    "cancel": "Annuller",
    "saving": "Gemmer...",
    "saveChanges": "Gem Ændringer",
    "createSite": "Opret Lokalitet"
  },
  "boardPriceSummary": {
    "title": "Prisoversigt",
    "description": "Samlet omkostningsoversigt over materialer og arbejdskraft",
    "category": "Kategori",
    "subtotal": "Subtotal",
    "subtotalExclVat": "Subtotal (ekskl. moms)",
    "materials": "Materialer",
    "labor": "Arbejdskraft",
    "items": "varer",
    "item": "vare",
    "include25Vat": "Inkluder 25% moms",
    "notApplied": "Ikke anvendt",
    "discount": "Rabat",
    "percentage": "Procent",
    "fixedAmount": "Fast Beløb",
    "noDiscount": "Ingen rabat",
    "total": "Total",
    "inclVat": "(inkl. moms)",
    "savePriceSummary": "Gem Prisoversigt",
    "priceSummarySaved": "Prisoversigt gemt succesfuldt",
    "failedToSavePriceSummary": "Kunne ikke gemme prisoversigt",
    "profitAnalysis": "Avanceanalyse",
    "combinedTotals": "Kombinerede Totaler",
    "profit": "Avance",
    "totalCost": "Samlet Omkostning",
    "totalPrice": "Samlet Pris",
    "margin": "Margin",
    "salesPrice": "Salgspris",
    "costPrice": "Omkostningspris",
    "totelProfit": "Samlet Avance",
    "totalSales": "Samlet Salg",
    "costPrice": "Omkostningspris",
    "COMBINEDTOTAL": "Kombiner",
    "totalProfit": "Samlet Avance",
    "costs": "Omkostninger",
    "totalCostPrice": "Samlet Omkostningspris",
    "grossProfit": "Bruttoavance",
    "profitMargin": "Avancemargin",
    "marginOnCost": "Margin på Omkostninger",
    "combinedTotal": "Kombineret Total",
    "profitStatus": {
      "excellent": "Fremragende",
      "good": "God",
      "fair": "Rimelig",
      "low": "Lav",
      "loss": "Tab"
    }
  },
  "boardProfitAnalysis": {
    "description": "Omkostning vs. salg analyse og avancemarginer",
    "addItemsToSeeAnalysis": "Tilføj produkter eller arbejdskraft for at se avanceanalyse",
    "noDataYet": "Ingen data endnu",
    "addProductsOrLabor": "Tilføj produkter eller arbejdskraft for at se avanceanalyse",
    "marginsAndAnalysis": "Avancemarginer & Analyse"
  },
  "boardActivity": {
    "created": "Tilbud oprettet",
    "emailSent": "Tilbud sendt via e-mail",
    "statusChanged": "Status ændret",
    "offerAccepted": "Tilbud accepteret",
    "convertedToJob": "Konverteret til aktiv opgave",
    "offerReopened": "Tilbud genåbnet",
    "createdBy": "Oprettet af {{userName}}",
    "sentByTo": "Sendt af {{userName}} til {{recipient}}",
    "changedBy": "Ændret af {{userName}} fra {{oldStatus}} til {{newStatus}}",
    "acceptedBy": "Accepteret af {{userName}} den {{date}}",
    "convertedByWithDate": "Konverteret til \"{{jobTitle}}\" af {{userName}} den {{date}}",
    "reopenedBy": "Genåbnet af {{userName}} den {{date}}",
    "reopenedFromDeclined": "Genåbnet fra \"{{oldStatus}}\" af {{userName}} den {{date}}",
    "reopenedFromAdminApproved": "Genåbnet fra \"{{oldStatus}}\" af {{userName}} den {{date}}",
    "reopenedFromAccepted": "Genåbnet fra \"{{oldStatus}}\" af {{userName}} den {{date}}",
    "reopenedFromActiveJob": "Genåbnet fra \"{{oldStatus}}\" af {{userName}} den {{date}}"
  },
  "boardStatus": {
    "newOffer": "Nyt Tilbud",
    "newOfferDescription": "Nyoprettet tilbud afventer gennemgang",
    "pendingOffer": "Afventende Tilbud",
    "pendingOfferDescription": "Tilbud klar til gennemgang",
    "pendingAdminApproval": "Afventer Administratorgodkendelse",
    "pendingAdminApprovalDescription": "Venter på administratorgodkendelse",
    "adminApproved": "Administrator Godkendt",
    "adminApprovedDescription": "Godkendt af administrator, afventer kundeaccept",
    "accepted": "Accepteret",
    "acceptedDescription": "Tilbud er blevet accepteret og godkendt",
    "activeJob": "Aktivt Job",
    "activeJobDescription": "Arbejdet er påbegyndt - flyttet til aktive job",
    "declined": "Afvist",
    "declinedDescription": "Tilbud er blevet afvist",
    "awaitingAdminApproval": "Afventer administratorgodkendelse før kundeaccept",
    "requirementsNotMet": "Krav ikke opfyldt",
    "missing": "Mangler",
    "markAccepted": "Marker som Accepteret",
    "markDeclined": "Marker som Afvist",
    "reopenForEdit": "Genåbn til Redigering",
    "awaitingAdmin": "Afventer administratorgennemgang",
    "viewJob": "Se Job",
    "failedToUpdateStatus": "Kunne ikke opdatere status",
    "convertingToActiveJob": "Konverterer til Aktivt Job - Omdirigerer til aktivt job om 2 sekunder...",
    "statusUpdated": "Status Opdateret - Tilbudsstatus ændret til {{label}}",
    "failedToUpdateQuoteStatus": "Kunne ikke opdatere tilbudsstatus. Prøv venligst igen.",
    "reviewActivateOffer": "Gennemgå & Aktiver Tilbud",
    "reviewActivateOfferDescription": "Gennemgå tilbudsdetaljer og aktiver det til behandling",
    "activateOfferConfirmTitle": "Aktiver Dette Tilbud?",
    "activateOfferConfirmDescription": "Dette vil flytte tilbuddet til \"Afventende Tilbud\" status, så det er klar til gennemgang og potentiel accept.",
    "sendForAdminApproval": "Send til Administratorgodkendelse",
    "sendForAdminApprovalDescription": "Indsend dette tilbud til administratorgennemgang og godkendelse",
    "requestAdminApprovalConfirmTitle": "Anmod om Administratorgodkendelse?",
    "requestAdminApprovalConfirmDescription": "Dette vil sende tilbuddet til administratorer til gennemgang. Når det er godkendt af en administrator, kan kunder acceptere det.",
    "markAsAccepted": "Marker som accepteret?",
    "markAsAcceptedButton": "Marker som Accepteret",
    "markAsAcceptedDescription": "Accepter dette tilbud direkte (spring administratorgodkendelse over)",
    "directAcceptConfirmTitle": "Accepter Tilbud Direkte?",
    "directAcceptConfirmDescription": "Dette vil markere tilbuddet som accepteret og springe administratorgodkendelsesprocessen over. Tilbuddet vil være klar til at konvertere til et aktivt job.",
    "acceptOfferCustomer": "Accepter Tilbud (Kunde)",
    "acceptOfferCustomerDescription": "Kunde kan nu acceptere dette godkendte tilbud",
    "customerAcceptConfirmTitle": "Kunde Accepterer Tilbud?",
    "customerAcceptConfirmDescription": "Dette simulerer, at kunden accepterer tilbuddet. I produktion ville dette blive gjort af kunden gennem deres interface.",
    "convertToActiveJob": "Konverter til Aktivt Job",
    "convertToActiveJobDescription": "Begynd at arbejde på dette accepterede tilbud",
    "convertJobConfirmTitle": "Konverter til Aktivt Job?",
    "convertJobConfirmDescription": "Dette vil oprette et aktivt job fra dette tilbud og flytte det til job-sektionen. Du vil blive omdirigeret til den nye aktive job-side.",
    "readyForAdminReview": "Klar til Administrator Gennemgang",
    "requiresAdminApproval": "Denne organisation kræver administratorgodkendelse for tilbud. Klik nedenfor for at sende dette tilbud til administratorer til gennemgang og godkendelse.",
    "readyToAccept": "Klar til Accept",
    "readyToProceed": "Når du er klar til at fortsætte med dette tilbud (efter kundebekræftelse), klik på knappen nedenfor for at acceptere tilbuddet og gå videre.",
    "approvedReadyForCustomer": "Godkendt - Klar til Kunde",
    "approvedByAdmin": "Dette tilbud er blevet godkendt af en administrator og er nu klar til kundeaccept. Du kan fortsætte med accept, afvisning eller genåbne til yderligere gennemgang.",
    "reopenForReview": "Genåbn til Gennemgang",
    "reopenConfirmTitle": "Genåbn til Gennemgang?",
    "reopenConfirmMessage": "Dette vil flytte tilbuddet tilbage til \"Afventende Tilbud\" status og fjerne administratorgodkendelsen. Tilbuddet skal gennemgå godkendelsesprocessen igen, hvis administratorgodkendelse er påkrævet.",
    "markAsDeclined": "Marker som Afvist",
    "declineConfirmTitle": "Marker som Afvist?",
    "declineConfirmMessage": "Dette vil markere tilbuddet som afvist. Denne handling indikerer, at tilbuddet er blevet afvist og vil opdatere status tilsvarende. Dette kan ikke nemt fortrydes.",
    "acceptThisOffer": "Accepter Dette Tilbud?",
    "acceptConfirmMessage": "Dette vil markere tilbuddet som accepteret og give dig mulighed for at fortsætte med at konvertere det til et aktivt job. Du kan gøre dette, når kunden har bekræftet, at de ønsker at fortsætte.",
    "confirmReopen": "Bekræft Genåbning",
    "confirmDecline": "Bekræft Afvisning", 
    "confirmAccept": "Bekræft Accept",
    "offerAcceptedTitle": "Tilbud Accepteret",
    "offerAcceptedDescription": "Dette tilbud er blevet accepteret og er klar til at blive konverteret til et aktivt job. Du kan fortsætte med konvertering eller genåbne for ændringer hvis nødvendigt.",
    "markAsDeclinedButton": "Marker som Afvist",
    "declineConfirmTitleAdmin": "Marker som Afvist?",
    "declineConfirmMessageAdmin": "Dette vil markere tilbuddet som afvist. Denne handling indikerer, at tilbuddet er blevet afvist og vil opdatere status tilsvarende. Dette kan ikke nemt fortrydes.",
    "acceptOfferCustomerButton": "Accepter Tilbud (Kunde)",
    "customerAcceptOfferTitle": "Kunde Accepterer Tilbud?",
    "customerAcceptOfferDescription": "Dette simulerer, at kunden accepterer tilbuddet. I produktion ville dette blive gjort af kunden gennem deres interface.",
    "reopenOfferButton": "Genåbn Tilbud",
    "reopenOfferTitle": "Genåbn Dette Tilbud?",
    "reopenOfferDescription": "Dette vil flytte tilbuddet tilbage til \"Afventende Tilbud\" status og fjerne accepten. Du kan derefter foretage ændringer eller gennemgå godkendelsesprocessen igen hvis nødvendigt.",
    "convertJobButton": "Konverter til Aktivt Job",
    "convertJobDialogTitle": "Konverter til Aktivt Job?",
    "convertJobDialogDescription": "Dette vil oprette et nyt aktivt job fra dette accepterede tilbud og flytte det til den aktive jobs sektion. Alle priser og detaljer vil blive kopieret over, og du vil blive omdirigeret til den aktive jobs side for at begynde at spore arbejdsfremskridt.",
    "confirmConvert": "Bekræft Konvertering",
    "newOfferCreatedTitle": "Nyt Tilbud Oprettet",
    "newOfferCreatedDescription": "Dette tilbud er blevet nyoprettet og venter på at blive aktiveret. Du kan aktivere det for at fortsætte med godkendelsesprocessen eller nulstille det, hvis der er behov for ændringer.",
    "resetOfferButton": "Nulstil Tilbud",
    "resetOfferTitle": "Nulstil Dette Tilbud?",
    "resetOfferDescription": "Dette vil nulstille tilbuddet tilbage til dets oprindelige nye tilstand. Enhver fremgang eller ændringer vil blive bevaret, men status forbliver som \"Nyt Tilbud\" for yderligere ændringer.",
    "confirmReset": "Bekræft Nulstilling",
    "reviewActivateOfferButton": "Gennemgå & Aktiver Tilbud",
    "activateOfferTitle": "Aktiver Dette Tilbud?",
    "activateOfferDescription": "Dette vil flytte tilbuddet til \"Afventende Tilbud\" status, så det er klar til gennemgang og potentiel accept. Når det er aktiveret, vil tilbuddet indgå i godkendelsesarbejdsgangen.",
    "confirmActivate": "Bekræft Aktivering",
    "confirm": "Bekræft",
    "offerDeclinedTitle": "Tilbud Afvist",
    "offerDeclinedDescription": "Dette tilbud er blevet afvist og vil ikke fortsætte videre. Du kan genåbne tilbuddet nedenfor, hvis omstændighederne har ændret sig.",
    "reopenDeclinedOfferTitle": "Genåbn Dette Tilbud?",
    "reopenDeclinedOfferDescription": "Dette vil flytte tilbuddet tilbage til \"Afventende Tilbud\" status, så du kan fortsætte med accept eller foretage ændringer. Tilbuddet vil være tilgængeligt til gennemgang og accept igen.",
    "awaitingAdminApprovalTitle": "Afventer Administratorgodkendelse",
    "awaitingAdminApprovalDescription": "Dette tilbud er blevet indsendt til administratorgennemgang. En administrator vil gennemgå og enten godkende eller anmode om ændringer. Du vil blive underrettet, når der er truffet en beslutning.",
    "convertedToActiveJobTitle": "✓ Dette tilbud er blevet konverteret til et aktivt job",
    "convertedToActiveJobDescription": "Tjek sektionen Aktive Jobs for at administrere dette projekt",
    "reopenActiveJobOfferTitle": "Genåbn Dette Tilbud?",
    "reopenActiveJobOfferDescription": "Dette vil flytte tilbuddet tilbage til \"Afventende Tilbud\" status, hvilket effektivt omvendt konverteringen til aktivt job. Det aktive job forbliver, men tilbudsstatussen nulstilles til yderligere ændringer.",
    "goToActiveJobButton": "Gå til Aktivt Job",
    "cancel": "Annuller",
    "updating": "Opdaterer...",
    "loadingOfferSettings": "Indlæser tilbudsindstillinger...",
    "convertingToActiveJobMessage": "Konverterer til Aktivt Job",
    "progress": "Fremskridt",
    "pleaseWaitCreatingJob": "Vent venligst mens vi opretter dit aktive job..."
  },
  "boardNotes": {
    "title": "Noter",
    "editNotes": "Rediger Noter",
    "cancel": "Annuller",
    "save": "Gem",
    "saving": "Gemmer...",
    "addNotesPlaceholder": "Tilføj dine noter her...",
    "characters": "tegn",
    "noNotesAdded": "Der er ikke tilføjet noter endnu.",
    "notesSavedSuccess": "Noter gemt med succes",
    "failedToSaveNotes": "Kunne ikke gemme noter"
  },
  "boardTerms": {
    "title": "Vilkår & Betingelser",
    "editTerms": "Rediger Vilkår",
    "cancel": "Annuller",
    "save": "Gem",
    "saving": "Gemmer...",
    "enterTermsPlaceholder": "Indtast vilkår og betingelser...",
    "characters": "tegn",
    "noTermsAdded": "Ingen vilkår er tilføjet endnu.",
    "termsSavedSuccess": "Vilkår gemt succesfuldt",
    "failedToSaveTerms": "Kunne ikke gemme vilkår"
  },
  "board": {
    "backToOffers": "Tilbage til Tilbud"
  },
  "boardOptions": {
    "viewPdf": "Vis PDF",
    "printPdf": "Print PDF",
    "delete": "Slet",
    "deleteConfirmation": "Er du sikker på, at du vil slette dette tilbud? Denne handling kan ikke fortrydes.",
    "offerDeletedSuccess": "Tilbud slettet succesfuldt",
    "failedToPrint": "Kunne ikke printe PDF",
    "navigatingToPdf": "Navigerer til PDF-visning til udskrivning..."
  },
  "offerApprovals": {
    "title": "Tilbudsgodkendelser",
    "subtitle": "Gennemgå og administrer afventende tilbudsgodkendelser",
    "noPendingApprovals": "Ingen Afventende Godkendelser",
    "allOffersReviewed": "Alle tilbud er blevet gennemgået. Nye tilbud, der kræver godkendelse, vil vises her.",
    "pendingReview": "Afventer Gennemgang",
    "projectDescription": "Projektbeskrivelse",
    "projectAddress": "Projektadresse",
    "start": "Start",
    "end": "Slut",
    "hourlyRate": "Timepris",
    "profitMargin": "Fortjenstmargen",
    "taxMargin": "Skattemargen",
    "submittedBy": "Indsendt af",
    "boardId": "Tavle ID",
    "viewDetails": "Se Detaljer",
    "client": "Klient",
    "submitted": "Indsendt",
    "reject": "Afvis",
    "approve": "Godkend",
    "rejectOffer": "Afvis Tilbud",
    "rejectOfferDescription": "Dette tilbud vil blive returneret til indsender til revision. Angiv venligst en grund til afvisning.",
    "reasonForRejection": "Grund til afvisning",
    "rejectionPlaceholder": "Forklar venligst hvorfor dette tilbud bliver afvist og hvilke ændringer der er nødvendige...",
    "cancel": "Annuller",
    "rejectOfferAction": "Afvis Tilbud",
    "approveOffer": "Godkend Tilbud",
    "approveOfferDescription": "Dette vil godkende tilbuddet til {{clientName}} til en værdi af {{amount}}. Kunden vil blive underrettet og kan fortsætte med accept.",
    "approveOfferAction": "Godkend Tilbud",
    "refreshOffers": "Opdater Tilbud",
    "failedToLoadOffers": "Kunne ikke indlæse afventende tilbud",
    "offerApprovedSuccess": "Tilbud godkendt succesfuldt",
    "offerRejectedSuccess": "Tilbud afvist succesfuldt",
    "failedToApproveOffer": "Kunne ikke godkende tilbud",
    "failedToRejectOffer": "Kunne ikke afvise tilbud"
  },
  "timeRequests": {
    "title": "Afventende Tidsanmodninger",
    "subtitle": "Gennemgå og godkend medarbejdernes tidsanmodninger",
    "noPendingRequests": "Ingen afventende anmodninger",
    "allRequestsReviewed": "Alle tidsanmodninger er blevet gennemgået",
    "hours": "timer",
    "approve": "Godkend",
    "reject": "Afvis",
    "requestApprovedSuccess": "Anmodning godkendt succesfuldt",
    "requestRejectedSuccess": "Anmodning afvist succesfuldt",
    "failedToUpdateRequest": "Kunne ikke opdatere anmodning",
    "failedToLoadRequests": "Kunne ikke indlæse tidsanmodninger",
    "to": "til",
    "workType": {
      "HOLIDAY": "Ferie",
      "SICK": "Syg",
      "WORK": "Arbejde",
      "OVERTIME": "Overtid"
    }
  },
  "marketing": {
    "redirecting": "Omdirigerer til dit dashboard...",
    "nav": {
      "features": "Funktioner",
      "testimonials": "Anmeldelser",
      "pricing": "Priser",
      "login": "Log ind",
      "startFreeTrial": "Start gratis prøveperiode"
    },
    "hero": {
      "title": "Få styr på",
      "titleHighlight": "hverdagen",
      "titleAnd": "og",
      "titleHighlight2": "hurtigere betaling",
      "subtitle": "Den komplette løsning for håndværkere, der vil spare tid, undgå fejl og få betalt hurtigere. Ingen binding. Prøv gratis i 30 dage.",
      "benefit1": "Mere tid til dit håndværk",
      "benefit2": "Hurtigere betaling",
      "benefit3": "Fuldt overblik over din virksomhed",
      "ctaFree": "Prøv gratis i 30 dage",
      "ctaDemo": "Book demo",
      "socialProof": "Brugt af håndværkere i hele Danmark",
      "helpsText": "Svendetid hjælper med",
      "helpsItem1": "Orderstyrring",
      "helpsItem2": "Timeregistering",
      "helpsItem3": "Fakturering",
      "helpsItem4": "Oprette tilbud",
      "stats": {
        "companies": "Danske håndværkere",
        "support": "Support på dansk",
        "uptime": "Oppetid"
      }
    },
    "trust": {
      "description": "Svendetid er bygget specifikt til danske håndværkere og overholder alle danske regler. Vi forstår din branche – fordi vi har arbejdet tæt sammen med elektrikere, blikkenslagere, tømrere og malere.",
      "item1": {
        "title": "Hundredvis af danske håndværkere",
        "description": "Følg virksomheder som Hansen El-Service, Andersen VVS og Tømrermester Jørgensen"
      },
      "item2": {
        "title": "GDPR-sikker",
        "description": "Alle dine data opbevares sikkert på danske servere"
      },
      "item3": {
        "title": "Dansk support",
        "description": "Få hjælp på dansk, når du har brug for det – ingen callcentre i udlandet"
      },
      "item4": {
        "title": "Nem opsætning",
        "description": "Kom i gang på 10 minutter – ingen teknisk viden krævet"
      },
      "item5": {
        "title": "30 dages gratis prøveperiode",
        "description": "Prøv alle funktioner uden binding eller kreditkort"
      }
    },
    "features": {
      "badge": "Alt du har brug for",
      "title": "Bygget til din arbejdsdag",
      "subtitle": "Alle de værktøjer, du har brug for, til at drive din virksomhed effektivt – fra tilbud til betaling.",
      "quotes": {
        "title": "Tilbud & Fakturaer",
        "description": "Opret professionelle tilbud på få minutter. Send fakturaer direkte fra appen og få betalt hurtigere."
      },
      "scheduling": {
        "title": "Planlægning & Kalender",
        "description": "Hold styr på alle job, deadlines og teammedlemmers tidsplaner i én intuitiv kalender."
      },
      "timeTracking": {
        "title": "Tidsregistrering",
        "description": "Medarbejdere registrerer timer direkte i appen – du får præcis fakturering og lønafregning."
      },
      "materials": {
        "title": "Materialestyring",
        "description": "Hold styr på materialer brugt på hvert job – automatisk inkluderet i fakturering."
      },
      "customers": {
        "title": "Kundestyring",
        "description": "Alle kundeoplysninger, kommunikationshistorik og dokumenter samlet ét sted."
      },
      "jobs": {
        "title": "Jobstyring",
        "description": "Fuldt overblik over alle aktive og afsluttede job med status, økonomi og kommunikation."
      }
    },
    "testimonials": {
      "badge": "Hvad siger brugerne?",
      "title": "Resultater fra virkeligheden",
      "subtitle": "Hør, hvordan danske håndværkere bruger Svendetid til at spare tid og øge indtjeningen.",
      "testimonial1": {
        "quote": "Vi sparede 10 timer om ugen på administration efter vi skiftede til Svendetid. Nu kan vi fokusere på det, vi er gode til – nemlig at installere el.",
        "author": "Lars Hansen",
        "company": "Hansen El-Service • Roskilde"
      },
      "testimonial2": {
        "quote": "Tidligere gik der uger, før vi fik betaling. Nu får vi penge med det samme. Det har ændret vores likviditet fuldstændigt.",
        "author": "Mette Andersen",
        "company": "Andersen VVS • Odense"
      },
      "testimonial3": {
        "quote": "Jeg var skeptisk over for computerløsninger, men Svendetid er så simpelt, at selv mine montører tager det til sig. Vi har aldrig været mere effektive.",
        "author": "Peter Jørgensen",
        "company": "Tømrermester Jørgensen • Aarhus"
      }
    },
    "pricing": {
      "badge": "Gennemsigtig prissætning",
      "title": "Vælg den løsning der passer til dig",
      "subtitle": "Start med Pro-licensen og opgrader til Business+, når du er klar til endnu mere automatisering.",
      "currency": "DKK",
      "perUserMonth": "pr. bruger, pr. måned",
      "pro": {
        "name": "Pro",
        "description": "Den komplette løsning for små og mellemstore virksomheder",
        "included": "Inkluderet i Pro:",
        "feature1": "Tilbud & fakturaer",
        "feature2": "Planlægning & kalender",
        "feature3": "Tidsregistrering",
        "feature4": "Materialestyring",
        "feature5": "Kundestyring",
        "feature6": "Jobstyring",
        "feature7": "Integrationer (e-conomic, Dinero, QuickPay)",
        "feature8": "Dansk support",
        "feature9": "Mobil app",
        "feature10": "Ubegrænsede brugere",
        "cta": "Prøv gratis i 30 dage"
      },
      "business": {
        "badge": "⭐ Mest populær",
        "name": "Business+",
        "description": "Pro + AI-funktioner til endnu større effektivitet",
        "plusFeatures": "Alt fra Pro, plus:",
        "aiTitle": "AI-assisteret arbejde",
        "aiFeature1Title": "Automatisk faktura-indlæsning",
        "aiFeature1Description": "Upload leverandørfakturaer – AI'en læser og registrerer data automatisk",
        "aiFeature2Title": "AI-forbedring af tilbud",
        "aiFeature2Description": "Få hjælp til at forbedre, omskrive og rette stavefejl i dine tilbud",
        "standardFeatures": "Plus alle standardfunktioner:",
        "feature1": "Alle funktioner fra Pro-licensen",
        "feature2": "Prioriteret support",
        "feature3": "Dedikeret onboarding",
        "feature4": "Avanceret rapportering",
        "cta": "Prøv Business+ gratis"
      },
      "whyBusinessPlus": "Hvorfor vælge Business+?",
      "value1Title": "Spar endnu mere tid",
      "value1Description": "AI'en håndterer kedelige opgaver, så du kan fokusere på det vigtige arbejde.",
      "value2Title": "Færre fejl",
      "value2Description": "AI'en fanger stavefejl og foreslår forbedringer, før du sender tilbud ud.",
      "value3Title": "Mere professionelt",
      "value3Description": "Send fejlfrie, velformulerede tilbud der vinder flere kunder."
    },
    "benefits": {
      "title": "Gør hverdagen lettere",
      "subtitle": "Svendetid hjælper dig med at reducere administration, undgå fejl og få et bedre overblik over din virksomhed.",
      "benefit1Title": "Mindre administration",
      "benefit1Description": "Automatiser kedelige opgaver og brug tiden på det, der tæller.",
      "benefit2Title": "Færre fejl",
      "benefit2Description": "Undgå misforståelser og glemte opgaver med digitale arbejdsgange.",
      "benefit3Title": "Bedre overblik",
      "benefit3Description": "Se status på alle job, økonomi og team på ét dashboard.",
      "benefit4Title": "Hurtigere betaling",
      "benefit4Description": "Send fakturaer med det samme og modtag betaling lynhurtigt."
    },
    "footer": {
      "description": "Job-management til danske håndværkere. Spar tid, undgå fejl, og få bedre overblik over din virksomhed.",
      "product": "Produkt",
      "features": "Funktioner",
      "pricing": "Priser",
      "demo": "Demo",
      "integrations": "Integrationer",
      "company": "Virksomhed",
      "about": "Om os",
      "contact": "Kontakt",
      "blog": "Blog",
      "support": "Support",
      "help": "Hjælp",
      "privacy": "Privatlivspolitik",
      "terms": "Servicevilkår",
      "security": "Sikkerhed",
      "copyright": "© {{year}} Svendetid ApS. Alle rettigheder forbeholdes.",
      "madeWith": "Lavet med ❤️ i Danmark",
      "systemStatus": "Alle systemer kører",
      "location": "🇩🇰 Danmark"
    }
  },
  "organizationSettings": {
    "title": "Organisationsindstillinger",
    "description": "Administrer din organisations konfiguration, medlemmer og fakturering.",
    "loading": "Indlæser...",
    "error": "Fejl",
    "accessDenied": "Adgang Nægtet",
    "accessDeniedMessage": "Du har ikke tilladelse til at få adgang til organisationsindstillinger. Kun Pro-administratorer kan administrere disse indstillinger.",
    "common": {
      "error": "Fejl"
    },
    "licenses": {
      "purchaseTeamLicenses": "Køb Team Licenser",
      "addLicensesDescription": "Tilføj licenser til dine teammedlemmer for at få adgang til platformen",
      "numberOfLicenses": "Antal licenser",
      "licenseInfo": "Hvert teammedlem har brug for én licens. 50 DKK pr. licens pr. måned.",
      "pricePerLicense": "Pris pr. licens:",
      "monthlyPrice": "15,00 DKK / måned",
      "total": "Samlet:",
      "totalPrice": "{{price}} DKK / måned",
      "redirectingToCheckout": "Omdirigerer til betalingssiden...",
      "redirecting": "Omdirigerer til betaling...",
      "preparingOrder": "Forbereder din ordre...",
      "purchaseLicenses": "Køb {{count}} {{licensePlural}}",
      "licenseSingular": "Licens",
      "licensePlural": "Licenser",
      "monthly": "Månedlig",
      "annual": "Årlig",
      "annualSave": "Årlig (Spar 20%)",
      "youSave": "Du sparer",
      "month": "måned",
      "year": "år",
      "checkout": "Gå til betaling",
      "billingPeriod": "Betalingsperiode",
      "checkoutError": "Betalingsfejl",
      "unknownError": "Der opstod en ukendt fejl",
      "unlockFullAccess": "Lås op for fuld adgang til platformen for dine teammedlemmer",
      "organizationNotFound": "Organisation ikke fundet",
      "organizationRequired": "Du skal være i en organisation for at købe licenser.",
      "priceIdMissing": "Produktpris ID er ikke konfigureret",
      "minimumLicense": "Vælg venligst mindst 1 licens",
      "licensesUpdated": "Licenser opdateret",
      "subscriptionUpdated": "Dit abonnement har nu {{count}} licenser.",
      "noCheckoutUrl": "Ingen betalings-URL eller abonnementsopdatering blev returneret fra serveren",
      "checkoutFailed": "Kunne ikke starte betalingsprocessen. Prøv venligst igen eller kontakt support.",
      "errorLoadingLicenseData": "Fejl ved indlæsning af licensdata",
      "retry": "Prøv igen",
      "getStarted": "Kom i gang",
      "chooseLicenseType": "Vælg den licenstype, der bedst passer til dine forretningsmæssige behov.",
      "proLicense": "Pro Licens",
      "popular": "Populær",
      "proLicenseDescription": "Perfekt til små og mellemstore teams. Inkluderer grundlæggende projektstyringsfeatures.",
      "proFeatures": {
        "projectManagement": "Projekt- og jobstyring",
        "customerInvoiceManagement": "Kunde- og fakturastyring",
        "basicReporting": "Grundlæggende rapportering",
        "mobileAppAccess": "Mobilapp-adgang",
        "emailSupport": "E-mail support"
      },
      "proDkkPerMonth": "99 DKK/måned per bruger (ekskl. moms)",
      "businessPlusLicense": "Business+ Licens",
      "advanced": "Avanceret",
      "businessPlusDescription": "Til voksende virksomheder, der har brug for avancerede funktioner og prioritetssupport.",
      "businessPlusBenefits": "Fordele ved Business+ over Pro:",
      "businessPlusFeatures": {
        "everythingInPro": "Alt i Pro",
        "advancedAnalytics": "Avanceret analyse og rapportering",
        "teamCollaboration": "Team samarbejdsværktøjer",
        "apiAccess": "API-adgang",
        "priorityPhoneSupport": "Prioriteret telefonsupport",
        "customIntegrations": "Brugerdefinerede integrationer"
      },
      "businessPlusDkkPerMonth": "199 DKK/måned per bruger (ekskl. moms)",
      "loading": "Indlæser...",
      "loadingSubscriptionInfo": "Indlæser abonnementsinformation...",
      "billingManagement": "Faktureringsstyring",
      "billingManagementDescription": "Administrer dit abonnement, se fakturaer og opdater betalingsmetoder.",
      "openBillingPortal": "Åbn Faktureringsportal",
      "needToPurchaseOrRenew": "Har du brug for at købe eller forny?",
      "purchaseRenewDescription": "Hvis dit abonnement er udløbet, eller du har brug for yderligere licenser, kan du købe dem her.",
      "coreFeatures": "Grundlæggende funktioner til små teams",
      "advancedFeaturesPriority": "Avancerede funktioner og prioritetssupport",
      "billingPortalNote": "Hvis du støder på problemer med at få adgang til faktureringsportalen, kan dit abonnement være udløbet eller annulleret. Du kan købe nye licenser ovenfor eller kontakte support for hjælp.",
      "billingPortalError": "Faktureringsportal Fejl",
      "billingPortalErrorDescription": "Kunne ikke åbne faktureringsstyring. Prøv venligst igen.",
      "noSubscriptionFound": "Intet abonnement fundet",
      "noSubscriptionFoundDescription": "Du skal købe licenser først, før du kan få adgang til faktureringsportalen.",
      "loadingPleaseWait": "Licensdata indlæses stadig. Prøv venligst igen om et øjeblik.",
      "noActiveSubscription": "Intet aktivt abonnement fundet. Dit abonnement kan være udløbet eller annulleret. Køb venligst nye licenser eller kontakt support for hjælp.",
      "noBillingAccount": "Ingen faktureringskonto fundet for denne organisation. Kontakt venligst support for at oprette fakturering.",
      "organizationNotFoundError": "Organisation ikke fundet. Kontakt venligst support for hjælp.",
      "licenseAssignment": {
        "title": "Licensfordeling",
        "loadingMembers": "Indlæser teammedlemmer...",
        "errorLoadingMembers": "Fejl ved indlæsning af medlemmer",
        "retry": "Prøv igen",
        "searchPlaceholder": "Søg medlemmer efter navn eller e-mail...",
        "filterAll": "Alle",
        "filterLicensed": "Licenserede",
        "filterUnlicensed": "Ikke-licenserede",
        "noAvailableLicenses": "Ingen tilgængelige licenser",
        "noAvailableLicensesDesc": "Du har ingen tilgængelige licenser at tildele. Køb flere licenser for at tilføje teammedlemmer.",
        "licenseManagementInfo": "Licensstyring",
        "licenseManagementDesc": "Admin-brugere bevarer administrativ adgang uanset licensstatus. Licenser styrer adgangen til premium-funktioner og kan tildeles til ethvert teammedlem.",
        "admin": "Admin",
        "licensed": "Licenseret",
        "you": "Dig",
        "license": "Licens",
        "noMembers": "Ingen medlemmer fundet.",
        "noSearchResults": "Ingen medlemmer matcher din søgning.",
        "licensed_one": "{{count}} licenseret",
        "licensed_other": "{{count}} licenserede",
        "admins_one": "{{count}} admin",
        "admins_other": "{{count}} admins",
        "available_one": "{{count}} tilgængelig",
        "available_other": "{{count}} tilgængelige",
        "licensedCountOf": "{{licensed}} af {{total}} medlemmer har licenser",
        "refresh": "Opdater",
        "refreshing": "Opdaterer...",
        "licenseUpdateSuccess": "Licens opdateret med succes",
        "licenseAssigned": "Licens {{action}} {{user}}.",
        "licenseAssignedTo": "tildelt til",
        "licenseRemovedFrom": "fjernet fra",
        "licenseUpdateFailed": "Licensopdatering mislykkedes",
        "noAvailableLicensesToast": "Ingen tilgængelige licenser",
        "noAvailableLicensesToastDesc": "Du skal købe flere licenser, før du kan tildele dem til brugere.",
        "selected": "valgt",
        "assignToSelected": "Tildel licenser",
        "removeFromSelected": "Fjern licenser",
        "clearSelection": "Ryd",
        "selectAll": "Vælg alle",
        "deselectAll": "Fravælg alle",
        "bulkUpdateSuccess": "Massefordeling fuldført",
        "bulkUpdateFailed": "Massefordeling mislykkedes",
        "insufficientLicenses": "Utilstrækkelige licenser",
        "insufficientLicensesDesc": "Ikke nok tilgængelige licenser til massefordeling",
        "role": "Rolle",
        "roleAdmin": "Administrator",
        "roleMember": "Medlem",
        "changeRole": "Skift rolle",
        "roleUpdateSuccess": "Rolle opdateret",
        "roleUpdateFailed": "Rolleopdatering mislykkedes",
        "cannotRemoveLastAdmin": "Kan ikke fjerne sidste administrator",
        "cannotRemoveLastAdminDesc": "Mindst én administrator er påkrævet for organisationen.",
        "roleUpdatedTo": "Rolle opdateret til {{role}} for {{user}}",
        "updatingRole": "Opdaterer rolle..."
      },
      "manageLicenses": {
        "title": "Licensstyring",
        "loadingPlanInfo": "Indlæser planoplysninger...",
        "managePlanLicenses": "Administrer dine {{plan}} licenser",
        "refreshSubscriptionData": "Opdater abonnementsdata fra Stripe",
        "totalPurchased": "Samlet købt",
        "availableToAssign": "Tilgængelige til tildeling",
        "used": "brugt",
        "currentPlan": "Nuværende plan",
        "businessPlanDesc": "Business+ plan inkluderer avancerede teamsamarbejdsfunktioner, ubegrænset lagerplads og prioritetssupport.",
        "professionalPlanDesc": "Professional plan inkluderer produktivitetsfunktioner, forbedret rapportering og standard support.",
        "standardPlanDesc": "Standard plan inkluderer grundlæggende funktioner. Opgrader til Professional eller Business+ for yderligere muligheder.",
        "totalLicenses": "Samlede licenser",
        "licenseType": "Licenstype",
        "subscriptionStatus": "Abonnementsstatus",
        "source": "Kilde",
        "stripeSubscription": "Stripe Abonnement",
        "database": "Database",
        "pendingInvitations": "Afventende invitationer",
        "pendingInvitationsCount": "Afventende invitationer ({{count}})",
        "show": "Vis",
        "hide": "Skjul",
        "loadingInvitations": "Indlæser invitationer...",
        "invited": "Inviteret {{date}}",
        "invitationsUsingLicenses": "Disse invitationer bruger {{count}} af dine tilgængelige licenser.",
        "inviteTeamMembers": "Inviter teammedlemmer",
        "error": "Fejl",
        "emailDomainIssue": "E-mail domæne problem?",
        "emailDomainDesc": "Hvis du tester med example.com eller lignende domæner, prøv at bruge et rigtigt e-mail domæne i stedet:",
        "emailDomainExamples": "ditnavn+test1@gmail.com (+ adressering), testbruger@outlook.com, eksempel@yahoo.com",
        "alternativeSolutions": "Alternative løsninger:",
        "alternativeSolutionsList": "Bed brugeren om at logge ind direkte til din organisation, Lad dem besøge din organisations login-side, Hvis de ikke har en konto, bed dem om at oprette en først, Tjek om de allerede er medlem under en anden e-mail, Kontakt support hvis brugeren fortsætter med at have adgangsproblemer",
        "success": "Succes",
        "invalidEmails": "Ugyldig e-mail",
        "invalidEmailsPlural": "Ugyldige e-mails",
        "invalidEmailsDesc": "Følgende e-mail adresser er ugyldige:",
        "dismiss": "Afvis",
        "emailAddresses": "E-mail adresser",
        "enterEmailPlaceholder": "Indtast e-mail adresser",
        "add": "Tilføj",
        "emailInstructions": "Indtast flere e-mails adskilt med kommaer eller tryk Tilføj efter hver enkelt. Brug rigtige e-mail domæner (gmail.com, outlook.com) - test domæner som example.com er blokeret.",
        "recipients": "Modtagere",
        "customMessage": "Tilpasset besked (valgfrit)",
        "customMessagePlaceholder": "Tilføj en personlig note til din invitation",
        "availableLicensesInfo": "Du har {{count}} tilgængelig licens.",
        "availableLicensesInfoPlural": "Du har {{count}} tilgængelige licenser.",
        "noLicensesAvailable": "Køb flere licenser for at invitere yderligere teammedlemmer.",
        "sendInvitations": "Send {{count}} invitation",
        "sendInvitationsPlural": "Send {{count}} invitationer",
        "sending": "Sender...",
        "cancel": "Annuller",
        "inviteMembers": "Inviter medlemmer",
        "noAvailableLicenses": "Ingen tilgængelige licenser",
        "purchaseMoreLicenses": "Køb flere licenser før du inviterer teammedlemmer.",
        "inviteFormInstructions": "Brug formularen ovenfor til at invitere teammedlemmer til din organisation",
        "subscriptionDataRefreshed": "Abonnementsdata opdateret",
        "subscriptionRefreshSuccess": "Opdateret til {{plan}} plan med {{quantity}} licenser",
        "refreshFailed": "Opdatering mislykkedes",
        "refreshFailedDesc": "Kunne ikke opdatere abonnementsdata",
        "invitationRevoked": "Invitation tilbagekaldt",
        "invitationRevokedDesc": "Invitation til {{email}} er blevet tilbagekaldt.",
        "failedToRevokeInvitation": "Kunne ikke tilbagekalde invitation",
        "revokeInvitationError": "Der opstod en fejl ved tilbagekaldelse af invitationen"
      },
      "upgradeToBusinessPlus": "Opgrader til Business+",
      "upgradeDescription": "Lås op for avancerede funktioner, prioritetssupport og meget mere for hele dit team.",
      "upgradeNote": "Bemærk",
      "allLicensesUpgradedNote": "Alle licenser vil blive opgraderet. Du debiteres straks for den forholdsmæssige forskel.",
      "viewUpgradeOptions": "Se opgraderingsmuligheder",
      "upgradeAllLicensesDescription": "Alle dine licenser vil blive opgraderet til Business+. Du debiteres straks for den forholdsmæssige forskel.",
      "calculatingCosts": "Beregner opgraderingsomkostninger...",
      "alreadyOnBusinessPlan": "Du er allerede på Business+ planen.",
      "currentPlan": "Nuværende plan",
      "newPlan": "Ny plan",
      "licenseType": "Licenstype",
      "currentMonthlyTotal": "Nuværende månedligt total",
      "newMonthlyTotal": "Nyt månedligt total",
      "immediateCharge": "Øjeblikkelig debitering",
      "proratedChargeExplanation": "Du debiteres i dag for den forholdsmæssige forskel for de resterende dage af din faktureringsperiode.",
      "chargeToday": "Debitering i dag",
      "monthlyIncreaseNote": "Din månedlige regning vil stige fra næste faktureringsperiode.",
      "businessPlusBenefits": "Business+ fordele",
      "allLicensesUpgraded": "Alle licenser opgraderes øjeblikkeligt",
      "cardChargedNow": "Dit kort debiteres øjeblikkeligt",
      "canManageAnytime": "Du kan administrere dit abonnement når som helst via faktureringsportalen",
      "confirmUpgrade": "Bekræft opgradering",
      "processing": "Behandler...",
      "upgradeSuccess": "Opgradering gennemført! 🎉",
      "upgradeError": "Opgraderingsfejl",
      "paymentFailed": "Betaling mislykkedes"
    },
    "language": {
      "english": "Engelsk",
      "danish": "Dansk",
      "englishFlag": "GB Flag",
      "danishFlag": "DK Flag"
    },
    "tabs": {
      "general": "Generelt",
      "members": "Medlemmer",
      "billingRates": "Faktureringssatser",
      "storage": "Lager",
      "licenses": "Licenser"
    },
    "general": {
      "organizationInformation": "Organisationsoplysninger",
      "organizationInformationDesc": "Grundlæggende oplysninger om din organisation",
      "organizationName": "Organisationsnavn",
      "organizationId": "Organisations-ID",
      "organizationLogo": "Organisationslogo",
      "cvrNumber": "CVR-nummer",
      "address": "Adresse",
      "websiteUrl": "Hjemmeside URL",
      "contactEmail": "Kontakt e-mail",
      "additionalInformation": "Yderligere oplysninger",
      "notSpecified": "Ikke angivet",
      "cvrNumberPlaceholder": "12345678",
      "addressPlaceholder": "Indtast organisationens adresse",
      "websiteUrlPlaceholder": "https://eksempel.dk",
      "contactEmailPlaceholder": "kontakt@eksempel.dk",
      "organizationDetails": "Organisationsdetaljer",
      "organizationDetailsDesc": "Tidslinje og medlemsoplysninger",
      "organizationFeatures": "Organisationsfunktioner",
      "organizationFeaturesDesc": "Tilgængelige funktioner og muligheder for denne organisation",
      "organizationSettings": "Organisationsindstillinger",
      "organizationSettingsDesc": "Avancerede konfigurationsmuligheder for din organisation",
      "createdDate": "Oprettelsesdato",
      "memberCount": "Antal medlemmer",
      "members": "medlemmer",
      "member": "medlem",
      "unknown": "Ukendt",
      "edit": "Rediger",
      "update": "Opdater",
      "remove": "Fjern",
      "uploadLogo": "Upload Logo",
      "save": "Gem",
      "cancel": "Annuller",
      "fileSupport": "Understøttede formater: JPEG, PNG, GIF, WebP, ICO (maks. 10MB)",
      "features": {
        "organizationManagement": "Organisationsstyring",
        "memberManagement": "Medlemsstyring",
        "roleBasedAccess": "Rollebaseret adgangskontrol",
        "timeTracking": "Tidsregistrering",
        "projectManagement": "Projektstyring"
      },
      "settingsItems": {
        "billingRates": "Konfigurer faktureringssatser for forskellige servicetyper",
        "storageUsage": "Administrer og overvåg lagerforbrug",
        "licenseAssignment": "Tildel licenser til teammedlemmer",
        "memberRoles": "Definer medlemsroller og tilladelser",
        "timeRegistration": "Konfigurer indstillinger for tidsregistrering",
        "projectJob": "Projekt- og jobadministrationsindstillinger"
      },
      "errors": {
        "organizationNameEmpty": "Organisationsnavnet må ikke være tomt",
        "updateNameFailed": "Kunne ikke opdatere organisationsnavn",
        "invalidFileType": "Ugyldig filtype. Upload venligst en JPEG, PNG, GIF, WebP eller ICO fil",
        "fileSizeTooBig": "Filstørrelse overskrider grænsen på 10MB",
        "updateLogoFailed": "Kunne ikke opdatere organisationslogo",
        "deleteLogoFailed": "Kunne ikke slette organisationslogo",
        "updateDetailsFailed": "Kunne ikke opdatere organisationsoplysninger",
        "invalidWebsiteUrl": "Ugyldigt hjemmeside URL-format",
        "invalidEmail": "Ugyldigt e-mail-format"
      },
      "success": {
        "nameUpdated": "Organisationsnavn blev opdateret",
        "logoUpdated": "Organisationslogo blev opdateret",
        "logoDeleted": "Organisationslogo blev slettet",
        "detailsUpdated": "Organisationsoplysninger blev opdateret"
      },
      "confirmations": {
        "deleteLogo": "Er du sikker på, at du vil slette organisationslogoet?"
      }
    },
    "storage": {
      "title": "Lagerstyring",
      "description": "Administrer din organisations lagertildeling og -forbrug.",
      "loading": "Indlæser lageroplysninger...",
      "errorLoading": "Fejl ved indlæsning af lagerdata",
      "debugInfo": "Fejlsøgningsoplysninger",
      "retry": "Prøv igen",
      "noStats": "Ingen lagerstatistik tilgængelig.",
      "refresh": "Opdater",
      "mockDataNote": "Bemærk: Dette er eksempeldata til demonstrationsformål.",
      "usageDetails": "Forbrugsdetaljer",
      "lastUpdated": "Sidst opdateret",
      "qualityControlDocs": "Kvalitetskontrol dokumenter",
      "files": "filer",
      "ofTotal": "af total",
      "otherStorage": "Anden lagring",
      "storageInformation": "Lageroplysninger",
      "storageInfoDesc": "Din organisations lagertildeling inkluderer:",
      "includedStorage": "10 GB inkluderet i din plan",
      "additionalStorage": "Ekstra lager",
      "perPackage": "pr. lagerpakke",
      "totalAvailableStorage": "Total tilgængelig lagerplads",
      "adminStorageNote": "Som administrator kan du købe yderligere lagerplads nedenfor.",
      "adminStorageNoteDefault": "Som administrator kan du købe yderligere lagerplads efter behov.",
      "errors": {
        "fetchFailed": "Kunne ikke hente lagerstatistik."
      }
    }
  },
  "pdfPreview": {
    "title": "PDF Forhåndsvisning",
    "livePreview": "Live forhåndsvisning af",
    "loading": "Indlæser PDF forhåndsvisning...",
    "fullscreen": "Fuldskærm",
    "exitFullscreen": "Afslut",
    "print": "Udskriv",
    "downloadPdf": "Download PDF",
    "creating": "Opretter PDF...",
    "generating": "Genererer PDF dokument...",
    "downloading": "Downloader...",
    "preparing": "Forbereder dokument til udskrivning...",
    "success": "PDF downloadet med succes!",
    "error": "Kunne ikke generere PDF",
    "printError": "Kunne ikke forberede dokument til udskrivning",
    "noCustomer": "Ingen Kunde",
    "document": "Dokument"
  },
  "pdfTemplate": {
    "invoice": "FAKTURA",
    "quotation": "TILBUD",
    "customer": "Kunde",
    "timeline": "Tidslinje",
    "startDate": "Start",
    "endDate": "Slut",
    "start": "Start:",
    "end": "Slut:",
    "notSet": "Ikke sat",
    "projectDescription": "Projektbeskrivelse",
    "productsAndMaterials": "Produkter og Materialer",
    "noProductsSpecified": "Ingen produkter specificeret",
    "productName": "Produktnavn",
    "quantity": "Antal",
    "unit": "Enhed",
    "unitPrice": "Enhedspris",
    "totalPrice": "Total Pris",
    "description": "Beskrivelse",
    "basePrice": "Grundpris",
    "salesPrice": "Salgspris",
    "discount": "Rabat",
    "finalPrice": "Endelig Pris",
    "laborAndBillingHours": "Arbejde og Faktureringstimer",
    "jobsAndServices": "Job og Tjenester",
    "billingRate": "Faktureringssats",
    "hours": "Timer",
    "ratePerHour": "Pris/Time",
    "total": "Total",
    "billableHours": "Fakturerbare timer",
    "serviceDescription": "Tjenestebeskrivelse",
    "hourlyRate": "Timepris",
    "untitledService": "Unavngivet Tjeneste",
    "financialSummary": "Finansielt Sammendrag",
    "includeVat": "Inkluder moms (25%)",
    "productsTotal": "Produkter Total:",
    "servicesTotal": "Tjenester Total:",
    "subtotal": "Subtotal:",
    "salesTax": "Moms",
    "totalAmount": "Totalt Beløb:",
    "termsAndConditions": "Vilkår og Betingelser",
    "paymentDue30Days": "Betaling forfalder inden 30 dage fra fakturadato",
    "latePaymentCharges": "Forsinket betaling kan medføre yderligere gebyrer",
    "pricesInDKK": "Alle priser er i danske kroner (DKK) og inkluderer gældende skatter",
    "questionsContact": "For spørgsmål vedrørende dette",
    "invoiceLower": "faktura",
    "quotationLower": "tilbud",
    "pleaseContactUs": "kontakt os venligst",
    "defaultTerms": {
      "payment": "• Betaling forfalder inden 30 dage fra fakturadato",
      "latePayment": "• Forsinket betaling kan medføre yderligere gebyrer",
      "prices": "• Alle priser er i danske kroner (DKK) og inkluderer gældende skatter",
      "questions": "• For spørgsmål vedrørende dette {type}, kontakt os venligst"
    },
    "additionalNotes": "Yderligere Bemærkninger",
    "thankYou": "Tak fordi du valgte {organizationName}",
    "generatedOn": "Genereret den {dateTime}"
  },
  "allOffers": "Alle Tilbud",
  "offersOffers": "Tilbud",
  "sentOffers": "Sendt",
  "approvedOffers": "Godkendt",
  "acceptedOffers": "Accepteret",
  "declinedOffers": "Afvist",
  "viewAndManageOffers": "Se og administrer alle dine tilbud",
  "allOffersWithStatus": "Alle tilbud med \"{{status}}\" status",
  "boardInventorySelector": {
    "title": "Lagervarer",
    "description": "Vælg produkter fra lageret til at inkludere i dette tilbud",
    "selectedItems": "Valgte Varer",
    "tableHeaders": {
      "product": "Produkt",
      "purchasePrice": "Købspris",
      "salesPrice": "Salgspris",
      "profitMargin": "Fortjenstmargen",
      "unit": "Enhed",
      "unitPrice": "Enhedspris",
      "quantity": "Antal",
      "total": "Total",
      "actions": "Handlinger"
    },
    "noItemsSelected": "Ingen lagervarer valgt endnu. Gennemse og vælg varer nedenfor.",
    "saveChanges": "Gem Ændringer",
    "addItemsFromInventory": "Tilføj Varer fra Lager",
    "searchDescription": "Søg efter varer at tilføje til dit tilbud",
    "addItem": "Tilføj Vare",
    "searchPlaceholder": "Søg lagervarer...",
    "addFirstMatch": "Tilføj Første Match",
    "refresh": "Opdater",
    "browseItems": "Gennemse Varer",
    "loadingItems": "Indlæser varer...",
    "noItemsFound": "Ingen varer fundet matching \"{{searchTerm}}\"",
    "startTyping": "Begynd at skrive for at søge lagervarer",
    "refreshing": "Opdaterer...",
    "refreshItems": "Opdater Varer",
    "toastMessages": {
      "itemsConnected": "Lagervarer succesfuldt forbundet til tilbud",
      "itemRemoved": "Vare fjernet fra tilbud",
      "itemsSaved": "Lagervarer gemt til tilbud",
      "saveFailed": "Kunne ikke gemme lagervarer"
    }
  },
  "boardLaborSelector": {
    "createNewLaborType": "Opret Ny Arbejdstype",
    "title": "Faktureringstimer",
    "description": "Tilføj fakturerbare timer ved hjælp af din organisations faktureringssatser",
    "selectedBillingRates": "Valgte Faktureringssatser",
    "newLaborType": "Ny Arbejdstype",
    "newLaborDescription": "Opret en ny arbejdstype med kostpris, salgspris og avance.",
    "laborName": "Arbejdsnavn",
    "laborNamePlaceholder": "f.eks. Elektriker, Blikkenslager",
    "laborDescription": "Beskrivelse",
    "descriptionPlaceholder": "Valgfri beskrivelse",
    "costPrice": "Kostpris (DKK/time)",
    "salesPrice": "Salgspris (DKK/time)",
    "profitMargin": "Avance",
    "profitPerHour": "Fortjeneste",
    "cancel": "Annuller",
    "create": "Opret",
    "creating": "Opretter...",
    "tableHeaders": {
      "costPrice": "Kostpris",
      "billingRate": "Faktureringssats",
      "description": "Beskrivelse",
      "ratePerHour": "Sats/Time",
      "hours": "Timer",
      "total": "Total",
      "actions": "Handlinger"
    },
    "noBillingRatesAdded": "Ingen faktureringssatser tilføjet endnu. Gennemse og vælg faktureringssatser nedenfor.",
    "saveChanges": "Gem Ændringer",
    "addBillingRates": "Tilføj Faktureringssatser",
    "searchDescription": "Søg efter faktureringssatser at tilføje til dit tilbud",
    "searchPlaceholder": "Søg faktureringssatser...",
    "addFirstMatch": "Tilføj Første Match",
    "refresh": "Opdater",
    "browseItems": "Gennemse Varer",
    "loadingBillingRates": "Indlæser faktureringssatser...",
    "noBillingRatesFound": "Ingen faktureringssatser fundet matching \"{{searchTerm}}\"",
    "startTyping": "Begynd at skrive for at søge faktureringssatser",
    "refreshing": "Opdaterer...",
    "refreshBillingRates": "Opdater Faktureringssatser",
    "noDescription": "Ingen beskrivelse",
    "default": "Standard",
    "toastMessages": {
      "hoursConnected": "Faktureringstimer succesfuldt forbundet til tilbud",
      "updateFailed": "Kunne ikke opdatere tilbud med faktureringstimer: {{error}}",
      "offline": "Du er i øjeblikket offline. Nogle funktioner er muligvis utilgængelige.",
      "cachedData": "Bruger cachede faktureringssats data. Opdater når du er online igen.",
      "loadFailed": "Kunne ikke indlæse faktureringssatser. Prøv venligst igen senere.",
      "hoursIncreased": "Øgede timer for {{name}}",
      "rateAdded": "Tilføjede {{name}} til tilbud",
      "rateRemoved": "Faktureringssats fjernet fra tilbud",
      "ratesSaved": "Faktureringssatser gemt til tilbud",
      "saveRatesFailed": "Kunne ikke gemme faktureringssatser"
    }
  },
  "inventory": {
    "search": {
      "placeholder": "Søg produkter efter navn eller enhed... (Ctrl+F for fokus, Esc for at rydde)",
      "resultsFound": "{{count}} resultat fundet",
      "resultsFoundPlural": "{{count}} resultater fundet",
      "searchingIn": "Søger i: Produktnavn, Enhed",
      "pressEscToClear": "Tryk Esc for at rydde søgning",
      "clear": "Ryd",
      "clearSearchTitle": "Ryd søgning (Esc)"
    },
    "filters": {
      "title": "Filtre:",
      "showUnusedOnly": "Vis kun ubrugte produkter",
      "showingUnusedProducts": "Viser produkter der ikke er tilknyttet noget aktivt job",
      "selectSupplier": "Vælg Leverandør",
      "allSuppliers": "Alle Leverandører",
      "noSupplier": "Ingen Leverandør",
      "filteringNoSupplier": "Ingen Leverandør",
      "filteringBySupplier": "Leverandør: {{name}}",
      "clearFilters": "Ryd Filtre",
      "withFiltersApplied": "med filtre anvendt"
    },
    "multiSelect": {
      "enableMultiSelect": "Multi-Vælg",
      "exitMultiSelect": "Afslut Multi-Vælg",
      "deleteSelected": "Slet Valgte",
      "deleting": "Sletter..."
    },
    "form": {
      "productNamePlaceholder": "Produktnavn",
      "unitPlaceholder": "Enhed",
      "pricePlaceholder": "Pris",
      "selectSupplier": "Vælg leverandør",
      "noSupplier": "Ingen leverandør",
      "addProduct": "Tilføj Produkt",
      "adding": "Tilføjer..."
    },
    "notice": {
      "title": "Bemærk:",
      "cannotDeleteInUse": "Produkter der bruges i aktive jobs kan ikke slettes.",
      "removeFromJobsFirst": "Du skal først fjerne produktet fra alle jobs før det kan slettes fra lageret.",
      "useFilterToShowUnused": "Brug filteret ovenfor for at vise kun ubrugte produkter der er sikre at slette."
    },
    "table": {
      "headers": {
        "productName": "Produktnavn",
        "unit": "Enhed",
        "price": "Pris",
        "supplier": "Leverandør",
        "status": "Status",
        "actions": "Handlinger"
      },
      "status": {
        "inUse": "I Brug",
        "available": "Tilgængelig",
        "unknown": "Ukendt"
      },
      "noSupplier": "Ingen leverandør"
    },
    "emptyStates": {
      "noProductsFoundSearch": "Ingen produkter fundet der matcher \"{{searchTerm}}\"",
      "tryDifferentKeywords": "Prøv at søge med andre nøgleord eller ryd søgningen",
      "noUnusedProducts": "Ingen ubrugte produkter fundet",
      "allProductsInUse": "Alle produkter bruges i øjeblikket i aktive jobs",
      "noProducts": "Ingen produkter fundet",
      "addFirstProduct": "Start med at tilføje dit første produkt ved hjælp af formularen ovenfor"
    },
    "actions": {
      "edit": "Rediger",
      "delete": "Slet",
      "deleting": "Sletter...",
      "save": "Gem",
      "cancel": "Annuller",
      "update": "Opdater",
      "updating": "Opdaterer..."
    },
    "confirmations": {
      "deleteProduct": "Er du sikker på, at du vil slette dette produkt?",
      "deleteMultipleProducts": "Er du sikker på, at du vil slette de valgte produkter?"
    },
    "toastMessages": {
      "productAdded": "Produkt tilføjet succesfuldt",
      "productUpdated": "Produkt opdateret succesfuldt",
      "productDeleted": "Produkt slettet succesfuldt",
      "addProductFailed": "Kunne ikke tilføje produkt: {{error}}",
      "updateProductFailed": "Kunne ikke opdatere produkt: {{error}}",
      "deleteProductFailed": "Kunne ikke slette produkt: {{error}}",
      "checkConsoleForDetails": "Tjek venligst konsollen for detaljer.",
      "fillAllFields": "Udfyld venligst alle felter",
      "cannotDeleteProductInUse": "Dette produkt kan ikke slettes, fordi det bruges i et eller flere jobs. Fjern det venligst fra alle jobs før sletning.",
      "cannotDeleteProductUsedInJobs": "Kan ikke slette \"{{productName}}\", fordi det bruges i jobs. Tjek hvor det bruges.",
      "bulkDeleteSuccess": "Succesfuldt slettet {{count}} produkt(er)",
      "partialBulkDeleteSuccess": "Succesfuldt slettet {{count}} ud af {{total}} produkt(er)",
      "cannotDeleteProductsInUse": "Kan ikke slette produkter der er i brug",
      "bulkDeleteFailed": "Kunne ikke slette nogle produkter",
      "bulkDeleteError": "Der opstod en fejl under masse-sletning"
    }
  },
  "suppliers": {
    "pageTitle": "Leverandører",
    "pageDescription": "Administrer dine leverandører og leverandørforhold",
    "loadingSuppliers": "Indlæser leverandører...",
    "failedToLoadSuppliers": "Kunne ikke indlæse leverandørdata",
    "retry": "Prøv igen",
    "searchSuppliers": "Søg leverandører...",
    "addSupplier": "Tilføj Leverandør",
    "addNewSupplier": "Tilføj Ny Leverandør",
    "editSupplier": "Rediger Leverandør",
    "updateSupplier": "Opdater Leverandør",
    "deleteSupplier": "Slet Leverandør",
    "supplierName": "Leverandørnavn",
    "supplierNameRequired": "Leverandørnavn er påkrævet",
    "companyName": "Firmanavn",
    "contactPerson": "Kontaktperson",
    "contactName": "Kontaktnavn",
    "email": "E-mail",
    "emailPlaceholder": "kontakt@leverandør.dk",
    "phoneNumber": "Telefonnummer",
    "phonePlaceholder": "+45 12 34 56 78",
    "website": "Hjemmeside",
    "websitePlaceholder": "www.leverandør.dk",
    "address": "Adresse",
    "addressPlaceholder": "Gadeadresse, by",
    "notes": "Noter",
    "notesPlaceholder": "Yderligere noter om denne leverandør...",
    "cancel": "Annuller",
    "adding": "Tilføjer...",
    "supplier": "Leverandør",
    "contact": "Kontakt",
    "phone": "Telefon",
    "actions": "Handlinger",
    "suppliersCount": "Leverandører ({{count}})",
    "noSuppliersFound": "Ingen leverandører fundet der matcher \"{{searchTerm}}\"",
    "tryDifferentKeywords": "Prøv at søge med andre nøgleord eller ryd søgningen",
    "noSuppliers": "Ingen leverandører fundet",
    "addFirstSupplier": "Start med at tilføje din første leverandør ved hjælp af knappen ovenfor",
    "supplierAddedSuccessfully": "Leverandør tilføjet succesfuldt",
    "supplierUpdatedSuccessfully": "Leverandør opdateret succesfuldt",
    "supplierDeletedSuccessfully": "Leverandør slettet succesfuldt",
    "failedToAddSupplier": "Kunne ikke tilføje leverandør",
    "failedToUpdateSupplier": "Kunne ikke opdatere leverandør",
    "failedToDeleteSupplier": "Kunne ikke slette leverandør",
    "cannotDeleteSupplierWithInventory": "Kan ikke slette leverandør med tilknyttede lagervarer",
    "selectMultiple": "Vælg Flere",
    "exitSelectMode": "Afslut Vælgemodus",
    "noSuppliersSelected": "Ingen leverandører valgt",
    "confirmDeleteMultiple": "Er du sikker på, at du vil slette {{count}} leverandører?",
    "suppliersDeletedSuccessfully": "{{count}} leverandører slettet succesfuldt",
    "someSuppliersDeletionFailed": "{{count}} leverandørsletninger mislykkedes",
    "failedToDeleteSuppliers": "Kunne ikke slette leverandører"
  },
  "timeRegistration": {
    "title": "Tidsregistrering",
    "description": "Administrer dine arbejdstimer og fremmøde",
    "pageDescription": "Log og spor arbejdstimer for medarbejdere og projekter.",
    "status": {
      "active": "Aktiv",
      "live": "Live"
    },
    "sections": {
      "manualEntry": "Manuel indtastning",
      "manualTimeEntry": "Manuel tidsindtastning",
      "clockInOut": "Ind/Ud stempling",
      "calendarView": "Kalendervisning",
      "quickStats": "Hurtige statistikker",
      "weeklySummary": "Ugeoversigt",
      "weekLookup": "Ugeopslag"
    },
    "badges": {
      "quickAdd": "Hurtig tilføjelse",
      "live": "Live",
      "overview": "Oversigt"
    },
    "loading": {
      "date": "Indlæser dato...",
      "time": "Indlæser tid..."
    },
    "error": {
      "message": "Fejl: "
    },
    "overview": {
      "title": "Tidsoversigt",
      "yearPlaceholder": "År",
      "weekPlaceholder": "Uge",
      "weekLabel": "Uge {{week}}",
      "tabs": {
        "daily": "Daglig",
        "weekly": "Ugentlig",
        "monthly": "Månedlig"
      },
      "timeLabels": {
        "hoursToday": "timer i dag",
        "hoursThisWeek": "timer denne uge",
        "hoursThisMonth": "timer denne måned"
      }
    },
    "userFilter": {
      "loading": "Indlæser...",
      "filterByUser": "Filtrer efter bruger",
      "allUsers": "Alle Brugere"
    },
    "entryMode": {
      "singleDay": "Enkelt Dag",
      "dateRange": "Datointerval"
    },
    "dateRange": {
      "startDate": "Startdato",
      "endDate": "Slutdato",
      "selectedDates": "Valgte Datoer ({{count}} dage):",
      "moreLabel": "+{{count}} flere..."
    },
    "manualEntry": {
      "entryMode": "Indtastnings tilstand",
      "date": "Dato",
      "type": "Type",
      "holidayDetails": "+ Ferie detaljer",
      "holidayType": "Ferie type",
      "start": "Start",
      "end": "Slut",
      "duration": "Varighed:",
      "daysMultiplier": "dage ×",
      "total": "total",
      "saving": "Gemmer...",
      "save": "Gem",
      "entries": "Indtastninger",
      "entry": "Indtastning",
      "errors": {
        "endTimeAfterStart": "Sluttidspunkt skal være efter starttidspunkt",
        "selectHolidayType": "Vælg venligst en ferie type",
        "cannotAddFutureWork": "Kan ikke tilføje arbejdsindtastninger i fremtiden ({{date}})",
        "failedToSave": "Kunne ikke gemme tidsindtastninger"
      },
      "success": {
        "multipleEntriesSaved": "{{count}} tidsindtastninger gemt med succes!",
        "entrySaved": "Tidsindtastning gemt med succes!",
        "entrySubmitted": "Tidsindtastning for {{workType}} sendt til godkendelse"
      }
    },
    "weeklySummary": {
      "thisWeek": "Denne Uge",
      "lastWeek": "Sidste Uge",
      "current": "Nuværende",
      "previous": "Forrige",
      "workTypes": {
        "work": "Arbejde",
        "sick": "Syg",
        "holiday": "Ferie"
      },
      "progressTo40h": "Fremskridt til 40t",
      "trends": {
        "upFromLastWeek": "Op fra sidste uge",
        "downFromLastWeek": "Ned fra sidste uge",
        "sameAsLastWeek": "Samme som sidste uge"
      }
    },
    "weekLookup": {
      "selectDate": "Vælg en dato",
      "currentWeek": "Nuværende Uge",
      "workTypes": {
        "work": "Arbejde",
        "sick": "Syg",
        "holiday": "Ferie",
        "total": "Total"
      },
      "stats": {
        "days": "Dage",
        "avg": "Gns"
      },
      "noData": {
        "title": "Ingen Data",
        "message": "Ingen indtastninger denne uge"
      },
      "dailyHours": "Daglige Timer",
      "noWorkingDays": "Ingen arbejdsdage"
    },
    "quickStats": {
      "today": "I dag",
      "thisWeek": "Denne uge",
      "thisMonth": "Denne måned",
      "overtime": "Overtid",
      "complete": "Fuldført",
      "remaining": "tilbage",
      "targetReached": "Mål nået",
      "toTarget": "til mål",
      "avg": "Gennemsnit"
    },
    "clock": {
      "loading": "Indlæser...",
      "working": "Arbejder",
      "elapsed": "forløbet",
      "clockOut": "Stem Ud",
      "clockIn": "Stem Ind",
      "success": {
        "clockedIn": "Succesfuldt stemplet ind!",
        "clockedOut": "Succesfuldt stemplet ud!"
      },
      "errors": {
        "clockOutFailed": "Kunne ikke stemple ud. Prøv igen."
      }
    },
    "recentEntries": {
      "title": "Seneste indtastninger",
      "today": "I dag",
      "yesterday": "I går",
      "noEntries": "Ingen tidsregistreringer endnu",
      "noEntriesDescription": "Begynd at registrere din tid for at se indtastninger her",
      "confirmDelete": "Er du sikker på, at du vil slette denne indtastning?",
      "deleteSuccess": "Indtastning slettet",
      "deleteError": "Kunne ikke slette indtastning",
      "type": "Type",
      "status": "Status",
      "holidayType": "Ferietype"
    },
    "insights": {
      "title": "Produktivitetsindsigt",
      "workStreak": "Arbejds-stribe",
      "daysLabel": "dage",
      "avgDaily": "Gns. daglig",
      "efficiency": "Effektivitet",
      "bestDay": "Bedste dag",
      "weeklyTrend": "Ugentlig tendens",
      "steady": "Stabil",
      "totalDaysWorked": "Samlet arbejdsdage",
      "streakMessages": {
        "startStreak": "Start din stribe i dag!",
        "building": "Opbygger momentum!",
        "keepGoing": "Bliv ved!",
        "onFire": "Du er på 🔥!",
        "unstoppable": "Ustoppelig! 🚀"
      },
      "days": {
        "sunday": "Søndag",
        "monday": "Mandag",
        "tuesday": "Tirsdag",
        "wednesday": "Onsdag",
        "thursday": "Torsdag",
        "friday": "Fredag",
        "saturday": "Lørdag"
      }
    },
    "quickActions": {
      "keyboardShortcuts": "Tastaturgenveje",
      "clockInOut": "Stem ind/ud",
      "manualEntry": "Manuel indtastning",
      "showShortcuts": "Vis genveje",
      "addEntry": "Tilføj indtastning",
      "viewCalendar": "Vis kalender"
    },
    "progressRing": {
      "readyToStart": "Klar til at starte",
      "todayProgress": "Dagens fremskridt",
      "extra": "ekstra",
      "messages": {
        "overtime": "Godt arbejde! Tag snart en pause",
        "complete": "Mål nået! 🎉",
        "almostThere": "Næsten der!",
        "halfwayThere": "Halvvejs!",
        "goodStart": "God start!",
        "justStarted": "Lige begyndt",
        "readyToStart": "Klar til at starte din dag?"
      }
    }
  },
  "map": {
    "filterByDate": "Filtrer efter dato",
    "from": "Fra",
    "to": "Til",
    "clearFilters": "Ryd filtre",
    "jobLocations": "Job lokationer",
    "mapView": "Kortvisning",
    "show": "Vis",
    "map": "Kort",
    "list": "Liste",
    "noLocationsMatch": "Ingen lokationer matcher dine filterkriterier",
    "start": "Start",
    "noStartDate": "Ingen startdato"
  },
  "agreements": {
    "daily": "Dagligt",
    "weekly": "Ugentligt",
    "biweekly": "Hver anden uge",
    "monthly": "Månedligt",
    "quarterly": "Kvartalsvis",
    "annually": "Årligt",
    "service": "Service",
    "installation": "Installation",
    "callOut": "Udkald",
    "low": "Lav",
    "medium": "Medium",
    "high": "Høj",
    "assigned": "Tildelt",
    "unassigned": "Ikke tildelt",
    "noAgreementsToday": "Ingen tilbagevendende serviceaftaler planlagt for i dag",
    "noAgreementsTomorrow": "Ingen tilbagevendende serviceaftaler planlagt for i morgen",
    "allClearToday": "Alt klaret for i dag!",
    "allClearTomorrow": "Intet planlagt til i morgen",
    "noAgreementsTodayDesc": "Ingen tilbagevendende serviceaftaler planlagt for i dag.",
    "noAgreementsTomorrowDesc": "Ingen tilbagevendende serviceaftaler planlagt for i morgen.",
    "viewAllJobs": "Se Alle Jobs",
    "allServiceAgreements": "Alle serviceaftaler",
    "myServiceAgreements": "Mine serviceaftaler",
    "my": "Mine",
    "all": "Alle",
    "today": "I dag",
    "tomorrow": "I morgen",
    "from": "Fra",
    "until": "Indtil"
  },
  "materials": {
    "loading": "Indlæser materialer...",
    "loadingDescription": "Vent venligst mens vi henter de seneste materialer",
    "noMaterials": "Ingen materialer tilføjet endnu",
    "noMaterialsDescription": "Klik \"Tilføj Materiale\" for at spore materialer til dette job",
    "updatingMaterials": "Opdaterer materialer...",
    "materialName": "Materialenavn",
    "fromInventoryNote": "Fra lager - navn kan ikke ændres",
    "quantity": "Mængde",
    "pricePerUnit": "Pris per Enhed (DKK)",
    "setInInventory": "Indstillet i lager",
    "description": "Beskrivelse",
    "totalCost": "Samlet Pris",
    "currency": "DKK",
    "cancel": "Annuller",
    "save": "Gem",
    "saving": "Gemmer...",
    "fromInventory": "Fra Lager",
    "qty": "Antal",
    "unitPrice": "Enhedspris",
    "total": "Total",
    "editMaterial": "Rediger materiale",
    "removeMaterial": "Fjern materiale fra job (vil forblive i eksisterende fakturaer)",
    "materialCost": "Materialeomkostning",
    "totalMaterialsCost": "Samlede Materialeomkostninger",
    "nameRequired": "Materialenavn er påkrævet",
    "validQuantityRequired": "Gyldig mængde er påkrævet",
    "validPriceRequired": "Gyldig pris er påkrævet",
    "updatedSuccessfully": "Materiale opdateret succesfuldt",
    "updateFailed": "Kunne ikke opdatere materiale",
    "materialNotFound": "Materiale ikke fundet",
    "removedFromJob": "Materiale fjernet fra job og returneret til lager (bevaret i eksisterende fakturaer)",
    "deleteFailed": "Kunne ikke slette materiale"
  },
  "billingTab": {
    "title": "Fakturering & Lageropload",
    "description": "Upload CSV-filer eller scan billeder for at tilføje lagervarer til din organisation og automatisk tilføje dem som materialer til dette job",
    "downloadTemplate": "Download Skabelon",
    "csvUploadTitle": "Upload Lager CSV",
    "csvUploadDescription": "Upload en CSV-fil med kolonner: produktnavn, enhed, pris, mængde. Varer vil blive tilføjet til dit lager og automatisk inkluderet som materialer til dette job. Eksisterende varer med samme navn vil blive sprunget over.",
    "defaultSupplier": "Standard Leverandør (Valgfrit)",
    "selectSupplier": "Vælg leverandør (valgfrit)",
    "noSupplier": "Ingen Leverandør",
    "supplierNote": "Denne leverandør vil blive tildelt varer uden en leverandør specificeret i CSV'en",
    "selectCsvFile": "Vælg CSV Fil",
    "csvFormatTitle": "CSV Format Krav:",
    "csvFormat": {
      "headers": "Første række skal indeholde overskrifter: produktnavn, enhed, pris, mængde",
      "productName": "produktnavn: Navn på produktet/materialet",
      "unit": "enhed: Måleenhed (f.eks. styk, gallon, meter, kasse)",
      "price": "pris: Pris per enhed (numerisk værdi)",
      "amount": "mængde: Kvantitet/mængde af varen (numerisk værdi)",
      "autoAdd": "Varer vil blive tilføjet til lager og job materialer automatisk",
      "ignored": "Yderligere kolonner vil blive ignoreret"
    },
    "preview": "Forhåndsvisning ({{count}} varer)",
    "productName": "Produktnavn",
    "unit": "Enhed",
    "price": "Pris",
    "amount": "Mængde",
    "supplier": "Leverandør",
    "moreItems": "... og {{count}} flere varer",
    "uploadToInventory": "Upload til Lager",
    "uploading": "Uploader...",
    "uploadCompleted": "Upload Fuldført Succesfuldt!",
    "itemsProcessed": "Varer behandlet: {{count}}",
    "itemsSkipped": "Varer sprunget over (eksisterer allerede): {{count}}",
    "itemsWithErrors": "Varer med fejl: {{count}}",
    "uploadErrors": "Upload Fejl:",
    "aiTitle": "AI-Drevet Fakturaanalyse",
    "aiDescription": "Upload et billede af en faktura, kvittering eller materialeliste, og vores AI vil automatisk udtrække lagervarer. Varer vil blive tilføjet til dit lager og automatisk inkluderet som materialer til dette job. AI'en analyserer billedet for at identificere produktnavne, enheder, priser og mængder med høj nøjagtighed.",
    "businessRequired": "Forretningslicens Påkrævet",
    "businessLicenseRequired": "Forretningslicens Påkrævet",
    "businessLicenseDescription": "AI-Drevet Fakturaanalyse er en avanceret funktion, der udelukkende er tilgængelig for indehavere af Forretningslicens. Opgrader din licens for at låse op for:",
    "features": {
      "aiScanning": "AI Fakturas-scanning - Automatisk data udtrækning fra billeder",
      "geminiAi": "Google Gemini 2.0 Flash - Nyeste AI teknologi for høj nøjagtighed",
      "editableResults": "Redigerbare Resultater - Gennemgå og modificer AI-udtrukkede data før upload",
      "autoIntegration": "Automatisk Integration - Sømløs tilføjelse til lager og job materialer"
    },
    "currentLicense": "Nuværende Licens: {{license}} Licens",
    "upgradeNote": "Opgrader til Forretning for AI funktioner",
    "supplierForScanned": "Standard Leverandør for Scannede Varer (Valgfrit)",
    "supplierForScannedNote": "Denne leverandør vil blive tildelt alle scannede varer",
    "selectImageFile": "Vælg Billedfil",
    "aiTips": "AI Analyse Tips for Bedste Resultater:",
    "aiTipsContent": {
      "clearImages": "Brug klare, højopløsningsbilleder for bedre AI nøjagtighed",
      "readableText": "Sørg for at tekst er læselig og godt belyst (undgå skygger eller reflekser)",
      "supportedFormats": "Understøttede formater: JPEG, PNG, WebP (maks 10MB)",
      "bestWith": "Fungerer bedst med fakturaer, kvitteringer, indkøbsordrer eller materialelister",
      "variousLayouts": "AI kan håndtere forskellige layouts og formater automatisk",
      "reviewData": "Gennemgå altid udtrukkede data før upload - AI er meget nøjagtig men ikke perfekt"
    },
    "selectedImage": "Valgt Billede: {{name}}",
    "imageSize": "Størrelse: {{size}} MB",
    "imageType": "Type: {{type}}",
    "analyzeWithAi": "Analyser med AI",
    "aiAnalyzing": "AI Analyserer Billede...",
    "clear": "Ryd",
    "aiExtracted": "AI Udtrukkede Varer ({{count}} fundet)",
    "reviewEdit": "Gennemgå og Rediger:",
    "reviewEditDescription": "AI'en har udtruket følgende varer fra dit billede. Du kan redigere eventuelle værdier før du tilføjer dem til dit lager. Klik på hvilket som helst felt for at ændre det.",
    "productNamePlaceholder": "Produktnavn",
    "unitPlaceholder": "Enhed",
    "pricePlaceholder": "0.00",
    "amountPlaceholder": "0",
    "remove": "Fjern",
    "itemsReady": "{{count}} varer klar til upload",
    "addToInventory": "Tilføj til Lager & Job Materialer",
    "scanningErrors": "Scanning Fejl:",
    "howItWorks": "Sådan Fungerer Det",
    "csvMethod": "CSV Upload Metode",
    "csvSteps": {
      "download": "Download Skabelon",
      "downloadDesc": "Få CSV skabelonen med det korrekte format og eksempeldata.",
      "fill": "Udfyld Dine Data",
      "fillDesc": "Tilføj dine lagervarer efter produktnavn, enhed, pris, mængde formatet.",
      "upload": "Upload & Behandl",
      "uploadDesc": "Upload filen og systemet vil tilføje varer til dit lager automatisk."
    },
    "aiMethod": "AI-Drevet Billedanalyse",
    "aiSteps": {
      "uploadImage": "Upload Billede",
      "uploadImageDesc": "Vælg et klart billede af en faktura, kvittering eller materialeliste (JPEG, PNG, WebP).",
      "aiAnalysis": "AI Analyse",
      "aiAnalysisDesc": "Flash AI analyserer intelligent billedet og udtrækker produktdetaljer med høj nøjagtighed.",
      "editConfirm": "Rediger & Bekræft",
      "editConfirmDesc": "Gennemgå og rediger udtrukkede data, tilføj derefter varer til dit lager og job materialer automatisk."
    }
  },
  "calendar": {
    "title": "Kalender",
    "today": "I dag",
    "previous": "Forrige",
    "next": "Næste",
    "month": "Måned",
    "week": "Uge",
    "day": "Dag",
    "agenda": "Dagsorden",
    "allDay": "Hele dagen",
    "noEventsInRange": "Ingen arbejdsposter planlagt for denne tidsperiode.",
    "filters": "Filtre",
    "teamMember": "Teammedlem",
    "selectTeamMember": "Vælg teammedlem",
    "allTeamMembers": "Alle teammedlemmer",
    "activeJob": "Aktivt job",
    "selectJob": "Vælg job",
    "allJobs": "Alle job",
    "statistics": "Statistikker",
    "entries": "poster",
    "users": "brugere",
    "quickView": "Hurtig visning",
    "entryTypes": "Post typer",
    "work": "Arbejde",
    "holiday": "Ferie",
    "overtime": "Overarbejde",
    "transportation": "Transport",
    "tasks": "Opgaver",
    "exportToGoogleCalendar": "Eksporter til Google Kalender",
    "exportCalendar": "Eksporter kalender",
    "weekNumber": "Uge {{number}}",
    "noUsersAvailable": "Ingen brugere tilgængelige",
    "unnamedUser": "(Unavngivet bruger)",
    "unassigned": "Ikke tildelt",
    "manageWorkEntriesAndSchedules": "Administrer arbejdsposter og spor team tidsplaner",
    "refresh": "Opdater",
    "teamCalendar": "Team Kalender",
    "fetchingData": "Henter dine arbejdsposter og tidsplan data..."
  },
  "createJob": {
    "title": "Opret Nyt Job",
    "jobTitle": "Job Titel",
    "jobTitlePlaceholder": "Indtast job titel",
    "jobTitleRequired": "Venligst indtast en job titel",
    "cancel": "Annuller",
    "createJob": "Opret Job",
    "creating": "Opretter...",
    "successMessage": "Job oprettet med succes",
    "errorMessage": "Kunne ikke oprette job"
  }
};
